/* Ink Invaders. Von Striga Tattoo Studio, Galveston, Texas.
   Characters and bosses drawn by CK (@cktattoo). Built from the approved prototype for the arcade theme.
   The pixel world behind every page; playable on the homepage and on the shop's arcade machine (/pages/arcade). */
(function () {
  'use strict';
  /* ================= art: shared by the game and the character lineup sheet ================= */
  // The characters and bosses are CK's own drawings (his two SVG sheets), cut
  // out and packed into one picture, the atlas. The helpers below draw the
  // sky, clouds, effects and the 3x5 pixel font.
  var INK = '#140a0e';
  var RP = {
    red: ['#4a0c16', '#8e1a2c', '#d7263d', '#ff6b6b', '#ffb8b8'],
    bone: ['#6b5a3a', '#a8936a', '#d9c49a', '#f4ead6', '#ffffff'],
    green: ['#0f3a1e', '#1f6b34', '#3fa34d', '#7fd06a', '#c8f5a8'],
    blue: ['#0c1f4a', '#17407f', '#2b6cc4', '#5fa3ef', '#b4dcff'],
    steel: ['#1c2028', '#3a414d', '#6b7482', '#a3acb8', '#e1e6ee'],
    gold: ['#5a3a08', '#9a6a14', '#d6a02a', '#f5c542', '#ffe9a0'],
    orange: ['#5a1f06', '#a8420e', '#e8701e', '#ffa04a', '#ffd7a0'],
    purple: ['#24104a', '#4b2a86', '#7b4bd0', '#b08aff', '#e2d2ff'],
    brown: ['#24140a', '#4a2c14', '#7a4a22', '#a8743c', '#d8a870'],
    black: ['#0a0a10', '#1c1c26', '#30303e', '#4a4a5e', '#7a7a94'],
    pink: ['#5a1038', '#a8326a', '#e8609a', '#ff9fc8', '#ffd8ea'],
    cyan: ['#06303a', '#0e6a7a', '#22a8bf', '#6fdcef', '#c2f6ff'],
    teal: ['#063a34', '#0e6a5e', '#1fa892', '#5fdcc4', '#c2fff2'],
    yellow: ['#5a4a06', '#a8900e', '#e8cc1e', '#ffe84a', '#fff7b0'],
    skin: ['#5a2e18', '#9a5a34', '#d6905c', '#f2be8c', '#ffe2c4'],
    ghost: ['#04140f', '#0a2a22', '#124a3a', '#1f7a5a', '#2fff9a'],
    olive: ['#1c260a', '#34461a', '#506a26', '#748e3a', '#a8c060']
  };
  function pal() { var out = [INK, '#ffffff']; for (var i = 0; i < arguments.length; i++) out = out.concat(RP[arguments[i]]); return out; }
  function hex2rgb(h) { var n = parseInt(h.slice(1), 16); return [(n >> 16) & 255, (n >> 8) & 255, n & 255]; }
  function pixelize(w, h, draw, palette, outline) {
    var c = document.createElement('canvas'); c.width = w; c.height = h;
    var x = c.getContext('2d');
    draw(x, w, h);
    var img = x.getImageData(0, 0, w, h), d = img.data;
    var palRgb = palette.map(hex2rgb);
    var solid = new Uint8Array(w * h);
    for (var i = 0; i < w * h; i++) {
      var a = d[i * 4 + 3];
      if (a < 110) { d[i * 4 + 3] = 0; continue; }
      var r = d[i * 4], g = d[i * 4 + 1], b = d[i * 4 + 2], best = 0, bd = 1e9;
      for (var p = 0; p < palRgb.length; p++) { var dr = r - palRgb[p][0], dg = g - palRgb[p][1], db = b - palRgb[p][2], dd = dr * dr * 0.3 + dg * dg * 0.59 + db * db * 0.11; if (dd < bd) { bd = dd; best = p; } }
      d[i * 4] = palRgb[best][0]; d[i * 4 + 1] = palRgb[best][1]; d[i * 4 + 2] = palRgb[best][2]; d[i * 4 + 3] = 255; solid[i] = 1;
    }
    if (outline !== false) {
      var ink = hex2rgb(typeof outline === 'string' ? outline : INK);
      for (var y = 0; y < h; y++) for (var xx = 0; xx < w; xx++) {
        var k = y * w + xx;
        if (solid[k]) continue;
        if ((xx > 0 && solid[k - 1]) || (xx < w - 1 && solid[k + 1]) || (y > 0 && solid[k - w]) || (y < h - 1 && solid[k + w])) {
          d[k * 4] = ink[0]; d[k * 4 + 1] = ink[1]; d[k * 4 + 2] = ink[2]; d[k * 4 + 3] = 255;
        }
      }
    }
    x.putImageData(img, 0, 0);
    return c;
  }
  function flatCopy(src, color) {
    var c = document.createElement('canvas'); c.width = src.width; c.height = src.height;
    var x = c.getContext('2d'); x.drawImage(src, 0, 0);
    x.globalCompositeOperation = 'source-in'; x.fillStyle = color; x.fillRect(0, 0, c.width, c.height);
    if (src.gw) { c.gw = src.gw; c.gh = src.gh; }
    return c;
  }
  function flipX(src) {
    var c = document.createElement('canvas'); c.width = src.width; c.height = src.height;
    var x = c.getContext('2d'); x.translate(src.width, 0); x.scale(-1, 1); x.drawImage(src, 0, 0);
    if (src.gw) { c.gw = src.gw; c.gh = src.gh; }
    return c;
  }
  // shape helpers (a color can be a gradient)
  function E(x, c, cx, cy, rx, ry, rot) { x.fillStyle = c; x.beginPath(); x.ellipse(cx, cy, Math.max(0.5, rx), Math.max(0.5, ry), rot || 0, 0, Math.PI * 2); x.fill(); }
  function PG(x, c, pts) { x.fillStyle = c; x.beginPath(); x.moveTo(pts[0], pts[1]); for (var i = 2; i < pts.length; i += 2) x.lineTo(pts[i], pts[i + 1]); x.closePath(); x.fill(); }
  function LN(x, c, pts, lw) { x.strokeStyle = c; x.lineWidth = lw || 1.4; x.lineCap = 'round'; x.lineJoin = 'round'; x.beginPath(); x.moveTo(pts[0], pts[1]); for (var i = 2; i < pts.length; i += 2) x.lineTo(pts[i], pts[i + 1]); x.stroke(); }
  function RC(x, c, a, b, w, h) { x.fillStyle = c; x.fillRect(a, b, w, h); }
  function RR(x, c, a, b, w, h, r) { x.fillStyle = c; x.beginPath(); x.moveTo(a + r, b); x.arcTo(a + w, b, a + w, b + h, r); x.arcTo(a + w, b + h, a, b + h, r); x.arcTo(a, b + h, a, b, r); x.arcTo(a, b, a + w, b, r); x.closePath(); x.fill(); }
  function LG(x, x0, y0, x1, y1, stops) { var g = x.createLinearGradient(x0, y0, x1, y1); for (var i = 0; i < stops.length; i++) g.addColorStop(i / (stops.length - 1), stops[i]); return g; }
  function RG(x, cx, cy, r, stops, fx, fy) { var g = x.createRadialGradient(fx == null ? cx : fx, fy == null ? cy : fy, 0, cx, cy, r); for (var i = 0; i < stops.length; i++) g.addColorStop(i / (stops.length - 1), stops[i]); return g; }

  /* ================= 3x5 bitmap font ================= */
  var GLYPH = {
    A:'010101111101101',B:'110101110101110',C:'011100100100011',D:'110101101101110',E:'111100110100111',F:'111100110100100',
    G:'011100101101011',H:'101101111101101',I:'111010010010111',J:'001001001101010',K:'101101110101101',L:'100100100100111',
    M:'101111111101101',N:'110101101101101',O:'010101101101010',P:'110101110100100',Q:'010101101110011',R:'110101110101101',
    S:'011100010001110',T:'111010010010010',U:'101101101101111',V:'101101101101010',W:'101101111111101',X:'101101010101101',
    Y:'101101010010010',Z:'111001010100111','0':'111101101101111','1':'010110010010111','2':'110001010100111',
    '3':'110001010001110','4':'101101111001001','5':'111100110001110','6':'011100111101111','7':'111001010010010',
    '8':'111101111101111','9':'111101111001110',' ':'000000000000000','-':'000000111000000','+':'000010111010000',
    '!':'010010010000010','.':'000000000000010',':':'000010000010000',"'":'010010000000000','/':'001001010100100',
    '?':'110001010000010'
  };
  // M and W need five columns to read as M and W (three columns made TWIN read as THIN)
  var GLYPH5 = { M: '1000111011101011000110001', W: '1000110001101011101110001' };
  function textWidth(str, s) {
    s = s || 1; str = String(str).toUpperCase();
    var n = 0;
    for (var i = 0; i < str.length; i++) n += (GLYPH5[str[i]] ? 5 : 3) + 1;
    return Math.max(0, n - 1) * s;
  }
  function drawText(ctx, str, x, y, color, s, align) {
    s = s || 1; str = String(str).toUpperCase();
    if (align === 'center') x = Math.round(x - textWidth(str, s) / 2);
    else if (align === 'right') x = Math.round(x - textWidth(str, s));
    ctx.fillStyle = color;
    for (var i = 0; i < str.length; i++) {
      var wide = GLYPH5[str[i]], g = wide || GLYPH[str[i]] || GLYPH[' '], gw = wide ? 5 : 3;
      for (var p = 0; p < gw * 5; p++) if (g.charCodeAt(p) === 49) ctx.fillRect(x + (p % gw) * s, y + ((p / gw) | 0) * s, s, s);
      x += (gw + 1) * s;
    }
  }


  /* ================= CK's sprites ================= */
  // Each sprite is stored at ART_A detail pixels per game pixel and remembers
  // its size in game pixels (gw by gh), which is the size it is drawn at.
  var ART_A = 2;
  var ATLAS_SRC = (window.VS_GAME && window.VS_GAME.atlas) || '';
  var ATLAS_RECTS = {"boss_ship":[0,0,215,256],"boss_palms":[217,0,168,230],"boss_turtle":[387,0,227,200],"boss_shrimp":[616,0,200,196],"boss_crab":[0,258,248,185],"boss_shark":[250,258,248,185],"boss_gull":[500,258,200,184],"boss_gator":[702,258,256,183],"machine":[960,258,33,56],"sacred":[995,258,28,42],"eagle":[0,445,44,40],"snake":[46,445,35,39],"dagger":[83,445,31,37],"rose":[116,445,30,36],"anchor":[148,445,28,36],"panther":[178,445,42,36],"swallow":[222,445,39,35],"star":[263,445,34,34],"twinIcon":[299,445,46,34],"gull":[347,445,36,34],"pirateB":[385,445,22,32],"skull":[409,445,28,31],"butterfly":[439,445,37,29],"babyShark":[478,445,36,29],"coconut":[516,445,20,28],"pirateA":[538,445,19,28],"pirateC":[559,445,18,28],"cap_fan":[579,445,55,28],"cap_rapid":[636,445,55,28],"cap_laser":[693,445,55,28],"cap_beads":[750,445,55,28],"cap_twin":[807,445,55,28],"cap_b409":[864,445,55,28],"cap_ibc":[921,445,55,28],"cap_boi":[0,487,55,28],"cap_life":[57,487,55,28],"heart":[114,487,30,27],"wire":[146,487,32,25],"bottle":[180,487,44,22],"feather":[226,487,14,21],"infinity":[242,487,34,18],"mini":[278,487,18,17],"bubble":[298,487,16,16],"cannonball":[316,487,14,14]};
  function gsz(c) { c.gw = c.width / ART_A; c.gh = c.height / ART_A; return c; }
  function atlasSprite(img, key) {
    var r = ATLAS_RECTS[key]; if (!r) return null;
    var c = document.createElement('canvas'); c.width = r[2]; c.height = r[3];
    c.getContext('2d').drawImage(img, r[0], r[1], r[2], r[3], 0, 0, r[2], r[3]);
    return gsz(c);
  }
  // draw a sprite centered on (cx, cy) at its game size, snapped to its detail grid
  function blit(ctx, img, cx, cy, scale) {
    var k = scale || 1, w = (img.gw || img.width) * k, h = (img.gh || img.height) * k;
    ctx.drawImage(img, Math.round((cx - w / 2) * ART_A) / ART_A, Math.round((cy - h / 2) * ART_A) / ART_A, w, h);
  }

  /* ================= "bad tattoo" version of any clean sprite ================= */
  // Wonky angle, faded muddy color, ink blowout around the lines and color
  // outside the lines. Seeded, so each character always looks the same.
  // amt 1 is the full bad tattoo; amt 0.5 is the "brighter" stage after one hit:
  // the same crooked angle cut in half, color mostly back, a little blowout.
  function badify(src, seed, amt) {
    amt = amt == null ? 1 : amt;
    var pad = 3, w = src.width + pad * 2, h = src.height + pad * 2;
    var t = document.createElement('canvas'); t.width = w; t.height = h;
    var tx = t.getContext('2d'); tx.imageSmoothingEnabled = false;
    function rnd() { seed = (seed * 9301 + 49297) % 233280; return seed / 233280; }
    var ang = (rnd() < 0.5 ? -1 : 1) * (0.1 + rnd() * 0.07), shear = (rnd() - 0.5) * 0.3, mud = amt >= 1 ? 1 : 0.28;
    tx.translate(w / 2, h / 2); tx.rotate(ang * amt); tx.transform(1, 0, shear * amt, 1, 0, 0);
    tx.drawImage(src, -src.width / 2, -src.height / 2);
    tx.setTransform(1, 0, 0, 1, 0, 0);
    var img = tx.getImageData(0, 0, w, h), d = img.data, n = w * h;
    var orig = new Uint8ClampedArray(d);
    function isInk(arr, i) { return arr[i * 4 + 3] >= 128 && arr[i * 4] + arr[i * 4 + 1] + arr[i * 4 + 2] < 150; }
    for (var i = 0; i < n; i++) {
      if (orig[i * 4 + 3] < 128) { d[i * 4 + 3] = 0; continue; }
      d[i * 4 + 3] = 255;
      if (isInk(orig, i)) continue;
      var r = orig[i * 4], g = orig[i * 4 + 1], b = orig[i * 4 + 2], l = (r + g + b) / 3;
      d[i * 4] = Math.round(r + (((r * 0.6 + l * 0.4) * 0.82 + 106 * 0.18) - r) * mud);
      d[i * 4 + 1] = Math.round(g + (((g * 0.6 + l * 0.4) * 0.82 + 90 * 0.18) - g) * mud);
      d[i * 4 + 2] = Math.round(b + (((b * 0.6 + l * 0.4) * 0.82 + 74 * 0.18) - b) * mud);
    }
    // two passes of blowout so it still reads at two detail pixels per game pixel
    for (var pass = 0; pass < (amt >= 1 ? 2 : 1); pass++) {
      var cur = new Uint8ClampedArray(d), pInk = (pass ? 0.16 : 0.32) * (amt >= 1 ? 1 : 0.5), pCol = (pass ? 0.06 : 0.16) * (amt >= 1 ? 1 : 0.4);
      for (var y = 1; y < h - 1; y++) for (var x = 1; x < w - 1; x++) {
        var k = y * w + x;
        if (cur[k * 4 + 3] >= 128) continue;
        var nb = [k - 1, k + 1, k - w, k + w];
        for (var q = 0; q < 4; q++) {
          var m = nb[q];
          if (cur[m * 4 + 3] < 128) continue;
          var roll = rnd();
          if (isInk(cur, m) && roll < pInk) { d[k * 4] = 58; d[k * 4 + 1] = 47; d[k * 4 + 2] = 70; d[k * 4 + 3] = 255; break; }
          if (!isInk(cur, m) && roll < pCol) { d[k * 4] = cur[m * 4]; d[k * 4 + 1] = cur[m * 4 + 1]; d[k * 4 + 2] = cur[m * 4 + 2]; d[k * 4 + 3] = 255; break; }
        }
      }
    }
    tx.putImageData(img, 0, 0);
    return gsz(t);
  }

  /* ================= the cast ================= */
  var INVADER_KEYS = ['rose', 'skull', 'swallow', 'anchor', 'infinity', 'wire', 'butterfly', 'dagger', 'panther', 'snake', 'sacred', 'eagle', 'bottle', 'star'];
  var CHAR_NAMES = {
    rose: 'ROSE', skull: 'SKULL', swallow: 'SWALLOW', anchor: 'ANCHOR', infinity: 'INFINITY',
    wire: 'BARBED WIRE', butterfly: 'BUTTERFLY', dagger: 'DAGGER', panther: 'PANTHER', snake: 'SNAKE', sacred: 'SACRED HEART',
    eagle: 'EAGLE', bottle: 'SHIP IN A BOTTLE', star: 'NAUTICAL STAR', machine: 'TATTOO MACHINE (YOU)', twinIcon: 'TWIN MACHINES',
    gull: 'SEAGULL', feather: 'FEATHER', bubble: 'BUBBLE', babyShark: 'BABY SHARK', coconut: 'COCONUT BOMB',
    pirateA: 'PIRATE', pirateB: 'PIRATE CAPTAIN', pirateC: 'CABIN BOY', cannonball: 'CANNONBALL'
  };
  var OTHER_KEYS = ['machine', 'twinIcon', 'gull', 'feather', 'bubble', 'babyShark', 'coconut', 'pirateA', 'pirateB', 'pirateC', 'cannonball'];
  var CAP_KEYS = ['fan', 'rapid', 'laser', 'beads', 'twin', 'b409', 'ibc', 'boi', 'life'];
  var CAP_NAMES = { fan: 'FAN SHOT', rapid: 'RAPID FIRE', laser: 'NEEDLE LASER', beads: 'MARDI GRAS BEADS', twin: 'TWIN MACHINES', b409: '409 BOMB', ibc: 'IBC BOMB', boi: 'BOI BOMB', life: 'EXTRA LIFE' };

  /* ================= bosses ================= */
  // Hit areas are fractions of the boss picture [left, top, right, bottom].
  // 'hit' takes damage, 'armor' bounces shots, 'mouth' swallows them.
  // Pictures that face a way are drawn facing right and flipped when needed.
  var BOSSES = [
    { key: 'gull', name: 'GIANT SEAGULL', faces: 1,
      about: 'Screams, swoops back and forth, sprays feathers and dive-bombs your ship. If it touches a falling power-up, it steals it.',
      boxes: [['hit', 0.08, 0.1, 0.9, 0.72]], beak: [0.93, 0.14] },
    { key: 'crab', name: 'GIANT BLUE CRAB', faces: 0,
      about: 'Scuttles side to side blowing bubbles. Its shell, legs and claws are armor: hit it right in the face. Watch for the red warning before it lunges.',
      boxes: [['hit', 0.37, 0.42, 0.63, 0.8], ['armor', 0.17, 0.36, 0.37, 0.66], ['armor', 0.63, 0.36, 0.83, 0.66], ['armor', 0.0, 0.55, 0.37, 1.0], ['armor', 0.63, 0.55, 1.0, 1.0], ['armor', 0.1, 0.0, 0.42, 0.42], ['armor', 0.58, 0.0, 0.9, 0.42]], mouth: [0.5, 0.56] },
    { key: 'shrimp', name: 'MUTANT SHRIMP', faces: 1,
      about: 'Fires bursts of ink at you, then curls into a spinning ball that bounces around shooting rings of ink.',
      boxes: [['hit', 0.05, 0.28, 0.8, 0.98]], head: [0.64, 0.38] },
    { key: 'turtle', name: 'MUTANT SEA TURTLE', faces: 1,
      about: 'The spiked shell is armor. Hit the head and flippers. It fires three shots at a time and spins down at you shell first.',
      boxes: [['hit', 0.72, 0.18, 0.99, 0.5], ['hit', 0.0, 0.58, 0.34, 0.95], ['hit', 0.32, 0.56, 0.62, 1.0], ['hit', 0.82, 0.48, 1.0, 0.9], ['armor', 0.04, 0.0, 0.74, 0.62]], head: [0.92, 0.36] },
    { key: 'shark', name: 'GREAT GULF SHARK', faces: 1,
      about: 'Circles as a fin you cannot hit while baby sharks attack, then leaps across the sky spitting teeth. Hit it while it is in the air.',
      boxes: [['hit', 0.08, 0.1, 0.95, 0.85]], fin: [0.322, 0.0, 0.513, 0.206], jaw: [0.86, 0.6] },
    { key: 'gator', name: 'BAYOU ALLIGATOR', faces: 1,
      about: 'When its mouth glows it swallows your shots and spits them back at you. Its tail sweeps half the beach: get to the other side.',
      boxes: [['hit', 0.0, 0.3, 0.72, 0.9], ['jaw', 0.72, 0.2, 1.0, 0.68]], mouth: [0.85, 0.47] },
    { key: 'palms', name: 'ALIEN PALM TREES', faces: 0,
      about: 'Two alien palms on one island. Their glowing coconut eyes are the weak spots: put each one out. They lob coconut bombs and beam up your twin.',
      crowns: [[0.14, 0.06, 0.56, 0.36], [0.5, 0.38, 0.84, 0.62]], eyes: [[0.22, 0.12, 0.47, 0.32], [0.55, 0.42, 0.74, 0.58]],
      trunks: [[0.3, 0.36, 0.48, 0.9], [0.55, 0.62, 0.7, 0.9]], beam: [0.33, 0.64] },
    { key: 'ship', name: "JEAN LAFITTE'S GHOST SHIP", faces: 0,
      about: 'Knock down all three sails first, then sink the hull. Its cannons fire in rows and pirates swing down on ropes.',
      sails: [[0.06, 0.16, 0.36, 0.6], [0.33, 0.0, 0.6, 0.42], [0.56, 0.16, 0.9, 0.56]], hull: [0.04, 0.58, 0.98, 0.86], ports: [0.2, 0.86, 0.72] }
  ];
  function rectOf(c, f) { return [Math.round(f[0] * c.width), Math.round(f[1] * c.height), Math.round((f[2] - f[0]) * c.width), Math.round((f[3] - f[1]) * c.height)]; }
  // the palm boss with some coconut eyes put out (mask bit set = that palm still alive)
  function palmVariant(src, def, mask) {
    var c = document.createElement('canvas'); c.width = src.width; c.height = src.height;
    var x = c.getContext('2d'); x.drawImage(src, 0, 0);
    def.eyes.forEach(function (f, k) {
      if (mask & (1 << k)) return;
      var r = rectOf(c, f), img = x.getImageData(r[0], r[1], r[2], r[3]), d = img.data;
      for (var i = 0; i < d.length; i += 4) {
        var R2 = d[i], G2 = d[i + 1], B2 = d[i + 2];
        if (d[i + 3] && G2 > 150 && G2 > R2 + 50 && G2 > B2 + 30) { var l = (R2 + G2 + B2) / 3; d[i] = 30 + l * 0.22; d[i + 1] = 22 + l * 0.16; d[i + 2] = 16 + l * 0.12; }
      }
      x.putImageData(img, r[0], r[1]);
    });
    return gsz(c);
  }
  // the ghost ship with some sails shot to rags (mask bit set = that sail still up)
  function shipVariant(src, def, mask) {
    var c = document.createElement('canvas'); c.width = src.width; c.height = src.height;
    var x = c.getContext('2d'); x.drawImage(src, 0, 0);
    def.sails.forEach(function (f, k) {
      if (mask & (1 << k)) return;
      var r = rectOf(c, f), seed = 31 + k * 97;
      function rnd() { seed = (seed * 9301 + 49297) % 233280; return seed / 233280; }
      x.save(); x.beginPath(); x.rect(r[0], r[1], r[2], r[3]); x.clip();
      x.globalCompositeOperation = 'source-atop'; x.fillStyle = 'rgba(10,8,6,0.45)'; x.fillRect(r[0], r[1], r[2], r[3]);
      x.globalCompositeOperation = 'destination-out';
      for (var n = 0; n < 26; n++) { x.beginPath(); x.arc(r[0] + rnd() * r[2], r[1] + rnd() * r[3], 2 + rnd() * r[2] * 0.14, 0, Math.PI * 2); x.fill(); }
      x.restore();
    });
    return gsz(c);
  }

  /* ================= build everything from the atlas ================= */
  var SPRITES = {};
  function buildArt(img) {
    var seed = 17;
    INVADER_KEYS.concat(OTHER_KEYS).forEach(function (k) {
      var clean = atlasSprite(img, k); if (!clean) return;
      var isInv = INVADER_KEYS.indexOf(k) !== -1;
      var sd = seed + k.length * 31;
      SPRITES[k] = { clean: [clean], bad: [isInv ? badify(clean, sd, 1) : clean], mid: [isInv ? badify(clean, sd, 0.5) : clean], flash: [flatCopy(clean, '#ffffff')], name: CHAR_NAMES[k] || k.toUpperCase() };
      seed += 7;
    });
    SPRITES.capsules = {};
    CAP_KEYS.forEach(function (k) { SPRITES.capsules[k] = atlasSprite(img, 'cap_' + k); });
    BOSSES.forEach(function (b) {
      var c = atlasSprite(img, 'boss_' + b.key);
      b.img = c; b.flash = flatCopy(c, '#ffffff'); b.imgL = flipX(c); b.flashL = flipX(b.flash);
      b.w = c.gw; b.h = c.gh;
      if (b.key === 'palms' || b.key === 'ship') {
        b.vars = []; b.varsFlash = [];
        var n = b.key === 'palms' ? 4 : 8;
        for (var m = 0; m < n; m++) { var v = b.key === 'palms' ? palmVariant(c, b, m) : shipVariant(c, b, m); b.vars.push(v); b.varsFlash.push(flatCopy(v, '#ffffff')); }
      }
    });
  }
  function loadArt(done) {
    var img = new Image();
    img.onload = function () { buildArt(img); done(); };
    img.onerror = function () { done(new Error('art did not load')); };
    img.crossOrigin = 'anonymous';
    img.src = ATLAS_SRC;
  }

  /* ================= settings ================= */
  var root = document.documentElement;
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var OPTS = { layout: ['full', 'top'], palette: ['sunset', 'neon', 'dark'], fonts: ['arcade', 'clean', 'soft'], fx: ['low', 'med', 'high'], practice: ['off', 'on'] };
  var settings = { layout: 'full', palette: 'sunset', fonts: 'arcade', fx: reduceMotion ? 'low' : 'med', practice: 'off', sound: false, buzz: true, mute: false, musicVol: 0.6, sfxVol: 0.8 };
  function store(k, v) { try { localStorage.setItem('inkinv.' + k, JSON.stringify(v)); } catch (e) {} }
  function load(k) { try { var s = localStorage.getItem('inkinv.' + k); return s == null ? null : JSON.parse(s); } catch (e) { return null; } }
  (function () {
    var saved = load('settings');
    if (saved && typeof saved === 'object') {
      Object.keys(OPTS).forEach(function (k) { if (OPTS[k].indexOf(saved[k]) !== -1) settings[k] = saved[k]; });
      if (typeof saved.sound === 'boolean') settings.sound = saved.sound;
      if (typeof saved.buzz === 'boolean') settings.buzz = saved.buzz;
      if (typeof saved.mute === 'boolean') settings.mute = saved.mute;
      if (typeof saved.musicVol === 'number' && saved.musicVol >= 0 && saved.musicVol <= 1) settings.musicVol = saved.musicVol;
      if (typeof saved.sfxVol === 'number' && saved.sfxVol >= 0 && saved.sfxVol <= 1) settings.sfxVol = saved.sfxVol;
    }
    settings.layout = 'full'; settings.palette = 'sunset'; settings.fonts = 'arcade'; settings.practice = 'off';
  })();
  var VS_MODE = (window.VS_GAME && window.VS_GAME.mode) === 'ambient' ? 'ambient' : (window.VS_GAME && window.VS_GAME.mode) === 'cabinet' ? 'cabinet' : 'play';
  var VS_AMBIENT = VS_MODE === 'ambient';
  var VS_CABINET = VS_MODE === 'cabinet';   // the arcade machine in the shop (/pages/arcade)
  var STAND_INS = {};
  var $ = function (id) {
    var el = document.getElementById(id);
    if (el) return el;
    if (!STAND_INS[id]) STAND_INS[id] = document.createElement(/canvas|^game$/i.test(id) ? 'canvas' : 'div');
    return STAND_INS[id];
  };
  var soundBtn = $('soundBtn'), buzzBtn = $('buzzBtn'), pauseBtn = $('pauseBtn');
  function applySettings() {
    Object.keys(OPTS).forEach(function (k) { root.setAttribute('data-' + k, settings[k]); });
    document.querySelectorAll('.seg[data-opt]').forEach(function (seg) {
      var k = seg.getAttribute('data-opt');
      seg.querySelectorAll('button').forEach(function (b) { b.setAttribute('aria-pressed', String(b.getAttribute('data-v') === settings[k])); });
    });
    soundBtn.setAttribute('aria-pressed', String(settings.sound));
    soundBtn.setAttribute('aria-label', settings.sound ? 'Sound is on. Turn sound off' : 'Sound is off. Turn sound on');
    buzzBtn.setAttribute('aria-pressed', String(settings.buzz));
    buzzBtn.setAttribute('aria-label', settings.buzz ? 'Vibration is on. Turn vibration off' : 'Vibration is off. Turn vibration on');
    store('settings', settings);
    if (sfxBus) sfxBus.gain.value = settings.sfxVol;
    musicSync();
  }

  /* ================= small helpers ================= */
  var YEAR = new Date().getFullYear();
  document.querySelectorAll('.year').forEach(function (el) { el.textContent = YEAR; });
  var AWARD_YEARS = [2018, 2019, 2020, 2021, 2022, 2023, 2024, 2025];
  (function buildTicker() {
    var one = '<span>VOTED BEST OF GALVESTON' + AWARD_YEARS.map(function (y) { return '<b>' + y + '</b>'; }).join('') + '</span>';
    $('tickerTrack').innerHTML = one + one;
  })();
  function logoFallback(img, wrap, word) {
    if (!img) return;   // the arcade page has no top bar
    function fail() { if (wrap) wrap.classList.add('no-img'); if (word) { img.hidden = true; word.hidden = false; } }
    img.addEventListener('error', fail);
    if (img.complete && img.naturalWidth === 0) fail();
  }
  logoFallback($('topLogo').querySelector('img'), $('topLogo'));
  logoFallback($('bootLogo'), null, $('bootWord'));
  function clamp(v, a, b) { return v < a ? a : v > b ? b : v; }
  function pad(n, w) { n = String(Math.max(0, Math.floor(n))); while (n.length < w) n = '0' + n; return n; }
  function seeded(seed) { return function () { seed = (seed * 9301 + 49297) % 233280; return seed / 233280; }; }

  /* ================= haptics ================= */
  var canVibrate = typeof navigator.vibrate === 'function';
  var isIOS = /iP(hone|ad|od)/.test(navigator.userAgent) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
  function iosTick() {
    // iPhone (iOS 18+) gives a light tick when a switch control is toggled
    // by a real tap. Only works inside a tap handler.
    try {
      var label = document.createElement('label');
      label.setAttribute('aria-hidden', 'true');
      label.style.display = 'none';
      var input = document.createElement('input');
      input.type = 'checkbox';
      input.setAttribute('switch', '');
      label.appendChild(input);
      document.head.appendChild(label);
      label.click();
      document.head.removeChild(label);
    } catch (e) {}
  }
  function buzz(pattern, fromTap) {
    if (!settings.buzz) return;
    if (canVibrate) { try { navigator.vibrate(pattern); } catch (e) {} }
    else if (fromTap && isIOS) iosTick();
  }

  /* ================= sound (made in code, no files) ================= */
  var actx = null, noiseBuf = null;
  function audio() {
    if (!settings.sound) return null;
    if (!actx) {
      var AC = window.AudioContext || window.webkitAudioContext;
      if (!AC) return null;
      try { actx = new AC(); } catch (e) { return null; }
      noiseBuf = actx.createBuffer(1, actx.sampleRate * 1.2, actx.sampleRate);
      var d = noiseBuf.getChannelData(0);
      for (var i = 0; i < d.length; i++) d[i] = Math.random() * 2 - 1;
    }
    if (actx.state === 'suspended') { try { actx.resume(); } catch (e) {} }
    return actx;
  }
  // effects and music each have their own volume (the volume panel on the site, the setup screen on the arcade machine)
  var sfxBus = null;
  function sfxOut(a) {
    if (!sfxBus) { sfxBus = a.createGain(); sfxBus.connect(a.destination); }
    sfxBus.gain.value = settings.sfxVol;
    return sfxBus;
  }

  /* ================= music: the Ink Invaders theme =================
     One song on a loop (a theme file, VS_GAME.music). On the site it starts with TAP TO PLAY;
     on the arcade machine it plays on the start screen. It starts over at the start of every
     game, and otherwise keeps looping. It only loads once the sound is on. */
  var MUSIC_SRC = (window.VS_GAME && window.VS_GAME.music) || '';
  var musicEl = null, musicGain = null, musicOn = false;
  function musicSetup() {
    if (musicEl || !MUSIC_SRC) return musicEl;
    try {
      musicEl = new Audio();
      musicEl.crossOrigin = 'anonymous';
      musicEl.loop = true;
      musicEl.preload = 'auto';
      musicEl.src = MUSIC_SRC;
    } catch (e) { musicEl = null; return null; }
    var a = audio();
    if (a && a.createMediaElementSource) {
      try { musicGain = a.createGain(); a.createMediaElementSource(musicEl).connect(musicGain); musicGain.connect(a.destination); }
      catch (e) { musicGain = null; }
    }
    musicLevel();
    return musicEl;
  }
  function musicLevel() {
    var v = settings.sound ? settings.musicVol : 0;
    if (musicGain) musicGain.gain.value = v;
    else if (musicEl) { try { musicEl.volume = v; } catch (e) {} }
  }
  function musicAllowed() {
    if (!settings.sound || !musicOn || document.hidden) return false;
    if (VS_CABINET) return true;
    return !G.ambientOnly && !G.userPaused && !consentWait;
  }
  function musicSync() {
    if (!musicEl) return;
    musicLevel();
    if (musicAllowed()) { if (musicEl.paused) { try { var p = musicEl.play(); if (p && p.catch) p.catch(function () {}); } catch (e) {} } }
    else if (!musicEl.paused) { try { musicEl.pause(); } catch (e) {} }
  }
  function musicStart() { if (!settings.sound || !musicSetup()) return; musicOn = true; musicSync(); }
  function musicRestart() {
    if (!settings.sound || !musicSetup()) return;
    musicOn = true;
    try { musicEl.currentTime = 0; } catch (e) {}
    musicSync();
  }
  function tone(type, f0, f1, dur, vol, when) {
    var a = audio(); if (!a) return;
    var t = a.currentTime + (when || 0);
    var o = a.createOscillator(), g = a.createGain();
    o.type = type; o.frequency.setValueAtTime(f0, t); o.frequency.exponentialRampToValueAtTime(Math.max(30, f1), t + dur);
    g.gain.setValueAtTime(vol, t); g.gain.exponentialRampToValueAtTime(0.0001, t + dur);
    o.connect(g); g.connect(sfxOut(a)); o.start(t); o.stop(t + dur + 0.02);
  }
  function noise(dur, vol, freq, when) {
    var a = audio(); if (!a) return;
    var t = a.currentTime + (when || 0);
    var s = a.createBufferSource(); s.buffer = noiseBuf; s.loop = true;
    var f = a.createBiquadFilter(); f.type = 'bandpass'; f.frequency.value = freq || 700; f.Q.value = 0.8;
    var g = a.createGain(); g.gain.setValueAtTime(vol, t); g.gain.exponentialRampToValueAtTime(0.0001, t + dur);
    s.connect(f); f.connect(g); g.connect(sfxOut(a)); s.start(t); s.stop(t + dur);
  }
  var SFX = {
    shot: function () { tone('square', 1300, 260, 0.06, 0.03); },
    laser: function () { tone('sawtooth', 2200, 700, 0.06, 0.028); },
    pop: function () { noise(0.18, 0.12, 900); tone('square', 420, 90, 0.12, 0.03); },
    hit: function () { tone('square', 220, 440, 0.06, 0.04); },
    tink: function () { tone('triangle', 2400, 1800, 0.05, 0.03); },
    die: function () { noise(0.6, 0.18, 300); tone('sawtooth', 500, 40, 0.7, 0.05); },
    gull: function () { tone('sine', 1700, 2500, 0.08, 0.05); tone('sine', 1900, 2700, 0.08, 0.05, 0.12); },
    clear: function () { [523, 659, 784, 1046].forEach(function (f, i) { tone('square', f, f, 0.09, 0.04, i * 0.09); }); },
    start: function () { [392, 523, 659, 523, 784].forEach(function (f, i) { tone('square', f, f, 0.08, 0.035, i * 0.085); }); },
    tick: function () { tone('square', 700, 700, 0.03, 0.025); },
    power: function () { [659, 880, 1175, 1568, 2093].forEach(function (f, i) { tone('square', f, f * 1.02, 0.06, 0.04, i * 0.05); }); },
    bomb: function () { noise(1.0, 0.28, 160); tone('sawtooth', 160, 30, 0.9, 0.07); tone('square', 900, 60, 0.5, 0.03); },
    block: function () { tone('square', 300, 900, 0.12, 0.04); noise(0.15, 0.08, 2000); },
    combo: function (n) { tone('square', 500 + n * 90, 700 + n * 90, 0.05, 0.03); },
    siren: function () { for (var i = 0; i < 4; i++) { tone('square', 520, 880, 0.25, 0.035, i * 0.5); tone('square', 880, 520, 0.25, 0.035, i * 0.5 + 0.25); } },
    // thunder with every lightning flash: a crack, then a rolling rumble, pitched so phone speakers carry it
    thunder: function (delay) { var d = delay || 0; noise(0.22, 0.26, 2400, d); noise(0.7, 0.26, 900, d + 0.04); noise(1.8, 0.36, 320, d + 0.1); noise(2.4, 0.3, 150, d + 0.3); noise(1.3, 0.16, 520, d + 0.9); },
    wave: function () { noise(1.2, 0.18, 500); tone('sine', 120, 60, 1.1, 0.05); },
    bossDie: function () { for (var i = 0; i < 6; i++) noise(0.4, 0.2, 200 + i * 150, i * 0.25); tone('sawtooth', 300, 30, 1.8, 0.06); },
    coin: function (k) { if (k === 'chest') { [523, 784, 1046].forEach(function (f, i) { tone('square', f, f, 0.08, 0.035, i * 0.06); }); } else tone('square', k === 'gem' ? 1318 : 988, k === 'gem' ? 1760 : 1568, 0.07, 0.03); }
  };

  /* ================= art ================= */
  // CK's sprites come from the atlas picture; the game starts once it has loaded (see start)
  var TIP_DX = 0;
  function findTip() {
    // where the needle of the tattoo machine is, so shots leave from its tip
    var c = SPRITES.machine.clean[0], d = c.getContext('2d').getImageData(0, 0, c.width, 4).data, sum = 0, n = 0;
    for (var i = 0; i < c.width * 4; i++) if (d[i * 4 + 3] > 0) { sum += i % c.width; n++; }
    TIP_DX = n ? (sum / n + 0.5 - c.width / 2) / ART_A : 0;
  }

  // invader stats: points, hits to destroy
  // points for saving it, hits it takes (every tattoo: bad, brighter, clean, saved)
  var KIND = {
    rose: [100, 3], skull: [150, 3], swallow: [80, 3], anchor: [60, 3], infinity: [70, 3],
    wire: [200, 3], butterfly: [90, 3], dagger: [120, 3], panther: [140, 3], snake: [110, 3], sacred: [130, 3],
    eagle: [120, 3], bottle: [160, 3], star: [70, 3], babyShark: [80, 1], pirateA: [100, 1], pirateB: [150, 2], pirateC: [100, 1]
  };
  function isTattoo(kind) { return INVADER_KEYS.indexOf(kind) !== -1; }
  function kindColors(k) {
    var map = { rose: ['#d7263d', '#3fa34d'], skull: ['#f4ead6', '#d9c49a'], swallow: ['#2b6cc4', '#b4dcff'],
      anchor: ['#a3acb8', '#f5c542'], infinity: ['#f5c542', '#ffe9a0'], wire: ['#a3acb8', '#e1e6ee'], butterfly: ['#b08aff', '#ffa04a'], dagger: ['#e1e6ee', '#f5c542'],
      panther: ['#4a4a5e', '#f5c542'], snake: ['#3fa34d', '#ffe84a'], sacred: ['#d7263d', '#ffa04a'], eagle: ['#7a4a22', '#f4ead6'], bottle: ['#6fdcef', '#f4ead6'],
      star: ['#2b6cc4', '#d7263d'], babyShark: ['#5fa3ef', '#f4ead6'], pirateA: ['#d7263d', '#f2be8c'], pirateB: ['#30303e', '#d7263d'], pirateC: ['#2b6cc4', '#f2be8c'] };
    return map[k] || ['#ffffff', '#ffd166'];
  }

  /* ================= palettes for the game world (darker, so play stands out) ================= */
  var PAL = {
    sunset: { sky: ['#08061a', '#0d0a26', '#130d31', '#1b0f3a', '#271241', '#351446', '#461749', '#5a1d49', '#702546', '#863440', '#97463b'],
      sun: ['#e8c862', '#e8a04a', '#d8723c', '#c24c48', '#a3305a'], sil: '#120820', sea: ['#1a1233', '#141c3a', '#0f243c', '#0b2c3a', '#083036'],
      crest: '#5aa8a0', glint: '#c98a3c', sand: '#a8874f', sand2: '#8a6c3c', palm: '#0c0614', star: '#e8e0c8', grid: null, cloud: '#3a1440', onSand: '#1d1d1c', catOnSand: '#7a0f1f',
      logoCloud: { shadow: '#2e1238', body: '#481a4c', light: '#62265a', ink: '#d9b6aa', inkHi: '#f4dccc', alpha: 0.82 } },
    neon: { sky: ['#030009', '#070116', '#0c0222', '#13042e', '#1e0640', '#2e084e', '#400a58', '#580c5e', '#761260', '#962060', '#b23a62'],
      sun: ['#e8dc52', '#e8aa38', '#e07a36', '#e0467c', '#d02a8c'], sil: '#060010', sea: ['#070016', '#070016', '#070016', '#070016', '#070016'],
      crest: '#00b8cc', glint: '#c82e8c', sand: '#1f0834', sand2: '#2c0c48', palm: '#030008', star: '#d8ecf8', grid: '#b0287a', cloud: '#26063e', onSand: '#fbe9ff', catOnSand: '#ff5a9a',
      logoCloud: { shadow: '#1c0430', body: '#2e0a4a', light: '#46126a', ink: '#e8b8de', inkHi: '#ffffff', alpha: 0.82 } },
    dark: { sky: ['#0e0e0d', '#111110', '#131312', '#161614', '#191917', '#1c1c19', '#20201c', '#25241e', '#2c2a20', '#343022', '#3c3624'],
      sun: ['#c4b474', '#b4965a', '#a07240', '#844e30', '#643026'], sil: '#0a0a09', sea: ['#141a18', '#131e1b', '#12221d', '#11261f', '#102920'],
      crest: '#4e7c42', glint: '#b4965a', sand: '#6a5e46', sand2: '#564c38', palm: '#080807', star: '#cfcfc6', grid: null, cloud: '#1e1e1b', onSand: '#e8e8e0', catOnSand: '#ffb08a',
      logoCloud: { shadow: '#171715', body: '#1f1f1c', light: '#2a2a26', ink: '#b8b8b0', inkHi: '#e0e0d8', alpha: 0.82 } }
  };
  var STORM_CLOUD = { shadow: '#14141e', body: '#22222e', light: '#30303e', ink: '#6a6a7e', inkHi: '#8a8aa0' };
  var LIT_CLOUD = { shadow: '#6a6aa0', body: '#9a9ac8', light: '#c8c8f0', ink: '#ffffff', inkHi: '#ffffff' };
  var FX = { low: { stars: 30, shake: 0 }, med: { stars: 70, shake: 1 }, high: { stars: 130, shake: 2 } };

  /* ================= power-ups ================= */
  var POWER = {
    fan:    { label: 'FAN SHOT', color: '#5fa3ef', time: 21, short: 'FAN' },
    rapid:  { label: 'RAPID FIRE', color: '#ff6b6b', time: 18, short: 'RAPID' },
    laser:  { label: 'NEEDLE LASER', color: '#7fd06a', time: 15, short: 'LASER' },
    beads:  { label: 'MARDI GRAS BEADS', color: '#b08aff', time: 20, short: 'BEADS' },
    twin:   { label: 'TWIN MACHINES', color: '#ffa04a', time: 24, short: 'TWIN' },
    b409:   { label: '409 BOMB', color: '#ffe84a', time: 0 },
    ibc:    { label: 'IBC BOMB', sub: 'ISLANDER BY CHOICE', color: '#5fa3ef', time: 0 },
    boi:    { label: 'BOI BOMB', sub: 'BORN ON THE ISLAND', color: '#ff9fc8', time: 0 },
    life:   { label: 'EXTRA LIFE', color: '#5fdcc4', time: 0 }
  };
  var DROPS = [['fan', 28], ['rapid', 20], ['laser', 15], ['beads', 13], ['twin', 10], ['b409', 6], ['ibc', 4], ['boi', 2], ['life', 2]];
  var TWIN_DX = 15;
  var BEADS_HITS = 5;   // Mardi Gras beads stay on until they take 5 hits
  function freshPw() { return { fan: 0, fanT: 0, rapidT: 0, laserT: 0, beadsT: 0, beadsHits: 0, twinT: 0 }; }

  /* ================= game state ================= */
  var canvas = $('game'), ctx = canvas.getContext('2d');
  var world = $('world'), hero = $('hero');
  var bg = document.createElement('canvas'), bgx = bg.getContext('2d');
  var W = 190, H = 220, SCALE = 2, RES = 2, HORIZON = 130, SAND = 207, SHIP_Y = 189, SHIP_TOP = 28;   // the ship flies anywhere between SHIP_TOP and SHIP_Y
  var G = {
    state: 'boot', phase: 'wave', score: 0, hi: 0, lives: 3, level: 1, wave: 1,
    ship: { x: 95, y: 189, alive: true, inv: 0, respawn: 0 },
    shots: [], eshots: [], enemies: [], parts: [], pops: [], rings: [], caps: [], covers: [], bombs: [], seekers: [], tide: null,
    gull: null, stars: [], boss: null, pier: null, cfg: null,
    t: 0, formT: 0, fireCd: 0, diveCd: 3, eshotCd: 2, gullCd: 9, phaseT: 0, shake: 0, flash: 0, skyFlash: 0, muzzle: 0,
    hintT: 7, steered: false, paused: false, userPaused: false, ambientOnly: false, holding: false,
    pw: freshPw(), bag: [], fired: 0, combo: 0, comboT: 0, kills: 0, firstDrop: false, announce: null, banner: null, nextId: 1, wheelParty: 0,
    storm: { cur: 0, mul: 1, bolt: null, nextBolt: 4, rain: [], clouds: [], wind: 0, gustT: 6, splashT: 2 }
  };
  var keys = { left: false, right: false, up: false, down: false };
  var mouseTarget = null, mouseTargetY = null;
  var playingCls = false;   // html.is-playing stops the game window from scrolling the page while you fly

  var API = (window.VS_GAME && window.VS_GAME.api) || 'https://vonstriga-api.vonstrigack.workers.dev';
  var BOARD = [], boardShared = false, gameTicket = null;
  function cleanBoard(list) {
    var out = [];
    (list || []).forEach(function (m) { if (m && typeof m.s === 'number' && isFinite(m.s) && /^[A-Z0-9]{3}$/.test(m.i)) out.push({ s: Math.floor(m.s), i: m.i }); });
    out.sort(function (a, b) { return b.s - a.s; });
    return out.slice(0, 10);
  }
  function sampleBoard() { return boardShared ? BOARD : cleanBoard(load('board')); }
  function refreshBoards(highlight) {
    renderBoard($('pageBoard'), highlight);
    if (VS_CABINET) renderBoard($('attractScores'));
    var top = sampleBoard()[0];
    G.hi = Math.max(G.hi || 0, top ? top.s : 0);
  }
  function fetchBoard() {
    try {
      fetch(API + '/api/public/scores', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (d) { if (d && Array.isArray(d.board)) { BOARD = cleanBoard(d.board); boardShared = true; refreshBoards(); } })
        .catch(function () {});
    } catch (e) {}
  }
  function fetchTicket() {
    gameTicket = null;
    try {
      fetch(API + '/api/public/game/start' + (VS_CABINET ? '?cabinet=1' : ''), { method: 'POST', headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (d) { if (d && typeof d.ticket === 'string') gameTicket = d.ticket; })
        .catch(function () {});
    } catch (e) {}
  }
  function postScore(entry, level) {
    var ticket = gameTicket; gameTicket = null;
    if (!ticket) return;
    try {
      fetch(API + '/api/public/scores', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ ticket: ticket, initials: entry.i, score: entry.s, level: level, cabinet: VS_CABINET || undefined }) })
        .then(function (r) { return r.json().catch(function () { return null; }); })
        .then(function (d) {
          if (d && Array.isArray(d.board)) { BOARD = cleanBoard(d.board); boardShared = true; renderBoard($('overBoard'), entry); refreshBoards(entry); }
          if (d && typeof d.share === 'string' && /^https:\/\/[^\s]+$/.test(d.share)) { G.shareUrl = d.share; if (VS_CABINET) cabinetQr(); }
        })
        .catch(function () {});
    } catch (e) {}
  }
  function ordinal(n) { var s = ['TH', 'ST', 'ND', 'RD']; var v = n % 100; return n + (s[(v - 20) % 10] || s[v] || s[0]); }
  function renderBoard(table, highlight) {
    var list = sampleBoard();
    if (!list.length) {
      table.innerHTML = '<tbody><tr><td class="empty" colspan="3">No scores yet. Be the first on the board!</td></tr></tbody>';
      var lg = table.parentNode && table.parentNode.querySelector('.legend');
      if (lg) lg.textContent = 'ISLAND LEGEND: UP FOR GRABS';
      return;
    }
    var rows = list.map(function (r, n) {
      var me = highlight && r.i === highlight.i && r.s === highlight.s;
      return '<tr' + (me ? ' class="me"' : '') + '><td>' + ordinal(n + 1) + '</td><td>' + r.i + '</td><td>' + pad(r.s, 6) + '</td></tr>';
    });
    table.innerHTML = '<tbody>' + rows.join('') + '</tbody>';
    var legend = table.parentNode && table.parentNode.querySelector('.legend');
    if (legend) legend.textContent = 'ISLAND LEGEND: ' + list[0].i + '  ' + pad(list[0].s, 6);
  }
  G.hi = sampleBoard().length ? sampleBoard()[0].s : 0;
  if (!VS_AMBIENT) fetchBoard();

  /* ================= layout of the playfield ================= */
  function measure() {
    var r = world.getBoundingClientRect();
    var cssW = Math.max(200, r.width), cssH = Math.max(200, r.height);
    var s = clamp(Math.floor(cssH / 170), 2, 4);
    if (cssW / s < 160) s = Math.max(1, Math.floor(cssW / 160));
    // the arcade machine's tall screen: big pixels, the same playfield shape as a phone (about 180 wide)
    if (VS_CABINET) s = Math.max(2, Math.min(Math.floor(cssW / 180), Math.floor(cssH / 300)));
    var nW = Math.ceil(cssW / s), nH = Math.ceil(cssH / s);
    var oW = W, oH = H;
    SCALE = s; W = nW; H = nH;
    // the canvas has one pixel per screen pixel, so CK's art keeps its detail;
    // the game itself still moves on a grid of SCALE screen pixels
    var dpr = VS_CABINET ? 1 : clamp(Math.round(window.devicePixelRatio || 1), 1, 3);
    RES = s * dpr;
    canvas.width = W * RES; canvas.height = H * RES;
    canvas.style.width = (W * s) + 'px'; canvas.style.height = (H * s) + 'px';
    HORIZON = Math.round(H * 0.6);
    SAND = H - 13;
    SHIP_Y = SAND - 18;
    if (oW && oH && (oW !== W || oH !== H)) {
      var fx = W / oW, fy = H / oH;
      G.ship.x *= fx;
      G.ship.y = Math.max(SHIP_TOP, Math.min(SHIP_Y, G.ship.y * fy));
      G.enemies.forEach(function (e) { e.x *= fx; e.y *= fy; });
      G.shots.forEach(function (o) { o.x *= fx; o.y *= fy; });
      G.eshots.forEach(function (o) { o.x *= fx; o.y *= fy; });
      if (G.boss) G.boss.x *= fx;
    }
    makeStars();
    makeStormBits();
    paintBg();
    buildCloud();
    placeBag();
    renderBag();
  }
  function formation() {
    var cols = clamp(Math.floor((W - 26) / 24), 4, 9);
    var cellW = 24, cellH = 21, fw = (cols - 1) * cellW;
    return { cols: cols, cellW: cellW, cellH: cellH, x0: Math.round((W - fw) / 2), y0: 30, room: Math.max(0, (W - fw) / 2 - 14) };
  }
  function slotPos(e) {
    var f = formation();
    var sway = Math.sin(G.formT * 0.8) * Math.min(14, f.room);
    var breathe = Math.sin(G.formT * 1.6) * 1.5;
    return { x: f.x0 + e.c * f.cellW * (1 + breathe * 0.01) + sway, y: f.y0 + e.r * f.cellH };
  }

  /* ================= levels and waves ================= */
  var TIERS = [[1, ['rose', 'swallow', 'star']], [2, ['anchor', 'butterfly']], [3, ['skull', 'infinity', 'dagger']], [5, ['snake', 'eagle', 'sacred']], [6, ['wire', 'panther', 'bottle']]];
  function kindsFor(L) { var out = []; TIERS.forEach(function (t) { if (L >= t[0]) out = out.concat(t[1]); }); return out; }
  // 8 levels across the island, each 3 waves and then a boss. The difficulty steps up a little
  // every level: level 1 is a touch busier than it used to be, level 8 stops short of top speed.
  var LAST_LEVEL = 8;
  function effLevel(L) { return 1 + (clamp(L, 1, LAST_LEVEL) - 1) * 1.5; }
  function waveConfig(L, w) {
    var d = effLevel(L) + (w - 1) * 0.5;
    var rnd = seeded(L * 131 + w * 17);
    var pool = kindsFor(L), rows = clamp(3 + Math.floor((L - 1) / 3), 3, 5);
    if (w === 2) rows = Math.max(2, rows - 1);
    var types = [];
    for (var r = 0; r < rows; r++) types.push(pool[Math.floor(rnd() * pool.length)]);
    if (w === 3 && L >= 3) types[0] = L >= 6 && rnd() < 0.5 ? 'wire' : 'skull';
    var dive = ['sine'];
    if (L >= 2) dive.push('loop');
    if (L >= 3) dive.push('zig');
    return {
      types: types, entry: w === 2 ? 'loop' : (w === 3 && L % 2 === 0 ? 'loop' : 'swoop'),
      diveEvery: Math.max(0.65, 3.0 - d * 0.17) * (w === 2 ? 0.6 : 1), diveSpeed: 50 + d * 5,
      shotEvery: Math.max(0.4, 1.9 - d * 0.1), maxShots: clamp(2 + Math.floor(d / 2), 2, 9),
      diveStyles: dive, escorts: w === 3, spread: L >= 7
    };
  }
  // the boss at the end of each level. The Great Gulf Shark swims along the water before it leaps,
  // so it fights at the Seawall (level 3) and the Mutant Shrimp takes the Strand (level 5).
  var BOSS_ORDER = [0, 1, 4, 3, 2, 5, 6, 7];
  function bossIndexFor(L) { return BOSS_ORDER[(Math.max(1, L) - 1) % 8]; }
  function isBossLevel(L) { return L >= 1; }
  // one stop on the island per level, ending at the shop on 61st Street
  var ZONES = ['CAUSEWAY CALAMITY', 'FERRY FURY', 'SEAWALL SURGE', 'BROADWAY BREACH', 'STRAND STAMPEDE', 'HARBORSIDE HAVOC', 'PLEASURE PIER RUN', '61ST STREET SHOWDOWN'];
  function zoneFor(L) { return ZONES[(Math.max(1, L) - 1) % 8]; }
  // the hurricane: calm for the first three levels, then Category 1 to 5, the Eye of the Storm before the Ghost Ship
  var STORM_BY_LEVEL = [0, 0, 0.2, 0.6, 1.0, 1.5, 2.0, 3.0];
  function stormFor(L) { return STORM_BY_LEVEL[clamp(L, 1, LAST_LEVEL) - 1]; }
  function catFor(s) { return s < 0.24 ? 0 : clamp(Math.ceil(s * 5 / 3), 1, 5); }

  function spawnWave() {
    var cfg = waveConfig(G.level, G.wave), f = formation();
    var maxRows = Math.max(2, Math.floor((SHIP_Y - 62 - f.y0) / f.cellH) + 1);
    if (cfg.types.length > maxRows) cfg.types = cfg.types.slice(0, maxRows);
    G.cfg = cfg;
    G.enemies = G.enemies.filter(function (e) { return e.free && e.mode !== 'dead'; });
    cfg.types.forEach(function (kind, r) {
      for (var c = 0; c < f.cols; c++) {
        var side = (r % 2) ? 1 : -1;
        G.enemies.push({ id: G.nextId++, kind: kind, r: r, c: c, x: side > 0 ? W + 12 : -12, y: -12, mode: 'enter', entry: cfg.entry, t: -(r * 0.45 + c * 0.07), hp: KIND[kind][1], max: KIND[kind][1], flash: 0, side: side, sx: 0, frame: 0 });
      }
    });
    G.diveCd = cfg.diveEvery + 1.2;
    G.eshotCd = 2.2;
  }
  function startLevel(L) {
    G.level = L; G.wave = 1;
    G.storm.target = stormFor(L);
    setScene(L - 1);
    startWave();
  }
  function startWave() {
    G.phase = 'wave';
    spawnWave();
    G.banner = { t: 1.8, a: 'LEVEL ' + G.level, b: zoneFor(G.level), c: 'WAVE ' + G.wave + ' OF 3' };
  }
  function newGame() {
    hideTap(); if (G.userPaused) togglePause();
    G.won = false; G.loot = []; G.treasure = 0;
    G.score = 0; G.lives = 3;
    G.ship = { x: W / 2, y: SHIP_Y, alive: true, inv: 1.5, respawn: 0 };
    G.shots = []; G.eshots = []; G.parts = []; G.pops = []; G.rings = []; G.caps = []; G.covers = []; G.bombs = []; G.seekers = []; G.tide = null;
    G.gull = null; G.gullCd = 9; G.formT = 0; G.boss = null; G.pier = null; G.enemies = []; G.capture = null; G.rescue = null;
    G.pw = freshPw(); G.combo = 0; G.comboT = 0; G.kills = 0; G.firstDrop = false; G.announce = null; G.flash = 0;
    G.bag = []; renderBag();
    G.saved = false; G.shareUrl = '';
    fetchTicket();
    G.state = 'play';
    G.storm.cur = stormFor(1); G.storm.mul = 1;
    startLevel(1);
    SFX.start();
  }

  /* ================= background ================= */
  function makeStars() {
    var n = FX[settings.fx].stars;
    G.stars = [];
    for (var i = 0; i < n; i++) G.stars.push({ x: Math.random() * W | 0, y: Math.random() * HORIZON * 0.78 | 0, p: Math.random() * 6.28, sp: 0.6 + Math.random() * 2.4, big: Math.random() < 0.08 });
  }
  var STORM_SPRITES = [];
  function makeStormBits() {
    STORM_SPRITES = [];
    var rnd = seeded(5);
    for (var i = 0; i < 4; i++) {
      var w = 40 + Math.floor(rnd() * 30), h = 12 + Math.floor(rnd() * 6);
      STORM_SPRITES.push(pixelize(w, h, function (x) {
        for (var k = 0; k < 7; k++) E(x, LG(x, 0, 0, 0, h, ['#3a3a4e', '#22222e', '#14141e']), 6 + k * (w - 12) / 6, h - 5 - rnd() * 4, 5 + rnd() * 5, 4 + rnd() * 3);
      }, ['#3a3a4e', '#22222e', '#14141e', '#4a4a62'], false));
    }
    G.storm.clouds = [];
    for (var c = 0; c < 8; c++) G.storm.clouds.push({ x: rnd() * W, y: 4 + rnd() * HORIZON * 0.45, spr: c % 4, sp: 3 + rnd() * 5 });
    G.storm.rain = [];
    for (var r = 0; r < 140; r++) G.storm.rain.push({ x: rnd() * W, y: rnd() * H, len: 3 + Math.floor(rnd() * 4), sp: 140 + rnd() * 80 });
  }
  function sunGeom() { var r = Math.max(14, Math.min(46, Math.round(Math.min(W, H) * 0.17))); return { cx: Math.round(W * 0.36), cy: HORIZON, r: r }; }
  function wheelGeom() { var R = Math.max(12, Math.min(20, Math.round(H * 0.07))); return { cx: Math.round(W * 0.2), cy: HORIZON - 9 - R, R: R }; }   // the Pleasure Pier's wheel (level 7)
  /* ================= a Galveston scene on the horizon for each level ================= */
  // Drawn from CK's reference photos, once per level, onto its own layer that sits in
  // front of the sun and the logo cloud and behind the play. Each level has its own
  // scene; the Pleasure Pier (with the turning Ferris wheel) is level 7 only.
  var SCENES = ['causeway', 'ferry', 'seawall', 'palace', 'strand', 'cruise', 'pier', 'shop'];
  // the Causeway deck: how high the road is above the water at each point across the screen
  function causewayDeck(xx) {
    var u = xx / W;
    if (u < 0.1) return 3 + Math.round(u / 0.1 * 3);
    if (u < 0.46) { var q = (u - 0.1) / 0.36; return 6 + Math.round(16 * q * q * (3 - 2 * q)); }
    return 22 - Math.round(Math.max(0, u - 0.88) * 30);
  }
  // cars and trucks driving across the Causeway, both ways, drawn every frame
  var TRAFFIC = [[0, 1, 23, 0], [37, 1, 21, 1], [81, 1, 24, 0], [133, 1, 20, 2], [9, -1, 19, 0], [58, -1, 22, 1], [104, -1, 18, 2], [150, -1, 21, 0]];
  function drawTraffic(c) {
    var span = W + 30, cols = ['#120820', '#3a2448', '#2a2238'];
    function col(x, h, c2) { if (x < 0 || x >= W) return; c.fillStyle = c2; c.fillRect(x, HORIZON - h, 1, 1); }
    [-1, 1].forEach(function (lane) {
      TRAFFIC.forEach(function (v) {
        if (v[1] !== lane) return;
        var p = ((v[0] / 170) * span + G.t * v[2]) % span, x0 = Math.round(lane > 0 ? p - 15 : W + 15 - p), truck = v[3] === 2, len = truck ? 10 : 6, up = lane < 0 ? 1 : 0;
        for (var i = 0; i < len; i++) {
          var x = x0 + i, d = causewayDeck(Math.max(0, Math.min(W - 1, x))) + up;
          col(x, d + 2, cols[v[3] % 3]); col(x, d + 3, cols[v[3] % 3]);
          if (i > 0 && i < len - 1 && (!truck || (lane > 0 ? i < 7 : i > 2))) col(x, d + 4, cols[v[3] % 3]);
          if (truck && (lane > 0 ? i < 7 : i > 2)) col(x, d + 5, cols[v[3] % 3]);
        }
        var front = lane > 0 ? x0 + len - 1 : x0, back = lane > 0 ? x0 : x0 + len - 1;
        col(front, causewayDeck(Math.max(0, Math.min(W - 1, front))) + up + 2, '#ffd166');
        col(back, causewayDeck(Math.max(0, Math.min(W - 1, back))) + up + 2, '#ff5a7a');
      });
    });
  }
  /* ================= life on the Seawall beach and the Strand (drawn every frame) ================= */
  // the people running for their lives and the horse and buggy sit on the sprites' detail grid (ART_A per game pixel)
  var LIFE = { runners: [], buggy: null };
  // how high the camera sits, in meters, so the street is about 20 meters wide on a phone or the arcade screen;
  // the wide desktop view gets a lower camera, so the people and the buggy are not lost in it
  function lifeCam() { return clamp(10 * (H - HORIZON) / (0.4 * W), 8, 18); }
  function lifeLine(x0, y0, x1, y1, t, c) {
    var A = ART_A, n = Math.max(1, Math.ceil(Math.max(Math.abs(x1 - x0), Math.abs(y1 - y0)) * A)), o = t / 2;
    ctx.fillStyle = c;
    for (var i = 0; i <= n; i++) ctx.fillRect(Math.round((x0 + (x1 - x0) * i / n) * A - o) / A, Math.round((y0 + (y1 - y0) * i / n) * A - o) / A, t / A, t / A);
  }
  // the Seawall beach: where across the sand (0 the water's edge, 1 the foot of the wall), 1 running away from us
  // or -1 toward us, speed, where in the run they start, 1 arms up in a panic or 0 arms pumping, size (kids are smaller)
  var RUNNERS = [
    [0.45, -1, 0.34, 0.00, 1, 1],
    [0.64, 1, 0.30, 0.41, 0, 1],
    [0.30, -1, 0.40, 0.57, 1, 0.7],
    [0.72, -1, 0.31, 0.23, 0, 1],
    [0.52, 1, 0.36, 0.83, 1, 1],
    [0.38, -1, 0.28, 0.69, 1, 1],
    [0.82, 1, 0.33, 0.13, 1, 0.85],
    [0.58, -1, 0.37, 0.31, 0, 1],
    [0.24, 1, 0.42, 0.92, 1, 0.68]
  ];
  // the people are medium gray (CK), the arm and leg on the far side a shade darker so the stride still reads
  function drawRunner(fx, fy, h, dir, ph, panic) {
    var A = ART_A, dark = '#8c8c8c', back = '#6e6e6e', lw = Math.max(1, Math.round(h * 0.1 * A)), tw = Math.max(1, Math.round(h * 0.17 * A));
    var hipX = fx, hipY = fy - h * 0.5 - Math.abs(Math.sin(ph)) * h * 0.07, shX = hipX + dir * h * 0.09, shY = hipY - h * 0.3;
    function leg(side, c) {
      var th = ph + side * Math.PI, a = 0.75 * Math.sin(th), b = a - (0.2 + 1.3 * Math.max(0, Math.cos(th)));
      var kx = hipX + dir * Math.sin(a) * h * 0.26, ky = hipY + Math.cos(a) * h * 0.26;
      lifeLine(hipX, hipY, kx, ky, lw, c); lifeLine(kx, ky, kx + dir * Math.sin(b) * h * 0.26, ky + Math.cos(b) * h * 0.26, lw, c);
    }
    function arm(side, c) {
      var ex, ey, hx, hy;
      if (panic) {   // both arms up over the head, flailing
        var a = (side ? 0.55 : -0.25) + 0.45 * Math.sin(ph * 1.5 + side * 2.1), a2 = a + 0.5 * Math.sin(ph * 2 + side);
        ex = shX + dir * Math.sin(a) * h * 0.16; ey = shY - Math.cos(a) * h * 0.16;
        hx = ex + dir * Math.sin(a2) * h * 0.15; hy = ey - Math.cos(a2) * h * 0.15;
      } else {       // pumping, opposite to the legs
        var p = -0.9 * Math.sin(ph + side * Math.PI);
        ex = shX + dir * Math.sin(p) * h * 0.15; ey = shY + Math.cos(p) * h * 0.15;
        hx = ex + dir * Math.sin(p + 1.5) * h * 0.14; hy = ey + Math.cos(p + 1.5) * h * 0.14;
      }
      lifeLine(shX, shY, ex, ey, lw, c); lifeLine(ex, ey, hx, hy, lw, c);
    }
    lifeLine(fx - h * 0.2, fy, fx + h * 0.2, fy, 1, '#6e5438');   // the shadow on the sand
    leg(1, back); arm(1, back);
    lifeLine(hipX, hipY, shX, shY, tw, dark);
    var hr = Math.max(1, Math.round(h * 0.18 * A)), hcx = shX + dir * h * 0.05, hcy = shY - h * 0.11;
    ctx.fillStyle = dark; ctx.fillRect(Math.round(hcx * A - hr / 2) / A, Math.round(hcy * A - hr / 2) / A, hr / A, hr / A);
    leg(0, dark); arm(0, dark);
  }
  function drawRunners() {
    var vx = Math.round(W * 0.72), GH = H - HORIZON, kFar = 0.12, kNear = 1.25, span = Math.log(kNear / kFar);
    LIFE.runners = RUNNERS.map(function (r, i) {
      var f = ((r[3] + G.t * r[2] / span) % 1 + 1) % 1;
      return { r: r, i: i, k: Math.exp(r[1] > 0 ? Math.log(kNear) - f * span : Math.log(kFar) + f * span) };
    }).sort(function (a, b) { return a.k - b.k; });
    LIFE.runners.forEach(function (o) {
      var r = o.r, y = HORIZON + o.k * GH, xs = vx + (-W * 0.25 - vx) * o.k, xb = vx + (W * 0.7 - vx) * o.k;
      var u = clamp(r[0] + 0.08 * Math.sin(G.t * 1.7 + o.i * 2.3), 0.1, 0.9), h = Math.max(1.5, o.k * GH * 0.15 * Math.min(1.5, 16 / lifeCam()) * r[5]), x = xs + u * (xb - xs);
      o.x = x; o.y = y; o.h = h;
      if (x < -h || x > W + h || y - h > H) return;
      drawRunner(x, y, h, r[1] > 0 ? 1 : -1, Math.PI * 2 * (G.t * (2.2 + r[2] * 3) + o.i * 0.37), r[4]);
    });
  }
  // the Strand's horse and buggy: a little 3D model made of boxes, drawn in the street's own perspective. It trots
  // away from us up the right side of the street, turns at the far end, comes back down the left side, turns near us.
  var BUGGY = { cv: null, img: null, px: null, zb: null, cols: {} };
  function buggyBoxes(trot, wr, wf) {
    var B = [];   // each box: center (x forward, y up, z across), half sizes, tilt (top toward the front), color
    function box(x, y, z, hx, hy, hz, a, c) { B.push([x, y, z, hx, hy, hz, a, c]); }
    function seg(x, y, z, len, ang, th, c) { box(x + Math.sin(ang) * len / 2, y - Math.cos(ang) * len / 2, z, th, len / 2, th, ang, c); }
    function wheel(x, y, z, r, ang) {
      for (var i = 0; i < 12; i++) { var a = ang + i * Math.PI / 6; box(x + Math.cos(a) * r, y + Math.sin(a) * r, z, 0.05, r * 0.27, 0.045, a, '#d84a4a'); }
      for (var j = 0; j < 4; j++) box(x, y, z, r * 0.95, 0.03, 0.025, ang + j * Math.PI / 4, '#d84a4a');
      box(x, y, z, 0.08, 0.08, 0.07, 0, '#ffd166');
    }
    var WH = '#ece6dc', WH2 = '#cfc6b8', MANE = '#9a90a2', TACK = '#3a2228', DK = '#20141e', bob = 0.035 * Math.abs(Math.sin(trot));
    // the horse
    box(1.55, 1.3 + bob, 0, 0.62, 0.27, 0.24, 0, WH);
    box(2.08, 1.36 + bob, 0, 0.2, 0.26, 0.22, 0, WH);
    box(0.98, 1.37 + bob, 0, 0.2, 0.25, 0.23, 0, WH);
    box(2.36, 1.74 + bob, 0, 0.15, 0.38, 0.12, -0.55, WH);
    box(2.25, 1.81 + bob, 0, 0.05, 0.36, 0.07, -0.55, MANE);
    box(2.73, 1.92 + bob, 0, 0.28, 0.12, 0.11, -0.7, WH);
    box(2.52, 2.2 + bob, 0.06, 0.035, 0.07, 0.03, -0.3, WH); box(2.52, 2.2 + bob, -0.06, 0.035, 0.07, 0.03, -0.3, WH);
    box(2.47, 2.3 + bob, 0, 0.04, 0.11, 0.04, -0.2, '#ff5a7a');          // a plume
    box(2.15, 1.5 + bob, 0, 0.09, 0.22, 0.25, -0.35, TACK);             // the collar
    box(1.75, 1.33 + bob, 0, 0.06, 0.29, 0.255, 0, TACK);               // the harness band
    seg(0.8, 1.5 + bob, 0, 0.62, -0.35 + 0.12 * Math.sin(trot * 0.5), 0.06, MANE);   // the tail
    // legs at a trot: the diagonal pairs move together
    [[2.08, 0.15, 0], [2.08, -0.15, 1], [1.0, 0.15, 1], [1.0, -0.15, 0]].forEach(function (L) {
      var th = trot + L[2] * Math.PI, a = 0.32 * Math.sin(th), b = a - 0.9 * Math.max(0, Math.cos(th)), y0 = 1.08 + bob;
      var kx = L[0] + Math.sin(a) * 0.5, ky = y0 - Math.cos(a) * 0.5;
      seg(L[0], y0, L[1], 0.5, a, 0.075, WH); seg(kx, ky, L[1], 0.55, b, 0.055, WH2);
      box(kx + Math.sin(b) * 0.55, ky - Math.cos(b) * 0.55 + 0.03, L[1], 0.06, 0.04, 0.06, 0, DK);
    });
    box(0.725, 1.15, 0.33, 1.335, 0.03, 0.03, 0.127, TACK); box(0.725, 1.15, -0.33, 1.335, 0.03, 0.03, 0.127, TACK);   // the shafts
    // the carriage: white with gold trim, red seats, a red canopy with a fringe, lamps up front
    box(-1.95, 1.05, 0, 0.95, 0.3, 0.56, 0, '#e8e0d0');
    box(-1.95, 1.2, 0, 0.97, 0.035, 0.575, 0, '#ffd166');
    box(-0.78, 1.18, 0, 0.04, 0.3, 0.5, -0.35, DK);
    box(-1.12, 1.4, 0, 0.2, 0.06, 0.5, 0, '#7a1e30'); box(-1.34, 1.6, 0, 0.04, 0.2, 0.5, 0, '#7a1e30');
    box(-2.42, 1.4, 0, 0.32, 0.07, 0.52, 0, '#7a1e30'); box(-2.82, 1.72, 0, 0.06, 0.4, 0.55, 0, '#e8e0d0');
    box(-2.2, 2.46, 0, 0.78, 0.04, 0.62, 0, '#a8283a'); box(-2.2, 2.36, 0, 0.8, 0.06, 0.64, 0, '#f4ead6');
    [-1.48, -2.92].forEach(function (x) { box(x, 1.88, 0.58, 0.025, 0.5, 0.025, 0, DK); box(x, 1.88, -0.58, 0.025, 0.5, 0.025, 0, DK); });
    box(-0.86, 1.66, 0.58, 0.05, 0.07, 0.05, 0, '#ffd166'); box(-0.86, 1.66, -0.58, 0.05, 0.07, 0.05, 0, '#ffd166');
    wheel(-2.45, 0.62, 0.7, 0.62, wr); wheel(-2.45, 0.62, -0.7, 0.62, wr); wheel(-1.05, 0.46, 0.64, 0.46, wf); wheel(-1.05, 0.46, -0.64, 0.46, wf);
    // the driver in a top hat, two passengers under the canopy
    box(-1.12, 1.78, 0, 0.16, 0.28, 0.19, 0.12, '#33405e'); box(-1.08, 2.16, 0, 0.1, 0.11, 0.1, 0, '#d8a080');
    box(-1.08, 2.29, 0, 0.17, 0.02, 0.17, 0, '#120820'); box(-1.08, 2.43, 0, 0.1, 0.13, 0.1, 0, '#120820');
    box(-0.9, 1.84, 0.17, 0.17, 0.045, 0.045, -0.5, '#33405e'); box(-0.9, 1.84, -0.17, 0.17, 0.045, 0.045, -0.5, '#33405e');
    box(-2.45, 1.68, 0.24, 0.14, 0.22, 0.15, 0, '#ff5a7a'); box(-2.42, 2.0, 0.24, 0.09, 0.1, 0.09, 0, '#d8a080');
    box(-2.45, 1.68, -0.24, 0.14, 0.22, 0.15, 0, '#4ac0d0'); box(-2.42, 2.0, -0.24, 0.09, 0.1, 0.09, 0, '#d8a080');
    return B;
  }
  var BOX_FACES = [[4, 5, 7, 6, 1, 0, 0], [0, 2, 3, 1, -1, 0, 0], [2, 6, 7, 3, 0, 1, 0], [0, 1, 5, 4, 0, -1, 0], [1, 3, 7, 5, 0, 0, 1], [0, 4, 6, 2, 0, 0, -1]];
  function buggyColor(c, lv) {
    var key = c + lv, v = BUGGY.cols[key];
    if (v === undefined) {
      var n = parseInt(c.slice(1), 16), r = Math.round(((n >> 16) & 255) * lv), g = Math.round(((n >> 8) & 255) * lv), b = Math.round((n & 255) * lv);
      v = BUGGY.cols[key] = ((255 << 24) | (b << 16) | (g << 8) | r) >>> 0;
    }
    return v;
  }
  function drawBuggy() {
    var A = ART_A, vx = Math.round(W / 2), GH = H - HORIZON, HC = lifeCam();
    // the street in meters: the camera sits HC up, the curbs are hw to each side, lanes at half of that;
    // the turn near us keeps the whole rig (about 3 meters each way from its middle) above our curb at the bottom
    var hw = 0.4 * W * HC / GH, lx = hw * 0.5, kNear = Math.min(0.86, (SAND - 1 - HORIZON) / GH), zN = HC / kNear + 0.75 + Math.sqrt(lx * lx + 10), zF = Math.max(zN + 6, HC / 0.32 - lx);
    var Ls = zF - zN, Lc = Math.PI * lx, loop = 2 * Ls + 2 * Lc, dist = G.t * 4.2, s = (dist % loop + loop) % loop, X, Z, hx, hz, a;
    if (s < Ls) { X = lx; Z = zN + s; hx = 0; hz = 1; }
    else if (s < Ls + Lc) { a = (s - Ls) / lx; X = lx * Math.cos(a); Z = zF + lx * Math.sin(a); hx = -Math.sin(a); hz = Math.cos(a); }
    else if (s < 2 * Ls + Lc) { X = -lx; Z = zF - (s - Ls - Lc); hx = 0; hz = -1; }
    else { a = (s - 2 * Ls - Lc) / lx; X = -lx * Math.cos(a); Z = zN - lx * Math.sin(a); hx = Math.sin(a); hz = -Math.cos(a); }
    var boxes = buggyBoxes(dist / 2.6 * Math.PI * 2, -dist / 0.62, -dist / 0.46);
    var LX = -0.45, LY = 0.75, LZ = -0.5, ll = Math.sqrt(LX * LX + LY * LY + LZ * LZ); LX /= ll; LY /= ll; LZ /= ll;
    var faces = [], minx = 1e9, miny = 1e9, maxx = -1e9, maxy = -1e9;
    for (var bi = 0; bi < boxes.length; bi++) {
      var q = boxes[bi], ca = Math.cos(q[6]), sa = Math.sin(q[6]), P = [];
      for (var ci = 0; ci < 8; ci++) {
        var lx0 = (ci & 4 ? 1 : -1) * q[3], ly0 = (ci & 2 ? 1 : -1) * q[4], lz = q[2] + (ci & 1 ? 1 : -1) * q[5];
        var lxx = q[0] + lx0 * ca - ly0 * sa, ly = q[1] + lx0 * sa + ly0 * ca;
        var wx = X + lxx * hx + lz * hz, wz = Z + lxx * hz - lz * hx;
        if (wz < 2) return;
        var sx = (vx + GH * wx / wz) * A, sy = (HORIZON + GH * (HC - ly) / wz) * A;
        P.push([sx, sy, 1 / wz, wx, ly, wz]);
        if (sx < minx) minx = sx; if (sx > maxx) maxx = sx; if (sy < miny) miny = sy; if (sy > maxy) maxy = sy;
      }
      for (var fi = 0; fi < 6; fi++) {
        var f = BOX_FACES[fi], lnx = f[4] * ca - f[5] * sa, lny = f[4] * sa + f[5] * ca, lnz = f[6];
        var nx = lnx * hx + lnz * hz, ny = lny, nz = lnx * hz - lnz * hx;
        var p0 = P[f[0]], p2 = P[f[2]], mx = (p0[3] + p2[3]) / 2, my = (p0[4] + p2[4]) / 2 - HC, mz = (p0[5] + p2[5]) / 2;
        if (nx * mx + ny * my + nz * mz >= 0) continue;   // facing away from us
        var d = nx * LX + ny * LY + nz * LZ;
        faces.push([P[f[0]], P[f[1]], P[f[2]], P[f[3]], buggyColor(q[7], d > 0.45 ? 1 : d > 0 ? 0.84 : 0.68)]);
      }
    }
    var x0 = Math.max(0, Math.floor(minx) - 2), y0 = Math.max(0, Math.floor(miny) - 2), x1 = Math.min(W * A, Math.ceil(maxx) + 2), y1 = Math.min(H * A, Math.ceil(maxy) + 2);
    var bw = x1 - x0, bh = y1 - y0;
    LIFE.buggy = { x: X, z: Z, k: HC / Z, heading: Math.atan2(hx, hz), sx: (vx + GH * X / Z), sy: HORIZON + GH * HC / Z, w: bw / A, h: bh / A, left: x0 / A, right: x1 / A, top: y0 / A, bottom: y1 / A };
    if (bw <= 0 || bh <= 0) return;
    if (!BUGGY.img || BUGGY.img.width < bw || BUGGY.img.height < bh) {
      BUGGY.cv = BUGGY.cv || document.createElement('canvas');
      var cw = Math.max(bw, BUGGY.img ? BUGGY.img.width : 0), ch = Math.max(bh, BUGGY.img ? BUGGY.img.height : 0);
      BUGGY.cv.width = cw; BUGGY.cv.height = ch;
      BUGGY.img = BUGGY.cv.getContext('2d').createImageData(cw, ch); BUGGY.px = new Uint32Array(BUGGY.img.data.buffer); BUGGY.zb = new Float32Array(cw * ch);
    }
    var px = BUGGY.px, zb = BUGGY.zb, sw = BUGGY.img.width;
    px.fill(0); zb.fill(0);
    function tri(a, b, c, col) {
      var ax = a[0] - x0, ay = a[1] - y0, bx = b[0] - x0, by = b[1] - y0, cx = c[0] - x0, cy = c[1] - y0;
      var ar = (bx - ax) * (cy - ay) - (by - ay) * (cx - ax);
      if (ar > -1e-6 && ar < 1e-6) return;
      var xa = Math.max(0, Math.floor(Math.min(ax, bx, cx))), xb = Math.min(bw - 1, Math.ceil(Math.max(ax, bx, cx)));
      var ya = Math.max(0, Math.floor(Math.min(ay, by, cy))), yb = Math.min(bh - 1, Math.ceil(Math.max(ay, by, cy)));
      for (var y = ya; y <= yb; y++) {
        var py = y + 0.5;
        for (var x = xa; x <= xb; x++) {
          var pxx = x + 0.5, w0 = ((bx - pxx) * (cy - py) - (by - py) * (cx - pxx)) / ar, w1 = ((cx - pxx) * (ay - py) - (cy - py) * (ax - pxx)) / ar, w2 = 1 - w0 - w1;
          if (w0 < 0 || w1 < 0 || w2 < 0) continue;
          var z = w0 * a[2] + w1 * b[2] + w2 * c[2], i = y * sw + x;
          if (z > zb[i]) { zb[i] = z; px[i] = col; }
        }
      }
    }
    for (var k = 0; k < faces.length; k++) { var F = faces[k]; tri(F[0], F[1], F[2], F[4]); tri(F[0], F[2], F[3], F[4]); }
    // a dark outline all the way around, like the sprites
    var ink = buggyColor('#120820', 1);
    for (var yy = 0; yy < bh; yy++) for (var xx = 0; xx < bw; xx++) {
      var j = yy * sw + xx;
      if (zb[j] > 0) continue;
      if ((xx > 0 && zb[j - 1] > 0) || (xx < bw - 1 && zb[j + 1] > 0) || (yy > 0 && zb[j - sw] > 0) || (yy < bh - 1 && zb[j + sw] > 0)) px[j] = ink;
    }
    BUGGY.cv.getContext('2d').putImageData(BUGGY.img, 0, 0, 0, 0, bw, bh);
    ctx.drawImage(BUGGY.cv, 0, 0, bw, bh, x0 / A, y0 / A, bw / A, bh / A);
  }
  function paintScene(b, n, P) {
    var B = HORIZON, sil = P.sil, lit = P.glint;
    var gold = '#ffd166', red = '#ff5a7a', cream = '#cfc6b8', blue = '#2b6cc4', orange = '#c8582c';
    var dk = '#24142e', mid = '#3a2448', hi = '#4a3358';
    function R(x, t, w, h, c) { w = Math.round(w); if (w <= 0 || t <= 0) return; if (h == null) h = t; if (h <= 0) return; b.fillStyle = c || sil; b.fillRect(Math.round(x), B - t, w, h); }
    function D(x, t, c) { R(x, t, 1, 1, c); }
    function SEG(x0, t0, x1, t1, c, step) {
      var n2 = Math.max(Math.abs(x1 - x0), Math.abs(t1 - t0)) || 1;
      for (var i = 0; i <= n2; i += (step || 1)) D(Math.round(x0 + (x1 - x0) * i / n2), Math.round(t0 + (t1 - t0) * i / n2), c);
    }
    function ring(cx, ct, r, c) { for (var k = 0; k < 64; k++) { var a = k / 64 * Math.PI * 2; D(Math.round(cx + Math.sin(a) * r), Math.round(ct - Math.cos(a) * r), c); } }
    function car(x, t, c, dir) { R(x, t + 3, 6, 2, c || sil); R(x + 1, t + 4, 4, 1, c || sil); D(dir > 0 ? x + 5 : x, t + 2, dir > 0 ? gold : red); }
    var x, t, i, k;
    switch (SCENES[n]) {
      case 'causeway': {   // LEVEL 1: the Causeway, a long deck on paired columns rising to the high span, light poles and traffic
        var deckTop = causewayDeck;
        for (x = 0; x < W; x++) {
          t = deckTop(x);
          R(x, t + 1, 1, 1);                       // the barrier along the top
          R(x, t, 1, 3, hi); R(x, t, 1, 1, mid);    // the deck edge catching the sunset
          if (x % 6 === 0 && t > 5) { R(x - 1, t - 3, 5, 1); R(x, t - 4, 1); R(x + 2, t - 4, 1); }
        }
        for (x = 8; x < W - 4; x += 15) { t = deckTop(x) + 1; R(x, t + 10, 1, 10); D(x - 1, t + 10); D(x + 1, t + 10); D(x - 2, t + 11); D(x + 2, t + 11); D(x - 3, t + 11, gold); D(x + 3, t + 11, gold); }
        var j0 = Math.round(W * 0.6), j1 = Math.round(W * 0.76);
        for (x = j0; x <= j1; x++) R(x, 1 + ((x * 7) % 3 === 0 ? 1 : 0) + (x > j0 + 2 && x < j1 - 2 ? 1 : 0), 1, null, '#1a1024');
        var fx = Math.round((j0 + j1) / 2);
        D(fx - 3, 7); R(fx - 3, 6, 1, 3); D(fx - 4, 3); D(fx - 2, 3);              // someone fishing
        R(fx + 2, 9, 5, 1, red); R(fx + 4, 8, 1, 3); D(fx + 3, 6); R(fx + 3, 5, 1, 2); // under an umbrella
        SEG(fx - 3, 6, fx - 9, 11); SEG(fx - 9, 11, fx - 11, 1, sil, 3);            // the fishing line
        break;
      }
      case 'ferry': {   // LEVEL 2: the Galveston to Bolivar ferry, orange columns and pilot houses at both ends, flags, a rig far off
        var fl = Math.max(100, Math.min(170, Math.round(W * 0.6))), f0 = Math.round(W * 0.47 - fl / 2), fr = f0 + fl;
        var rx = Math.max(3, Math.round(W * 0.04));
        SEG(rx, 1, rx + 3, 24); SEG(rx + 9, 1, rx + 6, 24); for (t = 4; t < 22; t += 5) { SEG(rx + 1, t, rx + 8, t + 4); SEG(rx + 8, t, rx + 1, t + 4); } R(rx + 2, 26, 6, 2); D(rx + 4, 27, red);
        for (x = Math.round(W * 0.84); x < W; x++) R(x, 2 + ((x * 7) % 3 === 0 ? 1 : 0) + ((x * 13) % 5 === 0 ? 1 : 0));
        R(f0 + 2, 1, fl - 4, 1); R(f0, 5, fl, 4); R(f0 - 1, 5, 1, 2); R(fr, 5, 1, 2);
        for (x = f0 + 1; x < fr; x += 2) D(x, 6, mid);
        R(f0 + Math.round(fl * 0.3), 10, 12, 4, '#2b4c8c'); R(f0 + Math.round(fl * 0.3) + 12, 9, 4, 3, mid);   // a truck
        R(f0 + Math.round(fl * 0.47), 9, 18, 3, '#1c1828');                                             // a tanker
        for (x = f0 + Math.round(fl * 0.68); x < fr - 14; x += 7) car(x, 6, x % 2 ? mid : sil, 1);
        [f0 + Math.round(fl * 0.12), fr - Math.round(fl * 0.12) - 3].forEach(function (lx) { R(lx, 15, 3, 9, orange); });
        R(f0 + Math.round(fl * 0.08), 16, Math.round(fl * 0.84), 2, orange);
        R(f0 + Math.round(fl * 0.12), 20, Math.round(fl * 0.76), 4, mid);
        for (x = f0 + Math.round(fl * 0.14); x < fr - Math.round(fl * 0.14); x += 3) D(x, 18, lit);
        var phs = [f0 + Math.round(fl * 0.1), fr - Math.round(fl * 0.1) - 10];
        phs.forEach(function (px) { R(px, 25, 10, 5, hi); R(px + 1, 23, 8, 2, sil); D(px + 2, 23, gold); D(px + 5, 23, gold); D(px + 8, 23, gold); R(px - 1, 26, 12, 1, orange); R(px + 5, 33, 1, 7); D(px + 5, 34, red); });
        R(Math.round(f0 + fl / 2) - 4, 25, 8, 5, hi); R(Math.round(f0 + fl / 2) - 4, 26, 8, 1, orange); D(Math.round(f0 + fl / 2), 23, blue);
        R(f0 + 3, 13, 1, 8); R(f0 + 4, 13, 4, 1, red); R(f0 + 4, 12, 4, 1, cream); R(f0 + 4, 11, 4, 1, red); R(f0 + 4, 13, 2, 2, blue);
        R(fr - 4, 13, 1, 8); R(fr - 9, 13, 5, 1, cream); R(fr - 9, 12, 5, 1, red); R(fr - 9, 13, 1, 2, blue);
        break;
      }
      case 'seawall': {   // LEVEL 3: the Seawall: the far end, where the wall, the road and the beach meet (the near wall is drawn in front of the water)
        var vxs = Math.round(W * 0.72);
        for (x = vxs - 14; x < vxs + 22; x += 5) { var bh = 3 + ((x * 13) % 6); R(x, bh, 4, bh, '#1e1230'); if (x % 3) D(x + 1, bh - 1, lit); }
        R(vxs - 1, 2, W - vxs + 1, 2, dk); R(vxs, 3, W - vxs, 1, hi);
        break;
      }
      case 'palace': {   // LEVEL 4: Broadway, Bishop's Palace with its spire, towers and red railings, live oaks and hedges
        var stone = '#2e1a2e', roof = '#40182a', rail = '#a3305a', pc = Math.round(W * 0.46), p0 = pc - 34;
        R(p0 - 26, 12, 14, 12, '#2a1426'); for (i = 0; i < 5; i++) R(p0 - 26 + i, 13 + i, 14 - 2 * i, 1, roof); D(p0 - 22, 8, lit); D(p0 - 17, 8, lit);
        R(p0 + 8, 22, 52, 22, stone);
        R(p0, 30, 14, 30, stone); for (i = 0; i < 8; i++) R(p0 + i, 31 + i, 14 - 2 * i, 1, roof); D(p0 + 7, 39);
        R(p0 + 16, 28, 10, 6, stone); for (i = 0; i < 5; i++) R(p0 + 16 + i, 29 + i, 10 - 2 * i, 1, roof);
        R(pc - 6, 34, 12, 34, stone); R(pc - 7, 34, 14, 1, mid);
        for (i = 0; i < 17; i++) { var cw = Math.max(1, 14 - Math.round(i * 13 / 16)); R(pc - (cw >> 1), 35 + i, cw, 1, roof); }
        D(pc, 52); D(pc, 53);
        R(p0 + 44, 28, 16, 28, stone); for (i = 0; i < 8; i++) R(p0 + 44 + i, 29 + i, 16 - 2 * i, 1, roof);
        R(p0 + 60, 32, 6, 32, stone); R(p0 + 60, 33, 6, 1, roof); R(p0 + 61, 34, 4, 1, roof); R(p0 + 62, 36, 2, 2, roof); D(p0 + 62, 37);
        R(p0 + 56, 38, 2, 8, stone); R(p0 + 30, 30, 2, 8, stone); R(p0 + 39, 29, 2, 7, stone);
        [8, 15].forEach(function (row) { for (x = p0 + 8; x < p0 + 60; x += 2) D(x, row, rail); for (x = p0 + 9; x < p0 + 60; x += 6) R(x, row - 1, 1, 6, mid); });
        [4, 11, 19].forEach(function (row) { for (x = p0 + 2; x < p0 + 64; x += 4) if ((x * 3 + row) % 5) { D(x, row, lit); D(x, row - 1, lit); } });
        D(pc - 2, 27, lit); D(pc - 2, 26, lit); D(pc + 2, 27, lit); D(pc + 2, 26, lit); D(p0 + 6, 25, lit); D(p0 + 6, 24, lit);
        var oak = function (ox, r) { for (var dy = -r; dy <= r; dy++) for (var dx = -r - 3; dx <= r + 3; dx++) if ((dx * dx) / ((r + 3) * (r + 3)) + (dy * dy) / (r * r) <= 1 && ((dx * 7 + dy * 3) % 5 !== 0 || Math.abs(dx) < r)) D(ox + dx, r + 7 + dy, '#18122a'); R(ox - 1, 7, 2, 7, '#18122a'); };
        oak(p0 + 82, 8); if (p0 + 104 < W) oak(p0 + 104, 6);
        for (x = p0 - 28; x < Math.min(W, p0 + 96); x++) R(x, 2 + ((x * 5) % 3 === 0 ? 1 : 0), 1, null, '#18122a');
        break;
      }
      case 'strand': {   // LEVEL 5: the Strand: the tall building at the far end of the street (the two rows of old buildings are drawn in front)
        var vxs2 = Math.round(W / 2);
        R(vxs2 - 7, 42, 14, 42, '#1c1230'); R(vxs2 - 8, 43, 16, 1, '#2a1a36');
        for (t = 8; t < 41; t += 3) for (x = vxs2 - 5; x < vxs2 + 6; x += 3) if ((x * 3 + t) % 5) D(x, t, lit);
        R(vxs2 - 12, 9, 5, 9, '#2e2232'); R(vxs2 + 7, 8, 5, 8, '#3a2230');
        break;
      }
      case 'cruise': {   // LEVEL 6: Harborside, a cruise ship at the terminal (PORT OF GALVESTON), a drilling rig and a crane
        var sl = Math.max(130, Math.min(240, Math.round(W * 0.72))), s0 = Math.max(24, Math.round(W * 0.5 - sl / 2)), se = s0 + sl;
        var hull = '#3a3050', hull2 = '#342a48';
        var rg = Math.max(2, s0 - 22);
        SEG(rg, 1, rg + 4, 44); SEG(rg + 10, 1, rg + 6, 44); for (t = 4; t < 42; t += 5) { SEG(rg + 1, t, rg + 9, t + 4); SEG(rg + 9, t, rg + 1, t + 4); } R(rg + 3, 46, 5, 2); D(rg + 5, 47, red);
        SEG(rg + 12, 8, rg + 30, 30); SEG(rg + 13, 8, rg + 31, 30); R(rg + 30, 30, 1, 10);
        for (t = 10; t <= 28; t++) { var xr = se - 10 + Math.round((t - 10) * 0.45); R(s0 + (t > 24 ? 2 : 0), t, xr - s0 - (t > 24 ? 2 : 0), 1, t % 2 ? hull : hull2); }
        for (t = 15; t <= 27; t += 2) for (x = s0 + 3; x < se - 10 + Math.round((t - 10) * 0.45) - 2; x += 2) if ((x * 3 + t) % 11) D(x, t, lit);
        for (x = s0 + 6; x < se - 16; x += 6) R(x, 13, 4, 2, orange);
        R(s0 + 8, 31, sl - 34, 3, hull2); for (x = s0 + 10; x < se - 28; x += 3) D(x, 30, lit);
        var fxs = s0 + Math.round(sl * 0.3);
        R(fxs, 34, 8, 3, cream); R(fxs + 1, 37, 6, 2, blue); R(fxs + 2, 41, 5, 4, '#d02a3a'); R(fxs + 5, 44, 5, 3, '#d02a3a'); R(fxs + 9, 45, 3, 2, '#d02a3a'); R(fxs - 7, 42, 8, 1, sil); R(fxs - 6, 43, 3, 1, sil);
        [s0 + Math.round(sl * 0.18), s0 + Math.round(sl * 0.55), s0 + Math.round(sl * 0.6)].forEach(function (dxx) { R(dxx, 35, 3, 3, cream); D(dxx + 1, 36, cream); });
        var sx = se - 40; SEG(sx, 32, sx + 6, 38, gold); SEG(sx + 6, 38, sx + 12, 34, orange); SEG(sx + 12, 34, sx + 16, 37, gold); R(sx + 15, 39, 1, 8);
        R(se - 22, 40, 1, 9); D(se - 22, 41, red);
        var tx0 = Math.round(W * 0.08), tx1 = Math.round(W * 0.94);
        R(tx0, 8, tx1 - tx0, 8, '#241a30'); R(tx0, 9, tx1 - tx0, 1, mid);
        for (x = tx0 + 4; x < tx1 - 6; x += 9) R(x, 6, 6, 1, '#33405e');
        for (x = tx0 + 3; x < tx1 - 4; x += 4) D(x, 4, lit);
        var lbl = 'PORT OF GALVESTON', lw2 = textWidth(lbl, 1) + 4, bx = Math.round(tx0 + (tx1 - tx0) * 0.18);
        R(bx - 3, 13, 12, 13, '#2c2236'); R(bx + 2, 9, 2, 4, gold);
        R(bx + 12, 14, lw2, 8, '#26304a'); R(bx + 12, 14, lw2, 1, '#3a4666'); drawText(b, lbl, bx + 14, B - 12, '#d8ccb4', 1);
        break;
      }
      case 'pier': {   // LEVEL 7: the Pleasure Pier from CK's sunset photo, flipped: the end building, the Ferris wheel, the Star Flyer
                       // in front of the sun, the main building under the coaster, the lift tower, the incline and the ring, out on pilings
        var Wg = wheelGeom(), wt = B - Wg.cy, p0 = Math.round(W * 0.04), fxw = function (f) { return Math.round(W * f); };
        R(p0, 7, W - p0, 2); for (x = p0 + 1; x < W; x += 4) R(x, 5, 1, 5);                                               // the deck on its pilings
        R(fxw(0.05), 13, fxw(0.08), 6); R(fxw(0.06), 15, fxw(0.06), 2); R(fxw(0.08), 17, 2, 2);                          // the building at the end of the pier
        for (var l = 0; l <= Wg.R + 2; l++) { D(Wg.cx - Math.round(l * 0.45), wt - l); D(Wg.cx + Math.round(l * 0.45), wt - l); }
        R(Wg.cx - 6, 10, 12, 3);
        var sx2 = fxw(0.31), th = Math.round(Math.min(64, HORIZON * 0.45));                                               // the Texas Star Flyer
        R(sx2, th, 2, th - 7); R(sx2 - 3, Math.round(th * 0.86) + 2, 8, 2); R(sx2 - 1, th + 2, 4, 2); D(sx2, th + 4); D(sx2 + 1, th + 4);
        R(sx2 - 4, 10, 10, 3);
        R(fxw(0.38), 15, fxw(0.2), 8); R(fxw(0.4), 17, fxw(0.08), 2); R(fxw(0.5), 18, fxw(0.05), 3);                     // the main building
        var c0 = fxw(0.37), c1 = fxw(0.66), ch2 = function (xx) { var q = (xx - c0) / (c1 - c0); return Math.round(19 + 4 * Math.sin(q * Math.PI * 3)); };
        for (x = c0; x <= c1; x++) { t = ch2(x); D(x, t); if ((x - c0) % 4 === 0) R(x, t - 1, 1, t - 9); }                // the Iron Shark's track and supports
        ring(fxw(0.45), 20, 5); ring(fxw(0.54), 21, 6);
        var lf = fxw(0.6);                                                                                              // the lift tower
        R(lf, 36, 1, 28); R(lf + 7, 36, 1, 28); R(lf, 36, 8, 1); R(lf, 27, 8, 1); R(lf, 18, 8, 1);
        SEG(lf, 36, lf + 7, 27); SEG(lf + 7, 36, lf, 27); SEG(lf, 27, lf + 7, 18); SEG(lf + 7, 27, lf, 18);
        SEG(lf + 3, 37, c1 - 4, 23);
        SEG(fxw(0.68), 22, fxw(0.9), 9); SEG(fxw(0.68), 21, fxw(0.9), 8);                                                // the incline
        for (x = fxw(0.69); x < fxw(0.9); x += 4) { var it = Math.round(22 - (x - fxw(0.68)) / (fxw(0.9) - fxw(0.68)) * 13); R(x, it - 1, 1, it - 8); }
        R(fxw(0.9), 11, 6, 4);
        ring(fxw(0.95), 17, 6); R(fxw(0.95), 11, 1, 3);                                                                 // the ring
        for (x = p0 + 3, i = 0; x < W; x += 6, i++) D(x, 8, i % 3 ? lit : gold);
        break;
      }
      case 'shop': {   // LEVEL 8: 61st Street, the Von Striga storefront: the green TATTOO sign, the canopy, the windows, cars out front
        var bw2 = Math.max(110, Math.min(220, Math.round(W * 0.64))), b0 = Math.round(W * 0.5 - bw2 / 2), facade = '#3a3046', fascia = '#433a52';
        R(b0, 26, bw2, 26, facade); R(b0 - 1, 27, bw2 + 2, 1, hi); R(b0, 25, bw2, 11, fascia);
        R(b0 - 2, 14, bw2 + 4, 2, '#2a2236'); R(b0, 12, bw2, 1, sil);
        for (x = b0 + 2; x < b0 + bw2 - 2; x += 24) R(x, 12, 1, 11, hi);
        for (x = b0 + 4; x < b0 + bw2 - 6; x += 24) { var gw = Math.min(19, b0 + bw2 - 4 - x); R(x, 11, gw, 9, '#1a1426'); R(x + 1, 10, gw - 2, 3, '#5a3a2a'); R(x + 1, 6, gw - 2, 1, orange); }
        var mid2 = Math.round(W * 0.5), dxr = mid2 - 14;
        R(dxr, 12, 7, 11, '#3fa34d'); R(dxr + 1, 11, 5, 9, '#1a1426'); R(dxr + 2, 9, 3, 2, '#5a3a2a');
        D(mid2 + 2, 9, cream); R(mid2 + 1, 8, 3, 1, cream); D(mid2 + 1, 10, cream); D(mid2 + 3, 10, cream);   // the crown in the window
        // the green channel letters, in a bold block face like the real sign
        var GL = { T: ['111111', '111111', '001100', '001100', '001100', '001100', '001100', '001100'],
          A: ['011110', '111111', '110011', '110011', '111111', '111111', '110011', '110011'],
          O: ['011110', '111111', '110011', '110011', '110011', '110011', '111111', '011110'] };
        var word = 'TATTOO', tx = mid2 - 20, ty = B - 24;
        [['#1e4a16', 1, 1], ['#2e6a22', -1, 0], ['#2e6a22', 1, 0], ['#2e6a22', 0, -1], ['#8ae04a', 0, 0]].forEach(function (pass) {
          b.fillStyle = pass[0];
          for (var ci = 0; ci < word.length; ci++) { var g = GL[word[ci]]; for (var gy = 0; gy < 8; gy++) for (var gx = 0; gx < 6; gx++) if (g[gy][gx] === '1') b.fillRect(tx + ci * 7 + gx + pass[1], ty + gy + pass[2], 1, 1); }
        });
        b.fillStyle = '#b6ff7a'; for (var ci2 = 0; ci2 < word.length; ci2++) b.fillRect(tx + ci2 * 7 + 1, ty, 4, 1);
        var sp = Math.min(W - 16, b0 + bw2 + 6);
        R(sp, 20, 1, 20); var st = '61ST ST', stw = textWidth(st, 1) + 4; R(sp - (stw >> 1), 22, stw, 7, '#2e7d32'); drawText(b, st, sp - (stw >> 1) + 2, B - 21, '#f4ead6', 1);
        for (x = b0 + 3; x < b0 + bw2 - 3; x++) if ((x * 5) % 7 < 4) D(x, 2 + ((x * 3) % 2), '#1a2a1e');
        R(b0 + 8, 6, 12, 3); R(b0 + 14, 8, 6, 2); D(b0 + 8, 4, red); D(b0 + 10, 1); D(b0 + 17, 1);
        R(b0 + bw2 - 24, 7, 11, 4, '#4a4458'); R(b0 + bw2 - 22, 8, 6, 1, sil); D(b0 + bw2 - 14, 5, red); D(b0 + bw2 - 22, 1); D(b0 + bw2 - 16, 1);
        break;
      }
    }
  }
  // what each scene stands on: water (with the moving waves), a beach with surf, or land
  var SCENE_WATER = [true, true, true, false, false, false, true, false];
  var SCENE_SURF = [false, false, false, false, false, false, true, false];   // a surf line where the water meets the beach
  var SCENE_PALMS = [false, false, false, false, false, true, false, false];
  function seaBottom(n) { return SCENES[n] === 'pier' ? HORIZON + Math.round((H - HORIZON) * 0.5) : SAND; }
  function paintGround(b, n, P) {
    var GH = H - HORIZON, kind = SCENES[n];
    function F(x, y, w, h, c) { if (w <= 0 || h <= 0) return; b.fillStyle = c; b.fillRect(Math.round(x), Math.round(y), Math.round(w), Math.round(h)); }
    function water(cols) { for (var i = 0; i < cols.length; i++) { var y0 = HORIZON + Math.round(i * (SAND - HORIZON) / cols.length), y1 = HORIZON + Math.round((i + 1) * (SAND - HORIZON) / cols.length); F(0, y0, W, y1 - y0, cols[i]); } }
    function concrete(top, seam) { F(0, SAND, W, H - SAND, '#8e8496'); F(0, SAND, W, 1, top || '#b0a6b6'); for (var x = 9; x < W; x += 18) F(x, SAND + 1, 1, H - SAND - 1, seam || '#7a7084'); }
    var x, y, i, k;
    if (kind === 'causeway') {   // bay water, a rock shoreline in front
      water(['#141e34', '#13263a', '#122e3a', '#103436', '#0e3a32']);
      F(0, SAND - 1, W, H - SAND + 1, '#4a4258');
      for (x = -3, i = 0; x < W; i++) { var rw = 5 + (i * 7) % 5, rh = 3 + (i * 5) % 4, ry = SAND + (i % 3) * 3 - 1; F(x, ry, rw, rh, ['#9a90a6', '#857b92', '#a89eb2'][i % 3]); F(x, ry, rw, 1, '#c0b6c8'); x += rw + 1; }
      for (x = 2; x < W; x += 13) F(x, SAND - 2, 4, 2, '#857b92');
    } else if (kind === 'ferry') {   // channel water, the ferry landing dock in front
      water(['#182230', '#1a2a32', '#1a3034', '#183632', '#163a30']);
      F(0, SAND, W, H - SAND, '#9a7a5a'); F(0, SAND, W, 1, '#b8946a');
      for (y = SAND + 4; y < H; y += 4) F(0, y, W, 1, '#7a5e44');
      for (y = SAND + 1, i = 0; y < H; y += 4, i++) for (x = (i % 2) * 7; x < W; x += 14) F(x, y, 1, 3, '#7a5e44');
      for (x = Math.round(W * 0.2); x < W - 6; x += Math.round(W * 0.3)) { F(x, SAND - 3, 4, 5, '#2a2030'); F(x - 1, SAND - 4, 6, 1, '#3a3044'); }
      for (x = Math.round(W * 0.2) + 4; x < W - 10; x++) { var seg = (x - Math.round(W * 0.2) - 4) % Math.round(W * 0.3), sag = Math.round(Math.sin(seg / Math.round(W * 0.3) * Math.PI) * 2); if (seg < Math.round(W * 0.3) - 4) F(x, SAND - 2 + sag, 1, 1, '#c8b48a'); }
      var lr = Math.round(W * 0.62); for (k = 0; k < 24; k++) { var a = k / 24 * Math.PI * 2; F(lr + Math.round(Math.cos(a) * 3), SAND + 5 + Math.round(Math.sin(a) * 3), 1, 1, k % 6 < 3 ? '#e85d26' : '#f4ead6'); }
    } else if (kind === 'seawall') {   // water all the way across; the beach and the wall are drawn in front of it
      water(P.sea);
    } else if (kind === 'pier') {   // the Gulf, the surf line, then a wide beach
      var shore = seaBottom(n);
      water(P.sea.slice(0, 4));
      F(0, shore, W, H - shore, kind === 'seawall' ? '#8a6c4a' : '#6a4a52');
      for (y = shore; y < shore + 5; y++) F(0, y, W, 1, kind === 'seawall' ? '#5a4a52' : '#4a3a56');
      if (kind === 'pier') {   // wet sand holding the sunset: ripples, the sun's streak, a gull and its reflection
        var Sg = sunGeom();
        for (y = shore + 5; y < H; y += 2) { k = (y - shore) / (H - shore); var sw2 = Math.max(2, Math.round(Sg.r * (0.5 - k * 0.3))); F(Sg.cx - sw2, y, sw2 * 2, 1, (y % 4) ? '#a8704a' : '#8a5a4a'); }
        for (i = 0; i < 9; i++) for (x = 0; x < W; x++) { y = shore + 7 + i * Math.round((H - shore) / 9) + Math.round(Math.sin(x * 0.09 + i * 1.7) * 2 + x * 0.04); if (y < H - 1 && y > shore + 5) F(x, y, 1, 1, '#4e3448'); }
        var gx2 = Math.round(W * 0.47), gy2 = shore + Math.round((H - shore) * 0.5);
        var GULL = ['10000000001', '01000000010', '00100000100', '00110001100', '00011111000', '00001111110', '00000100000'];
        for (var gr = 0; gr < GULL.length; gr++) for (var gc = 0; gc < 11; gc++) if (GULL[gr][gc] === '1') { F(gx2 + gc, gy2 + gr, 1, 1, '#1a0e1e'); F(gx2 + gc, gy2 + 2 * GULL.length - gr, 1, 1, '#3a2238'); }
      } else {   // dry sand with tire tracks along the wall
        for (y = shore + 5; y < H; y += 3) for (x = (y * 13) % 7; x < W; x += 7) F(x, y, 1, 1, '#7a5e40');
        for (i = 0; i < 3; i++) for (x = 0; x < W; x++) { y = shore + 10 + i * 9 + Math.round(Math.sin(x / W * Math.PI * 2 + i) * 3); if (y < H - 2) F(x, y, 1, 1, '#6a5238'); }
      }
    } else if (kind === 'palace') {   // the lawn and hedges, the sidewalk, Broadway itself, our curb
      var lawnB = HORIZON + Math.round(GH * 0.32), hedgeB = lawnB + 4, walkB = hedgeB + Math.round(GH * 0.12);
      F(0, HORIZON, W, lawnB - HORIZON, '#14261c'); for (y = HORIZON + 1; y < lawnB; y += 2) for (x = (y * 3) % 5; x < W; x += 5) F(x, y, 1, 1, '#1c3424');
      F(0, lawnB, W, hedgeB - lawnB, '#0f2016'); for (x = 0; x < W; x++) F(x, lawnB - 1 - ((x * 7) % 3 === 0 ? 1 : 0), 1, 1, '#0f2016'); for (x = 1; x < W; x += 3) F(x, lawnB, 1, 1, '#1e3a24');
      F(0, hedgeB, W, walkB - hedgeB, '#4a4458'); F(0, hedgeB, W, 1, '#5e566c'); for (x = 6; x < W; x += 12) F(x, hedgeB + 1, 1, walkB - hedgeB - 1, '#3e3a4c');
      F(0, walkB, W, 1, '#6a6278'); F(0, walkB + 1, W, SAND - walkB - 1, '#1a1824');
      var ly = walkB + Math.round((SAND - walkB) * 0.55); for (x = 2; x < W; x += 16) F(x, ly, 8, 1, '#8a7a40');
      concrete();
    } else if (kind === 'strand') {   // the brick street with the trolley tracks running into the distance
      var vx = Math.round(W * 0.5);
      F(0, HORIZON, W, H - HORIZON, '#3a2228');
      for (k = 1, y = HORIZON; y < H; k++) { var ny = HORIZON + Math.round(GH * Math.pow(k / 26, 1.6)); if (ny <= y) ny = y + 1; F(0, ny, W, 1, '#2a181e'); var jw = 3 + Math.round((ny - HORIZON) / GH * 9); for (x = (k % 2) * (jw >> 1); x < W; x += jw) F(x, y + 1, 1, ny - y - 1, '#2a181e'); y = ny; }
      for (y = HORIZON; y < H; y++) { k = (y - HORIZON) / GH; var sw = 2 + Math.round(k * W * 0.16); F(0, y, sw, 1, '#5a5266'); F(W - sw, y, sw, 1, '#5a5266'); F(sw, y, 1, 1, '#8a8296'); F(W - sw - 1, y, 1, 1, '#8a8296'); var rw2 = Math.round(1 + k * W * 0.12); F(vx - rw2, y, 1, 1, '#9a92a8'); F(vx + rw2, y, 1, 1, '#9a92a8'); }
      concrete();
    } else if (kind === 'cruise') {   // the road, the rail tracks and the parking lot in front of the terminal
      var roadB = HORIZON + Math.round(GH * 0.16), railY = roadB + Math.round(GH * 0.08);
      F(0, HORIZON, W, roadB - HORIZON, '#1c1a26'); for (x = 3; x < W; x += 12) F(x, HORIZON + Math.round((roadB - HORIZON) / 2), 6, 1, '#6a6478');
      F(0, roadB, W, railY + 6 - roadB, '#2c2834'); for (x = 1; x < W; x += 4) F(x, railY - 1, 1, 6, '#3a2a22'); F(0, railY, W, 1, '#8a8296'); F(0, railY + 3, W, 1, '#8a8296');
      F(0, railY + 6, W, SAND - railY - 6, '#22202c');
      var vx2 = Math.round(W * 0.5), t0 = railY + 9;
      F(0, t0, W, 1, '#5a5468');
      for (i = -12; i <= 12; i++) { var xa = vx2 + i * W * 0.05, xb = vx2 + i * W * 0.13; for (y = t0; y < SAND; y++) { k = (y - t0) / (SAND - t0); F(Math.round(xa + (xb - xa) * k), y, 1, 1, '#5a5468'); } }
      concrete('#b8a24a');
    } else if (kind === 'shop') {   // the walk under the canopy, the curb, the parking lot, the sign shining in the wet asphalt
      var wB = HORIZON + Math.round(GH * 0.07);
      F(0, HORIZON, W, wB - HORIZON, '#4a4458'); F(0, wB, W, 1, '#8a8296'); F(0, wB + 1, W, SAND - wB - 1, '#1e1c28');
      var vx3 = Math.round(W * 0.5), t1 = wB + 3;
      for (i = -12; i <= 12; i++) { var xa2 = vx3 + i * W * 0.06, xb2 = vx3 + i * W * 0.15; for (y = t1; y < SAND; y++) { k = (y - t1) / (SAND - t1); F(Math.round(xa2 + (xb2 - xa2) * k), y, 1, 1, '#5e5872'); } F(Math.round(xa2 + 2), t1 + 2, Math.max(2, Math.round(W * 0.025)), 1, '#3a3446'); }
      for (y = wB + 4; y < wB + 22 && y < SAND; y += 2) for (x = vx3 - 20 + ((y * 5) % 4); x < vx3 + 20; x += 5 + (y % 3)) if (((x + y) % 3) === 0) F(x, y, 2, 1, '#2e6a22');
      concrete('#b8a24a');
    }
  }
  // the Seawall level: the beach and the curved wall run off toward the far end, in front of the water
  function paintFront(b, n, P) {
    if (SCENES[n] === 'strand') return paintStrand(b);
    if (SCENES[n] !== 'seawall') return false;
    var vx = Math.round(W * 0.72), GH = H - HORIZON, wh = Math.round(Math.min(46, GH * 0.42));
    function F(x, y, w, h, c) { if (w <= 0 || h <= 0) return; b.fillStyle = c; b.fillRect(Math.round(x), Math.round(y), Math.round(w), Math.round(h)); }
    var xs = function (y) { return vx + (-W * 0.25 - vx) * (y - HORIZON) / GH; };          // the water's edge
    var xb = function (y) { return vx + (W * 0.7 - vx) * (y - HORIZON) / GH; };            // the foot of the wall
    var xt = function (y) { return vx + (W * 1.02 - vx) * (y - HORIZON) / (GH - wh); };    // the top of the wall
    for (var y = HORIZON + 1; y < H; y++) {
      var k = (y - HORIZON) / GH, a = Math.round(xs(y)), c = Math.round(xb(y)), d = Math.round(xt(y));
      F(a, y, c - a, 1, '#8a6c4a');
      F(a, y, Math.max(1, Math.round(2 + k * 6)), 1, '#5a4a52');
      if (y % 2 === 0) F(a - 1 - Math.round(k * 3), y, Math.max(1, Math.round(1 + k * 3)), 1, '#f4ead6');
      var face = Math.min(W, d) - c;
      if (face > 0) {
        F(c, y, face, 1, '#4e4460');
        F(c, y, Math.max(1, Math.round(face * 0.18)), 1, '#3a3046');
        F(c + Math.round(face * 0.82), y, Math.max(1, Math.round(face * 0.18)), 1, '#6a6080');
      }
      if (d < W) { F(d, y, W - d, 1, '#6a6078'); F(d, y, 1, 1, '#2a2436'); }
    }
    for (var t = 0; t < 2; t++) for (y = HORIZON + 3; y < H; y++) { var kk = (y - HORIZON) / GH, tx = vx + ((t ? 0.18 : 0.32) * W - vx) * kk + Math.round(Math.sin(y * 0.15 + t) * kk * 3); if (tx > xs(y) + 2 && tx < xb(y)) F(tx, y, Math.max(1, Math.round(kk * 3)), 1, '#6e5438'); }
    for (y = HORIZON + 6; y < H; y += 3) for (var gx = Math.round(xb(y)) + 3; gx < Math.min(W, xt(y)) - 2; gx += 9) F(gx + (y % 6 ? 0 : 4), y, 2, 1, '#5a4e72');
    [0.12, 0.25, 0.42, 0.64, 0.9, 1.2].forEach(function (s2, j) {
      var y0 = HORIZON + s2 * (GH - wh), x0 = vx + (W * 1.02 - vx) * s2 + 2;
      if (x0 > W - 2) return;
      var ph = Math.round(4 + s2 * 70), pw = s2 > 0.5 ? 2 : 1;
      F(x0, y0 - ph, pw, ph, '#120820');
      F(x0 - Math.round(2 + s2 * 6), y0 - ph, Math.round(2 + s2 * 6) + pw, pw, '#120820');
      F(x0 - Math.round(3 + s2 * 6), y0 - ph + pw, pw + 1, pw, '#ffd166');
      if (j === 3) { F(x0 + 5, y0 - 30, 1, 30, '#120820'); F(x0 + 2, y0 - 34, 8, 6, '#cfc6b8'); F(x0 + 2, y0 - 34, 8, 1, '#120820'); }
    });
    // the people running down the beach are drawn every frame (drawRunners)
    return true;
  }
  // the Strand level: old buildings with iron balconies on both sides of the street, running back to the far end
  function paintStrand(b) {
    var vx = Math.round(W / 2), GH = H - HORIZON, yTop0 = HORIZON - Math.round(HORIZON * 0.55), yBase0 = HORIZON + Math.round(GH * 0.8), xCurb = Math.round(W * 0.1);
    var cols = ['#4a2228', '#584a4e', '#58303e', '#4e3a34', '#3e3448', '#43222a', '#5a4038'], awn = ['#2e4a36', '#5a2626', '#33405e', '#5a4a26'];
    var hfs = [1, 0.82, 1.08, 0.9, 1.15, 0.86, 1.02, 0.94];
    function side(mirror, seed) {
      function F(x, y, w, h, c) { if (w <= 0 || h <= 0) return; if (mirror) x = W - x - w; b.fillStyle = c; b.fillRect(Math.round(x), Math.round(y), Math.round(w), Math.round(h)); }
      var bounds = [], x0 = 0, w0 = Math.round(W * 0.13), i = 0;
      while (x0 < vx - 3) { var w = Math.max(2, Math.round(w0 * Math.pow(0.8, i))); bounds.push([x0, Math.min(vx - 3, x0 + w), i + seed]); x0 += w; i++; }
      bounds.forEach(function (bd) {
        var xa = bd[0], xb = bd[1], j = bd[2], col = cols[j % cols.length], hf = hfs[j % hfs.length];
        for (var x = xa; x < xb; x++) {
          var d = 1 - x / vx, top = Math.round(HORIZON - (HORIZON - yTop0) * d * hf), bot = Math.round(HORIZON + (yBase0 - HORIZON) * d), hg = bot - top, f = (x - xa) / Math.max(1, xb - xa);
          if (hg < 2) continue;
          var Y = function (v) { return Math.round(top + v * hg); };
          F(x, top, 1, hg, col);
          F(x, top, 1, Math.max(1, Math.round(hg * 0.04)), '#2a1620');
          if (x === xa) { F(x, top, 1, hg, '#20141e'); continue; }
          if (hg >= 10) {
            [[0.15, 0.27], [0.44, 0.56], [0.73, 0.85]].forEach(function (wc, q) {
              if (f < wc[0] || f > wc[1]) return;
              [[0.12, 0.3], [0.38, 0.54]].forEach(function (fl, r) { var lt = ((j * 7 + q * 3 + r * 5) % 4) < 2; F(x, Y(fl[0]), 1, Math.max(1, Y(fl[1]) - Y(fl[0])), lt ? '#b07a38' : '#2a1a26'); F(x, Y(fl[0]), 1, 1, '#20141e'); });
            });
            F(x, Y(0.57), 1, Math.max(1, Y(0.6) - Y(0.57)), (x % 2) ? '#1a1020' : col);
            F(x, Y(0.6), 1, Math.max(1, Y(0.64) - Y(0.6)), '#1a1020');
            F(x, Y(0.64), 1, Math.max(1, Y(0.69) - Y(0.64)), awn[j % awn.length]);
            F(x, Y(0.72), 1, Math.max(1, Y(0.96) - Y(0.72)), (Math.abs(f - 0.33) < 0.04 || Math.abs(f - 0.66) < 0.04) ? '#20141e' : '#8a5a3a');
            if (Math.abs(f - 0.5) < 0.03 || f < 0.06) F(x, Y(0.64), 1, bot - Y(0.64), '#1a1020');
          }
        }
      });
      for (var y = HORIZON + 1; y < H; y++) {
        var xc = Math.round(vx - (vx - xCurb) * (y - HORIZON) / GH), xf = y < yBase0 ? Math.round(vx * (1 - (y - HORIZON) / (yBase0 - HORIZON))) : 0;
        if (xc > xf) { F(xf, y, xc - xf, 1, '#4a4458'); F(xc, y, 1, 1, '#8a8296'); if (y % 4 === 0) F(xf, y, xc - xf, 1, '#3e3a4c'); }
      }
      [0.2, 0.38, 0.6, 0.86].forEach(function (k) {
        var y0 = Math.round(HORIZON + GH * k), x0 = Math.round(vx - (vx - xCurb) * k) - 2, ph = Math.round(4 + k * 36);
        F(x0, y0 - ph, 1 + (k > 0.5 ? 1 : 0), ph, '#120820'); F(x0 - 1, y0 - ph - 2, 3 + (k > 0.5 ? 1 : 0), 2, '#ffd166');
      });
    }
    side(false, 0); side(true, 3);
    // a car parked along the left curb (the horse and buggy drives up and down the street, drawn every frame: drawBuggy)
    var kc = 0.55, cy = Math.round(HORIZON + GH * kc), cxl = Math.round(vx - (vx - xCurb) * kc) + 2, cw = Math.round(5 + 10 * kc), ch = Math.round(2 + 4 * kc);
    b.fillStyle = '#1e1a2a'; b.fillRect(cxl, cy - ch, cw, ch); b.fillRect(cxl + 2, cy - ch - 2, cw - 5, 2); b.fillStyle = '#ff5a7a'; b.fillRect(cxl, cy - ch + 1, 1, 1);
    return true;
  }

  // the scene for the current level sits on its own layer (in front of the sun and the logo cloud,
  // behind the play), and the Seawall and the Strand have a layer in front of the water too
  var sceneN = 0, sceneC = document.createElement('canvas'), frontC = document.createElement('canvas'), hasFront = false;
  var sceneMask = document.createElement('canvas'), frontMask = document.createElement('canvas');
  function maskOf(src, dst) {
    dst.width = src.width; dst.height = src.height;
    var x = dst.getContext('2d'); x.clearRect(0, 0, dst.width, dst.height); x.drawImage(src, 0, 0);
    x.globalCompositeOperation = 'source-in'; x.fillStyle = '#16241e'; x.fillRect(0, 0, dst.width, dst.height); x.globalCompositeOperation = 'source-over';
  }
  function paintLayers(P) {
    sceneC.width = W; sceneC.height = H; var sx = sceneC.getContext('2d'); sx.imageSmoothingEnabled = false; sx.clearRect(0, 0, W, H); paintScene(sx, sceneN, P);
    frontC.width = W; frontC.height = H; var fx = frontC.getContext('2d'); fx.imageSmoothingEnabled = false; fx.clearRect(0, 0, W, H); hasFront = paintFront(fx, sceneN, P);
    maskOf(sceneC, sceneMask); if (hasFront) maskOf(frontC, frontMask);
  }
  function setScene(n) { n = ((n % 8) + 8) % 8; if (n === sceneN) return; sceneN = n; paintBg(); }
  // the storm darkens the scene layers the same way it darkens the sky and the ground
  function tintLayer(mask, st) {
    var a1 = Math.min(0.55, st * 0.18), a2 = Math.min(0.3, st * 0.08);
    ctx.globalAlpha = a1; ctx.drawImage(mask, 0, 0, W, HORIZON, 0, 0, W, HORIZON);
    ctx.globalAlpha = a2; ctx.drawImage(mask, 0, HORIZON, W, H - HORIZON, 0, HORIZON, W, H - HORIZON);
    ctx.globalAlpha = 1;
  }
  function paintBg() {
    var P = PAL[settings.palette];
    bg.width = W; bg.height = H;
    var b = bgx;
    b.imageSmoothingEnabled = false;
    var bands = P.sky.length, bandH = HORIZON / bands;
    for (var i = 0; i < bands; i++) {
      var y0 = Math.round(i * bandH), y1 = Math.round((i + 1) * bandH);
      b.fillStyle = P.sky[i]; b.fillRect(0, y0, W, y1 - y0);
      if (i < bands - 1) { b.fillStyle = P.sky[i + 1]; for (var x = (y1 % 2); x < W; x += 2) b.fillRect(x, y1 - 1, 1, 1); }
    }
    var S = sunGeom();
    for (var yy = S.cy - S.r; yy < S.cy; yy++) {
      var dy = S.cy - yy, half = Math.floor(Math.sqrt(S.r * S.r - dy * dy));
      var frac = (yy - (S.cy - S.r)) / S.r, ci = Math.min(P.sun.length - 1, Math.floor(frac * P.sun.length));
      var gapZone = dy < S.r * 0.55, gap = gapZone ? Math.max(1, Math.round((1 - dy / (S.r * 0.55)) * 3)) : 0;
      if (gapZone && (dy % 5) < gap) continue;
      b.fillStyle = P.sun[ci]; b.fillRect(S.cx - half, yy, half * 2, 1);
    }
    b.fillStyle = P.cloud;
    [[0.08, 0.55, 0.34], [0.52, 0.7, 0.4], [0.2, 0.83, 0.26]].forEach(function (c) {
      var cy = Math.round(HORIZON * c[1]), cx = Math.round(W * c[0]), cw = Math.round(W * c[2]);
      b.fillRect(cx, cy, cw, 1); b.fillRect(cx + 4, cy - 1, cw - 10, 1); b.fillRect(cx + cw - 8, cy + 1, 10, 1);
    });
    var seaH = SAND - HORIZON;
    for (var sI = 0; sI < P.sea.length; sI++) {
      var sy0 = HORIZON + Math.round(sI * seaH / P.sea.length), sy1 = HORIZON + Math.round((sI + 1) * seaH / P.sea.length);
      b.fillStyle = P.sea[sI]; b.fillRect(0, sy0, W, sy1 - sy0);
    }
    b.fillStyle = P.sand2; b.fillRect(0, SAND, W, 2);
    b.fillStyle = P.sand; b.fillRect(0, SAND + 2, W, H - SAND - 2);
    b.fillStyle = P.sand2;
    for (var sx = 0; sx < W; sx += 7) b.fillRect(sx + ((sx * 13) % 5), SAND + 4 + ((sx * 7) % 6), 1, 1);
    paintGround(b, sceneN, P);
    paintLayers(P);
  }
  // palms sway more as the storm builds, so they are drawn every frame
  function drawPalm(col, x, y, dir, sway) {
    ctx.fillStyle = col;
    var h = Math.round(Math.min(H * 0.34, 80)), tx = x, ty = y;
    for (var i = 0; i < h; i++) {
      var k = i / h;
      tx = x + dir * Math.round(k * k * h * 0.22) + Math.round(sway * k * k * 3);
      ty = y - i;
      ctx.fillRect(tx - 1, ty, (i % 6 === 0) ? 4 : 3, 1);
    }
    var fronds = [[-1, 0.2], [-0.6, -0.35], [0.1, -0.5], [0.7, -0.3], [1, 0.25], [0.45, 0.45]];
    fronds.forEach(function (f, n) {
      var len = Math.round(h * 0.32), wob = Math.sin(G.t * (1.2 + sway * 0.4) + n) * sway;
      for (var k2 = 0; k2 < len; k2++) {
        var q = k2 / len;
        var fx = tx + Math.round(f[0] * k2 * dir + wob * q * 2.2), fy = ty + Math.round(f[1] * k2 + (k2 * k2) / (len * 1.4) + wob * q);
        ctx.fillRect(fx, fy, 2, 1);
        if (k2 % 3 === 1) ctx.fillRect(fx, fy + 1, 1, 2);
      }
    });
    ctx.fillRect(tx - 2, ty, 5, 3);
  }

  /* ================= the Von Striga logo as a pixel cloud ================= */
  // The cloud is the white part of the Von Striga logo (green outline and
  // background removed), carried inside this file, shrunk to game pixels and
  // painted as a cloud that drifts across the sky. It turns into a storm cloud
  // as the hurricane builds and lights up when lightning flashes.
  var LOGO_MASK = (window.VS_GAME && window.VS_GAME.logoMask) || '';
  var logoSrc = null, cloud = null, cloudStorm = null, cloudLit = null, cloudMode = 'wordmark';
  function loadLogo() {
    var img = new Image();
    img.onload = function () {
      try {
        var sw = 334, sh = Math.max(8, Math.round(img.naturalHeight / img.naturalWidth * sw));
        var c = document.createElement('canvas'); c.width = sw; c.height = sh;
        var x = c.getContext('2d'); x.drawImage(img, 0, 0, sw, sh);
        logoSrc = { w: sw, h: sh, d: x.getImageData(0, 0, sw, sh).data };
      } catch (e) { logoSrc = null; }
      buildCloud();
    };
    img.crossOrigin = 'anonymous';
    img.src = LOGO_MASK;
  }
  function cloudBox() { return { maxW: Math.min(Math.round(W * 0.66), 200), maxH: Math.max(20, Math.round(HORIZON * 0.42)) }; }
  function maskFromLogo(src) {
    var w = src.w, h = src.h, d = src.d, ink = new Uint8Array(w * h), minX = w, minY = h, maxX = -1, maxY = -1;
    for (var i = 0; i < w * h; i++) {
      if (d[i * 4 + 3] > 110) { ink[i] = 1; var px = i % w, py = (i / w) | 0; if (px < minX) minX = px; if (px > maxX) maxX = px; if (py < minY) minY = py; if (py > maxY) maxY = py; }
    }
    if (maxX < 0) return null;
    var bw = maxX - minX + 1, bh = maxY - minY + 1, box = cloudBox();
    var k = Math.min(box.maxW / bw, box.maxH / bh);
    var TW = Math.max(8, Math.round(bw * k)), TH = Math.max(5, Math.round(bh * k));
    var M = new Uint8Array(TW * TH);
    for (var ty = 0; ty < TH; ty++) for (var tx = 0; tx < TW; tx++) {
      var x0 = minX + Math.floor(tx / k), x1 = Math.max(x0 + 1, minX + Math.floor((tx + 1) / k));
      var y0 = minY + Math.floor(ty / k), y1 = Math.max(y0 + 1, minY + Math.floor((ty + 1) / k));
      var n = 0, on2 = 0;
      for (var yy = y0; yy < y1 && yy <= maxY; yy++) for (var xx = x0; xx < x1 && xx <= maxX; xx++) { n++; on2 += ink[yy * w + xx]; }
      M[ty * TW + tx] = n && on2 / n > 0.3 ? 1 : 0;
    }
    return { M: M, TW: TW, TH: TH };
  }
  function maskFromWordmark() {
    var sz = W >= 300 ? 4 : 3, txt = 'VON STRIGA', TW = textWidth(txt, sz), TH = 5 * sz;
    var c = document.createElement('canvas'); c.width = TW; c.height = TH;
    var x = c.getContext('2d'); drawText(x, txt, 0, 0, '#000', sz);
    var d = x.getImageData(0, 0, TW, TH).data, M = new Uint8Array(TW * TH);
    for (var i = 0; i < TW * TH; i++) M[i] = d[i * 4 + 3] > 0 ? 1 : 0;
    return { M: M, TW: TW, TH: TH };
  }
  function cloudFromMask(m, colors) {
    var TW = m.TW, TH = m.TH, M = m.M;
    var big = Math.max(3, Math.round(TH * 0.11));
    var padd = big + 4, CW = TW + padd * 2, CH = TH + padd * 2 + big;
    var Pm = new Uint8Array(CW * CH), L = new Uint8Array(CW * CH);
    function setP(x, y) { if (x >= 0 && y >= 0 && x < CW && y < CH) Pm[y * CW + x] = 1; }
    function disc(cx, cy, r) { for (var yy = -r; yy <= r; yy++) for (var xx = -r; xx <= r; xx++) if (xx * xx + yy * yy <= r * r + r) setP(cx + xx, cy + yy); }
    for (var y = 0; y < TH; y++) for (var x = 0; x < TW; x++) if (M[y * TW + x]) {
      L[(y + padd) * CW + x + padd] = 1;
      for (var dy = -2; dy <= 2; dy++) for (var dx = -2; dx <= 2; dx++) if (dx * dx + dy * dy <= 6) setP(x + padd + dx, y + padd + dy);
    }
    var rnd = seeded(11);
    function edgeY(x0, fromBottom) {
      for (var k = 0; k < TH; k++) {
        var yy = fromBottom ? TH - 1 - k : k;
        for (var xx = Math.max(0, x0 - 2); xx <= Math.min(TW - 1, x0 + 2); xx++) if (M[yy * TW + xx]) return yy;
      }
      return -1;
    }
    for (var bx = 1; bx < TW; bx += 3 + Math.floor(rnd() * 3)) { var yb = edgeY(bx, true); if (yb < 0) continue; var r = Math.max(2, Math.round(big * (0.55 + rnd() * 0.6))); disc(bx + padd, yb + padd + Math.round(r * 0.35), r); }
    for (var tx = 2; tx < TW; tx += 6 + Math.floor(rnd() * 5)) { var yt = edgeY(tx, false); if (yt < 0) continue; disc(tx + padd, yt + padd + 1, Math.max(2, Math.round(big * (0.3 + rnd() * 0.3)))); }
    var c = document.createElement('canvas'); c.width = CW; c.height = CH;
    var cx = c.getContext('2d'), img = cx.createImageData(CW, CH), D = img.data;
    var C = { shadow: hex2rgb(colors.shadow), body: hex2rgb(colors.body), light: hex2rgb(colors.light), ink: hex2rgb(colors.ink), inkHi: hex2rgb(colors.inkHi) };
    for (var i = 0; i < CW * CH; i++) {
      if (!Pm[i]) continue;
      var X = i % CW, Y = (i / CW) | 0, chk = (X + Y) & 1;
      var up = Y > 0 && Pm[i - CW], up2 = Y > 1 && Pm[i - 2 * CW], down = Y < CH - 1 && Pm[i + CW], down2 = Y < CH - 2 && Pm[i + 2 * CW];
      var col;
      if (L[i]) col = (Y > 0 && !L[i - CW]) ? C.inkHi : C.ink;
      else if (!up) col = C.light; else if (!up2 && chk) col = C.light; else if (!down) col = C.shadow; else if (!down2 && chk) col = C.shadow; else col = C.body;
      D[i * 4] = col[0]; D[i * 4 + 1] = col[1]; D[i * 4 + 2] = col[2]; D[i * 4 + 3] = 255;
    }
    cx.putImageData(img, 0, 0);
    return c;
  }
  function buildCloud() {
    var m = logoSrc ? maskFromLogo(logoSrc) : null;
    cloudMode = m ? 'logo' : 'wordmark';
    if (!m) m = maskFromWordmark();
    cloud = cloudFromMask(m, PAL[settings.palette].logoCloud);
    cloudStorm = cloudFromMask(m, STORM_CLOUD);
    cloudLit = cloudFromMask(m, LIT_CLOUD);
  }
  function drawCloud(P) {
    if (!cloud) return;
    var span = W + cloud.width + 30, speed = span / 80;
    var x = Math.round(((G.t * speed + W * 0.3) % span) - cloud.width - 15);
    var sun = sunGeom();
    var y = Math.max(22, Math.round(HORIZON - sun.r * 0.45 - cloud.height));
    var k = clamp(G.storm.cur - 1, 0, 1);
    ctx.globalAlpha = P.logoCloud.alpha * (1 - k); if (k < 1) ctx.drawImage(cloud, x, y);
    ctx.globalAlpha = 0.9 * k; if (k > 0) ctx.drawImage(cloudStorm, x, y);
    if (G.skyFlash > 0) { ctx.globalAlpha = clamp(G.skyFlash * 4, 0, 1); ctx.drawImage(cloudLit, x, y); }
    ctx.globalAlpha = 1;
  }

  /* ================= firing and power-ups ================= */
  function guns() { var g = [G.ship.x]; if (G.pw.twinT > 0) g.push(G.ship.x + TWIN_DX); return g; }
  function canPlay() { return G.state === 'play' && !G.paused && !G.ambientOnly && G.phase !== 'pierEnd'; }
  function fire() {
    if (!canPlay() || !G.ship.alive) return false;
    var pw = G.pw;
    var volleys = 4 + (pw.rapidT > 0 ? 3 : 0);
    var spread = pw.fanT > 0 ? (pw.fan >= 2 ? [-0.5, -0.25, 0, 0.25, 0.5] : [-0.26, 0, 0.26]) : [0];
    var gunList = guns(), per = spread.length * gunList.length;
    if (G.shots.length + per > volleys * per) return false;
    var laser = pw.laserT > 0, speed = laser ? 270 : 220;
    gunList.forEach(function (gx) { spread.forEach(function (a) { G.shots.push({ x: gx + TIP_DX, y: G.ship.y - 14, vx: Math.sin(a) * speed, vy: -Math.cos(a) * speed, laser: laser, hit: laser ? {} : null }); }); });
    G.muzzle = 0.07;
    G.fired++;
    if (laser) SFX.laser(); else SFX.shot();
    buzz(5);
    return true;
  }
  function fireRate() { return G.pw.rapidT > 0 ? 0.1 : 0.2; }
  function pressFire() { G.holding = true; if (G.fireCd <= 0 && fire()) G.fireCd = fireRate(); }
  function addScore(n) { G.score += n; if (G.score > G.hi) G.hi = G.score; }
  function ring(x, y, max, color, life) { G.rings.push({ x: x, y: y, max: max, c: color, life: life || 0.3, t: 0 }); }
  function explode(x, y, colors, n, spd) {
    for (var i = 0; i < n; i++) {
      var a = Math.random() * 6.283, sp = (spd || 1) * (20 + Math.random() * 55);
      G.parts.push({ x: x, y: y, vx: Math.cos(a) * sp, vy: Math.sin(a) * sp, life: 0.35 + Math.random() * 0.45, c: colors[i % colors.length] });
    }
  }
  function pop(x, y, txt, color, size) { G.pops.push({ x: x, y: y, txt: txt, c: color || '#ffd166', life: 0.9, s: size || 1 }); }
  function spriteOf(kind) { return SPRITES[kind]; }
  function sparkle(x, y, colors, n) {
    for (var i = 0; i < n; i++) { var a = Math.random() * 6.283, sp = 12 + Math.random() * 30; G.parts.push({ x: x, y: y, vx: Math.cos(a) * sp, vy: Math.sin(a) * sp - 10, life: 0.3 + Math.random() * 0.3, c: colors[i % colors.length] }); }
  }
  function damage(e, n, viaBomb) {
    if (e.mode === 'dead') return false;
    var before = e.hp;
    e.hp -= n;
    if (e.hp > 0) {
      // one step closer to a clean tattoo: bad, then brighter, then your clean flash
      e.flash = 0.08;
      addScore(10 * (before - e.hp));
      if (isTattoo(e.kind)) sparkle(e.x, e.y, ['#ffffff', '#ffd166', kindColors(e.kind)[0]], 6);
      if (!viaBomb) SFX.hit();
      return false;
    }
    var diving = e.mode === 'dive' || e.mode === 'free';
    var pts = (KIND[e.kind] ? KIND[e.kind][0] : 50) * (diving ? 2 : 1);
    if (G.phase === 'pier') { G.pier.hits++; pts = 100; }
    G.combo = G.comboT > 0 ? G.combo + 1 : 1;
    G.comboT = 1.1;
    addScore(pts + (G.combo >= 3 ? G.combo * 20 : 0));
    e.mode = 'dead';
    G.kills++;
    var spr = spriteOf(e.kind);
    if (spr && isTattoo(e.kind)) {
      // saved: the clean tattoo lifts off the skin in a sparkle and fades away
      G.covers.push({ x: e.x, y: e.y, img: spr.clean[0], fl: spr.flash[0], t: 0, life: 0.9 });
      sparkle(e.x, e.y, ['#ffffff', '#ffd166', '#7fd06a', kindColors(e.kind)[0]], 16);
      ring(e.x, e.y, 12, '#ffd166', 0.3);
    } else {
      explode(e.x, e.y, kindColors(e.kind).concat(['#ffffff']), 14);
      ring(e.x, e.y, 10, kindColors(e.kind)[0], 0.25);
    }
    if (G.combo === 3 || G.combo === 5 || (G.combo >= 10 && G.combo % 5 === 0)) { pop(e.x, e.y - 8, 'X' + G.combo + ' COMBO', '#ff5a7a'); SFX.combo(Math.min(G.combo, 12)); }
    else if (isTattoo(e.kind) && G.combo < 3) pop(e.x, e.y - 8, 'SAVED', '#7fd06a');
    else if (G.combo < 6) pop(e.x, e.y - 8, String(pts));
    if (!viaBomb) { SFX.pop(); buzz(12); }
    if (FX[settings.fx].shake) G.shake = Math.max(G.shake, 0.08);
    if (G.phase !== 'pier') maybeDrop(e, diving);
    return true;
  }
  function pickPower() {
    var list = DROPS.filter(function (d) { return d[0] !== 'life' || G.lives < 5; });
    var total = list.reduce(function (a, d) { return a + d[1]; }, 0), r = Math.random() * total;
    for (var i = 0; i < list.length; i++) { r -= list[i][1]; if (r <= 0) return list[i][0]; }
    return 'fan';
  }
  function spawnCap(x, y, kind) { G.caps.push({ x: x, y: y, kind: kind, t: 0 }); }
  function maybeDrop(e, diving) {
    if (!G.firstDrop && G.kills >= 5) { G.firstDrop = true; spawnCap(e.x, e.y, 'fan'); return; }
    if (G.caps.length >= 2) return;
    var chance = 0.07 + (diving ? 0.05 : 0) + ((KIND[e.kind] && KIND[e.kind][0] >= 130) ? 0.12 : 0);
    if (Math.random() < chance) spawnCap(e.x, e.y, pickPower());
  }
  function clampShip(x) { return Math.max(8, Math.min(W - 8 - (G.pw.twinT > 0 ? TWIN_DX : 0), x)); }
  function clampShipY(y) { return Math.max(SHIP_TOP, Math.min(SHIP_Y, y)); }
  /* bombs go in the bag on the side and only go off when you tap them */
  var BOMB_KINDS = ['b409', 'ibc', 'boi'], BAG_MAX = 3;
  function useBomb(i) {
    if (!canPlay() || !(i >= 0 && i < G.bag.length)) return false;
    var kind = G.bag.splice(i, 1)[0], def = POWER[kind];
    G.announce = { txt: def.label, sub: def.sub || '', c: def.color, t: 1.7 };
    G.flash = Math.max(G.flash, 0.35);
    if (kind === 'b409') G.bombs.push({ x: G.ship.x, y: G.ship.y - 10, vy: -150, t: 0 });
    if (kind === 'ibc') launchSeekers();
    if (kind === 'boi') { G.tide = { y: H + 6, hitBoss: false, done: {} }; G.eshots = []; SFX.wave(); }
    SFX.power(); buzz([30, 30, 60], true);
    renderBag();
    return true;
  }
  var bagEl = document.getElementById('bombBag');
  function renderBag() {
    if (!bagEl) return;
    bagEl.innerHTML = '';
    G.bag.forEach(function (kind, i) {
      var spr = SPRITES.capsules && SPRITES.capsules[kind]; if (!spr) return;
      var b = document.createElement('button');
      b.type = 'button'; b.className = 'bomb-slot'; b.setAttribute('data-buzz', '');
      b.setAttribute('aria-label', 'Use the ' + POWER[kind].label.toLowerCase() + (touchSeen ? '' : ', key ' + (i + 1)));
      var c = document.createElement('canvas'); c.width = spr.width; c.height = spr.height; c.getContext('2d').drawImage(spr, 0, 0);
      c.style.width = (spr.gw * SCALE) + 'px'; c.style.height = (spr.gh * SCALE) + 'px';
      b.appendChild(c);
      b.addEventListener('click', function () { useBomb(i); });
      bagEl.appendChild(b);
    });
    bagEl.hidden = G.bag.length === 0;
  }
  function placeBag() { if (bagEl) bagEl.style.bottom = Math.round((H - SHIP_Y + 18) * SCALE) + 'px'; }
  function collect(kind) {
    var p = G.pw, def = POWER[kind], label = def.label;
    if (BOMB_KINDS.indexOf(kind) !== -1) {
      if (G.bag.length >= BAG_MAX) { addScore(500); G.announce = { txt: 'BOMB BAG FULL', sub: '+500', c: def.color, t: 1.6 }; }
      else { G.bag.push(kind); addScore(100); G.announce = { txt: def.label + ' SAVED', sub: VS_CABINET ? 'PRESS SPECIAL TO USE IT' : touchSeen ? 'TAP IT TO USE IT' : 'CLICK IT OR PRESS ' + G.bag.length, c: def.color, t: 2.2 }; renderBag(); }
      ring(G.ship.x, G.ship.y, 18, def.color, 0.35);
      SFX.power(); buzz([20, 30, 45]);
      return;
    }
    if (kind === 'fan') { p.fan = Math.min(2, (p.fanT > 0 ? p.fan : 0) + 1); p.fanT = def.time; if (p.fan === 2) label = 'FAN SHOT MAX'; }
    else if (kind === 'rapid') p.rapidT = def.time;
    else if (kind === 'laser') p.laserT = def.time;
    else if (kind === 'beads') { p.beadsT = 999; p.beadsHits = BEADS_HITS; }
    else if (kind === 'twin') { p.twinT = def.time; G.ship.x = clampShip(G.ship.x); }
    else if (kind === 'life') G.lives = Math.min(5, G.lives + 1);
    addScore(100);
    G.announce = { txt: label, sub: def.sub || '', c: def.color, t: 1.7 };
    G.flash = Math.max(G.flash, 0.35);
    ring(G.ship.x, G.ship.y, 18, def.color, 0.35);
    explode(G.ship.x, G.ship.y - 4, [def.color, '#ffffff'], 18);
    SFX.power(); buzz([20, 30, 45]);
  }
  function targetsList() {
    var out = [];
    G.enemies.forEach(function (e) { if (e.mode !== 'dead' && e.mode !== 'enter' && e.y > -6) out.push({ e: e, x: e.x, y: e.y }); });
    if (G.boss && G.phase === 'boss') bossBoxes(G.boss).forEach(function (bx) { if (bx.type !== 'armor') out.push({ boss: true, part: bx.part, x: bx.x + bx.w / 2, y: bx.y + bx.h / 2 }); });
    return out;
  }
  function launchSeekers() {
    var t = targetsList();
    t.sort(function (a, b) { return Math.abs(a.x - G.ship.x) - Math.abs(b.x - G.ship.x); });
    for (var i = 0; i < 6; i++) {
      var a = -Math.PI / 2 + (i - 2.5) * 0.35;
      G.seekers.push({ x: G.ship.x, y: G.ship.y - 8, vx: Math.cos(a) * 90, vy: Math.sin(a) * 90, tg: t.length ? t[i % t.length] : null, life: 2.6 });
    }
  }
  function blast(x, y, r, dmg, bossDmg, color) {
    G.enemies.forEach(function (e) { if (e.mode !== 'dead' && Math.hypot(e.x - x, e.y - y) < r) damage(e, dmg, true); });
    if (G.boss && G.phase === 'boss') {
      var hitParts = {};
      bossBoxes(G.boss).forEach(function (bx) {
        var nx = clamp(x, bx.x, bx.x + bx.w), ny = clamp(y, bx.y, bx.y + bx.h);
        if (Math.hypot(nx - x, ny - y) < r && !hitParts[bx.part]) { hitParts[bx.part] = 1; bossDamage(bossDmg, bx.part, true); }
      });
    }
    ring(x, y, r, color || '#ffd166', 0.45);
    explode(x, y, [color || '#ffd166', '#ffffff', '#ff8a3d'], 22, 1.4);
  }
  function hitShip() {
    if (G.pw.beadsT > 0) {
      G.pw.beadsHits = Math.max(0, (G.pw.beadsHits || 1) - 1);
      G.ship.inv = 1.2;
      ring(G.ship.x, G.ship.y, 18, '#b08aff', 0.4);
      if (G.pw.beadsHits <= 0) {
        G.pw.beadsT = 0;
        explode(G.ship.x, G.ship.y, ['#b08aff', '#f5c542', '#3fa34d'], 20);
        G.announce = { txt: 'BEADS BROKE', sub: '', c: '#b08aff', t: 1 };
      } else {
        explode(G.ship.x, G.ship.y, ['#b08aff', '#f5c542', '#3fa34d'], 8);
        G.announce = { txt: 'BEADS HIT', sub: G.pw.beadsHits + (G.pw.beadsHits === 1 ? ' HIT LEFT' : ' HITS LEFT'), c: '#b08aff', t: 1 };
      }
      SFX.block(); buzz(30);
      return;
    }
    killShip();
  }
  function hitTwin() {
    if (G.pw.beadsT > 0) { hitShip(); return; }
    var x = G.ship.x + TWIN_DX;
    G.pw.twinT = 0;
    explode(x, G.ship.y, ['#f5c542', '#f4ead6', '#ffffff'], 18);
    ring(x, G.ship.y, 12, '#ffa04a', 0.3);
    G.announce = { txt: 'TWIN DOWN', sub: '', c: '#ffa04a', t: 1 };
    SFX.pop(); buzz([25, 30, 25]);
  }
  function killShip() {
    var s = G.ship;
    explode(s.x, s.y, ['#f5c542', '#f4ead6', '#d7263d', '#ffffff'], 26);
    G.shake = 0.5;
    G.eshots = [];
    SFX.die();
    buzz([40, 50, 70]);
    if (settings.practice === 'on') { s.inv = 1.5; pop(s.x, s.y - 14, 'PRACTICE', '#7fd06a'); return; }
    s.alive = false; s.respawn = 1.6;
    G.lives--;
    G.pw = freshPw(); G.caps = [];
  }

  /* ================= bosses ================= */
  var BOSS_HP = [45, 55, 60, 70, 75, 90, 95, 110];   // by level
  function startBossIntro() {
    G.enemies = []; G.banner = null;
    G.phase = G.storm.target >= 2 && bossIndexFor(G.level) === 7 ? 'eye' : 'warning';
    G.phaseT = G.phase === 'eye' ? 2.8 : 2.6;
    if (G.phase === 'warning') SFX.siren();
  }
  function startBoss() {
    var i = bossIndexFor(G.level), def = BOSSES[i], cyc = 0;
    var hp = BOSS_HP[clamp(G.level, 1, LAST_LEVEL) - 1];
    // big bosses shrink on short screens so there is always room to dodge
    var k = Math.min(1, (SHIP_Y - 44) / def.h, (W - 6) / def.w), w = def.w * k, h = def.h * k;
    var b = { def: def, i: i, key: def.key, w: w, h: h, x: W / 2, y: -h - 4, ty: Math.max(4, Math.min(30, SHIP_Y - 30 - h)), hp: hp, maxHp: hp, t: 0, st: 'enter', stT: 0, flash: 0, dir: 1, m: 1 + cyc * 0.35, cd: {}, swallow: 0, spin: 0 };
    if (def.key === 'palms') b.crowns = [0, 1].map(function () { var q = Math.round(hp / 2); return { hp: q, max: q, alive: true, cd: 1 + Math.random() }; });
    if (def.key === 'ship') { var s3 = Math.round(hp * 0.2); b.sailHp = [s3, s3, s3]; b.hullHp = hp - s3 * 3; }
    if (def.key === 'shark') { b.st = 'fin'; b.stT = 2.0; b.y = HORIZON; b.x = -20; b.dir = 1; }
    G.boss = b;
    G.phase = 'boss';
  }
  function bossW(b) { return b.w; }
  function bossH(b) { return b.h; }
  function bossX0(b) { return b.x - b.w / 2; }
  function facingLeft(b) { return !!b.def.faces && b.dir < 0; }
  // a point given as fractions of the boss picture, in game pixels (mirrored when it faces left)
  function bossPt(b, fx, fy) { if (facingLeft(b)) fx = 1 - fx; return [bossX0(b) + fx * b.w, b.y + fy * b.h]; }
  function fbox(b, f, type, part) {
    var a = f[0], c = f[2];
    if (facingLeft(b)) { a = 1 - f[2]; c = 1 - f[0]; }
    return { x: bossX0(b) + a * b.w, y: b.y + f[1] * b.h, w: (c - a) * b.w, h: (f[3] - f[1]) * b.h, type: type, part: part || 0 };
  }
  function sailsUp(b) { return b.sailHp.some(function (v) { return v > 0; }); }
  // hit areas: 'hit' takes damage, 'armor' bounces shots, 'mouth' swallows them
  function bossBoxes(b) {
    var out = [], d = b.def;
    if (b.st === 'enter' && b.y < 0) return out;
    if (b.key === 'shark' && b.st !== 'leap') return out;
    if (b.key === 'turtle' && b.st === 'spin') { out.push(fbox(b, [0.15, 0.15, 0.85, 0.85], 'armor')); return out; }
    if (b.key === 'shrimp' && b.st === 'ball') { out.push(fbox(b, [0.15, 0.15, 0.85, 0.85], 'hit')); return out; }
    if (b.key === 'palms') {
      b.crowns.forEach(function (c, k) { if (c.alive) out.push(fbox(b, d.crowns[k], 'hit', k)); });
      d.trunks.forEach(function (t) { out.push(fbox(b, t, 'armor', 9)); });
      return out;
    }
    if (b.key === 'ship') {
      // the ghost hull cannot be touched until all three sails are down
      d.sails.forEach(function (f, k) { if (b.sailHp[k] > 0) out.push(fbox(b, f, 'hit', k)); });
      if (!sailsUp(b)) out.push(fbox(b, d.hull, 'hit', 3));
      return out;
    }
    d.boxes.forEach(function (f) { var type = f[0]; if (type === 'jaw') type = b.st === 'open' ? 'mouth' : 'hit'; out.push(fbox(b, f.slice(1), type)); });
    return out;
  }
  function bossDamage(n, part, viaBomb) {
    var b = G.boss;
    if (!b || G.phase !== 'boss') return;
    var d = b.def, p, f;
    if (b.key === 'palms') {
      var c = b.crowns[part]; if (!c || !c.alive) return;
      c.hp -= n;
      if (c.hp <= 0) {
        c.alive = false; f = d.eyes[part]; p = bossPt(b, (f[0] + f[2]) / 2, (f[1] + f[3]) / 2);
        explode(p[0], p[1], ['#7fd06a', '#2fff9a', '#ffffff'], 30, 1.3); ring(p[0], p[1], 26, '#7fd06a', 0.5); pop(p[0], p[1] - 10, 'LIGHTS OUT', '#7fd06a'); SFX.bossDie(); addScore(1500);
        if ((b.captive && b.captive.k === part) || (G.capture && G.capture.k === part)) freeCaptive(b, part);
      }
      b.hp = b.crowns.reduce(function (a, q) { return a + Math.max(0, q.hp); }, 0);
    } else if (b.key === 'ship') {
      if (part < 3) {
        if (b.sailHp[part] <= 0) return;
        b.sailHp[part] -= n;
        if (b.sailHp[part] <= 0) { f = d.sails[part]; p = bossPt(b, (f[0] + f[2]) / 2, (f[1] + f[3]) / 2); explode(p[0], p[1], ['#2fff9a', '#4a4a5e', '#ffffff'], 30, 1.3); pop(p[0], p[1], 'SAIL DOWN', '#2fff9a'); SFX.bossDie(); addScore(1500); }
      } else { if (sailsUp(b)) return; b.hullHp -= n; }
      b.hp = b.sailHp.reduce(function (a, v) { return a + Math.max(0, v); }, 0) + Math.max(0, b.hullHp);
    } else b.hp -= n;
    b.flash = 0.08;
    if (!viaBomb) SFX.hit();
    if (b.hp <= 0) bossDie();
  }
  function bossDie() {
    var b = G.boss;
    G.phase = 'bossDeath'; G.phaseT = 2.6;
    var bonus = 5000 * clamp(G.level, 1, LAST_LEVEL);
    addScore(bonus);
    G.bossBonus = bonus;
    G.eshots = [];
    SFX.bossDie(); buzz([60, 40, 60, 40, 120]);
    G.announce = { txt: 'BOSS DOWN', sub: '+' + bonus, c: '#ffd166', t: 2.4 };
  }
  function eshot(x, y, vx, vy, kind) { if (G.eshots.length < 60) G.eshots.push({ x: x, y: y, vx: vx, vy: vy, k: kind || 'ink' }); }
  function aimAt(x, y, speed) { var dx = G.ship.x - x, dy = G.ship.y - y, d = Math.max(1, Math.hypot(dx, dy)); return [dx / d * speed, dy / d * speed]; }
  function every(b, key, period, dt) { b.cd[key] = (b.cd[key] == null ? period * 0.6 : b.cd[key]) - dt; if (b.cd[key] <= 0) { b.cd[key] = period; return true; } return false; }
  function updateBoss(dt) {
    var b = G.boss; if (!b) return;
    b.t += dt; if (b.flash > 0) b.flash -= dt;
    var w = b.w, h = b.h, m = b.m, s = G.ship, d = b.def, pt;
    if (b.st === 'enter') {
      b.y += 40 * dt;
      if (b.y >= b.ty) { b.y = b.ty; b.st = 'fight'; }
      return;
    }
    var swing = Math.max(0, W / 2 - w / 2 - 4);
    function glide(speed) { var nx = W / 2 + Math.sin(b.t * speed * m) * swing; if (Math.abs(nx - b.x) > 0.01) b.dir = nx > b.x ? 1 : -1; b.x = nx; }
    switch (b.key) {
      case 'gull':
        if (b.st === 'dive') {
          b.stT -= dt; var k = 1 - Math.abs(b.stT / 1.8 * 2 - 1);
          b.y = b.ty + k * Math.max(0, SHIP_Y - h * 0.8 - b.ty); var gx = (b.tx - b.x) * dt * 2; if (Math.abs(gx) > 0.01) b.dir = gx > 0 ? 1 : -1; b.x += gx;
          if (b.stT <= 0) { b.st = 'fight'; b.y = b.ty; }
        } else {
          glide(0.7); b.y = b.ty + Math.sin(b.t * 2) * 3;
          if (every(b, 'feather', 1.5 / m, dt)) { pt = bossPt(b, d.beak[0], d.beak[1]); for (var i = -2; i <= 2; i++) { var a = Math.PI / 2 + i * 0.3; eshot(pt[0], pt[1], Math.cos(a) * 58 * m, Math.sin(a) * 58 * m, 'feather'); } }
          if (every(b, 'dive', 6 / m, dt)) { b.st = 'dive'; b.stT = 1.8; b.tx = s.x; SFX.gull(); }
        }
        for (var c = G.caps.length - 1; c >= 0; c--) { var cp = G.caps[c]; if (Math.abs(cp.x - b.x) < w * 0.4 && cp.y > b.y && cp.y < b.y + h) { G.caps.splice(c, 1); pop(cp.x, cp.y, 'STOLEN!', '#ff5a7a'); SFX.gull(); } }
        break;
      case 'crab':
        if (b.st === 'fight') {
          if (b.tx == null || Math.abs(b.tx - b.x) < 2) { b.waitT = (b.waitT || 0) - dt; if (b.waitT <= 0) { b.tx = W / 2 + (Math.random() * 2 - 1) * swing; b.waitT = 0.6 / m; } }
          b.x += clamp(b.tx - b.x, -46 * m * dt, 46 * m * dt);
          b.y = b.ty + (Math.floor(b.t * 6) % 2 ? 0.5 : 0);
          if (every(b, 'lunge', 5.5 / m, dt)) { b.st = 'tele'; b.stT = 0.8; }
        }
        if (b.st !== 'lunge' && every(b, 'bubbles', 1.3 / m, dt)) { pt = bossPt(b, d.mouth[0], d.mouth[1]); for (var q = -2; q <= 2; q++) { var aa = Math.PI / 2 + q * 0.32; eshot(pt[0], pt[1], Math.cos(aa) * 46 * m, Math.sin(aa) * 46 * m, 'bubble'); } }
        if (b.st === 'tele') { b.stT -= dt; if (b.stT <= 0) { b.st = 'lunge'; b.stT = 1.3; } }
        if (b.st === 'lunge') {
          b.stT -= dt; var kk = 1 - Math.abs(b.stT / 1.3 * 2 - 1);
          b.y = b.ty + kk * Math.max(0, SHIP_Y + 6 - h - b.ty);
          if (b.stT <= 0) { b.st = 'fight'; b.y = b.ty; b.tx = null; }
        }
        break;
      case 'shrimp':
        if (b.st === 'fight' || b.st === 'swim') {
          b.st = 'swim'; glide(0.9); b.y = b.ty + Math.sin(b.t * 1.7) * 6;
          if (every(b, 'burst', 1.1 / m, dt)) { pt = bossPt(b, d.head[0], d.head[1]); for (var z = 0; z < 3; z++) { var v = aimAt(pt[0], pt[1], 70 * m); eshot(pt[0], pt[1], v[0] + (z - 1) * 18, v[1], 'ink'); } }
          if (every(b, 'curl', 6, dt)) { b.st = 'ball'; b.stT = 6; b.vx = 70 * m; b.vy = 60 * m; }
        } else if (b.st === 'ball') {
          b.stT -= dt; b.spin += dt * 10; b.x += b.vx * dt; b.y += b.vy * dt;
          var r0 = Math.min(w, h) * 0.4;
          if (b.x < r0 || b.x > W - r0) { b.vx *= -1; b.x = clamp(b.x, r0, W - r0); }
          if (b.y < 6 || b.y > SHIP_Y - 46 - h * 0.6) { b.vy *= -1; b.y = clamp(b.y, 6, Math.max(6, SHIP_Y - 46 - h * 0.6)); }
          if (every(b, 'ring', 1.4 / m, dt)) for (var rr = 0; rr < 8; rr++) { var ar = rr * Math.PI / 4 + b.t; eshot(b.x, b.y + h / 2, Math.cos(ar) * 52 * m, Math.sin(ar) * 52 * m, 'ink'); }
          if (b.stT <= 0) { b.st = 'swim'; b.y = b.ty; b.spin = 0; }
        }
        break;
      case 'turtle':
        if (b.st === 'spin') {
          b.stT -= dt; var ks = 1 - Math.abs(b.stT / 2.4 * 2 - 1);
          b.y = b.ty + ks * Math.max(0, SHIP_Y + 4 - h - b.ty); b.x += (b.tx - b.x) * dt * 1.5; b.spin += dt * 14;
          if (b.stT <= 0) { b.st = 'fight'; b.y = b.ty; b.spin = 0; }
        } else {
          glide(0.6); b.y = b.ty + Math.sin(b.t * 1.4) * 4;
          if (every(b, 'triple', 1.3 / m, dt)) { pt = bossPt(b, d.head[0], d.head[1]); for (var tq = -1; tq <= 1; tq++) { var v2 = aimAt(pt[0], pt[1], 72 * m); eshot(pt[0], pt[1], v2[0] + tq * 22, v2[1], 'ink'); } }
          if (every(b, 'spin', 7 / m, dt)) { b.st = 'spin'; b.stT = 2.4; b.tx = s.x; }
        }
        break;
      case 'shark':
        if (b.st === 'fin') {
          b.stT -= dt; b.x += b.dir * 70 * m * dt; b.y = HORIZON + 2;
          if (!b.calledPups) { b.calledPups = true; for (var p2 = 0; p2 < 2 + Math.floor(m); p2++) { var px0 = 20 + Math.random() * (W - 40); G.enemies.push({ id: G.nextId++, kind: 'babyShark', free: true, x: px0, y: -10 - p2 * 20, vx: (G.ship.x > px0 ? 1 : -1) * 18, vy: 50 * m, mode: 'free', hp: 1, flash: 0, t: 0 }); } }
          if (b.stT <= 0 || b.x < -30 || b.x > W + 30) { b.st = 'leap'; b.stT = 3.0; b.x0 = clamp(b.x, 20, W - 20); b.x1 = clamp(W - b.x0 + (Math.random() - 0.5) * 40, 20, W - 20); b.dir = b.x1 > b.x0 ? 1 : -1; b.teeth = 0; }
        } else if (b.st === 'leap') {
          b.stT -= dt; var kl = 1 - b.stT / 3.0;
          b.x = b.x0 + (b.x1 - b.x0) * kl; b.y = HORIZON - h * 0.6 - Math.sin(kl * Math.PI) * Math.max(0, HORIZON - h * 0.6 - 4);
          if (kl > 0.3 * (b.teeth + 1) && b.teeth < 3) { b.teeth++; pt = bossPt(b, d.jaw[0], d.jaw[1]); for (var tt = -1; tt <= 1; tt++) eshot(pt[0], pt[1], tt * 24, 80 * m, 'tooth'); }
          if (b.stT <= 0) { b.st = 'fin'; b.stT = 2.0; b.dir = -b.dir; b.calledPups = false; explode(b.x, HORIZON, ['#ffffff', '#5fa3ef'], 18); }
        }
        break;
      case 'gator':
        if (b.st !== 'tail') { glide(0.5); b.y = b.ty + Math.sin(b.t * 1.2) * 2; }
        if (b.st === 'fight' && every(b, 'mouth', 4.5 / m, dt)) { b.st = 'open'; b.stT = 1.8; b.swallow = 0; }
        if (b.st === 'open') {
          b.stT -= dt;
          if (b.stT <= 0) {
            b.st = 'fight'; var n2 = clamp(b.swallow, 3, 14); pt = bossPt(b, d.mouth[0], d.mouth[1]);
            for (var sp = 0; sp < n2; sp++) { var as = Math.PI / 2 + (sp - (n2 - 1) / 2) * 0.16; eshot(pt[0], pt[1], Math.cos(as) * 75 * m, Math.sin(as) * 75 * m, 'ink'); }
            if (b.swallow) pop(pt[0], pt[1] + 10, 'SPIT!', '#7fd06a');
          }
        }
        if (b.st === 'fight' && every(b, 'tail', 7.5 / m, dt)) { b.st = 'tele'; b.stT = 0.9; b.side = s.x < W / 2 ? 0 : 1; }
        if (b.st === 'tele') { b.stT -= dt; if (b.stT <= 0) { b.st = 'tail'; b.stT = 0.6; } }
        if (b.st === 'tail') { b.stT -= dt; var x0 = b.side ? W / 2 : 0; if (s.alive && s.inv <= 0 && s.x >= x0 && s.x <= x0 + W / 2 && s.y > SHIP_Y - 18) hitShip(); if (b.stT <= 0) b.st = 'fight'; }
        break;
      case 'palms':
        b.x = W / 2 + Math.sin(b.t * 0.4 * m) * swing; b.y = b.ty + Math.sin(b.t * 1.3) * 3;
        b.crowns.forEach(function (c, k) {
          if (!c.alive) return;
          c.cd -= dt;
          if (c.cd <= 0) { c.cd = 2.2 / m + Math.random(); var e = d.eyes[k], q = bossPt(b, (e[0] + e[2]) / 2, e[3]); G.eshots.push({ x: q[0], y: q[1], vx: (Math.random() * 2 - 1) * 30, vy: -40, k: 'coconut', g: 70, life: 1.7 }); }
        });
        if (!b.beam && every(b, 'beam', 8 / m, dt)) { var alive = b.crowns.map(function (c, k) { return c.alive && !(b.captive && b.captive.k === k) && !(G.capture && G.capture.k === k) ? k : -1; }).filter(function (k) { return k >= 0; }); if (alive.length) b.beam = { k: alive[Math.floor(Math.random() * alive.length)], t: 2.3 }; }
        if (b.beam) {
          b.beam.t -= dt; var bxx = beamX(b);
          if (b.beam.t < 1.8 && G.pw.twinT > 0 && Math.abs(G.ship.x + TWIN_DX - bxx) < 9) { G.pw.twinT = 0; G.announce = { txt: 'TWIN ABDUCTED', sub: '', c: '#7fd06a', t: 1.4 }; explode(G.ship.x + TWIN_DX, G.ship.y, ['#7fd06a', '#ffffff'], 16); }
          // Galaga style: the beam can grab your ship too. Shoot that palm to get it back as a twin.
          var btop = holdY(b), bhw = 3 + Math.max(0, s.y - btop) / Math.max(1, SAND - btop) * 7;
          if (b.beam.t < 1.8 && !b.captive && !G.capture && s.alive && s.inv <= 0 && s.y > btop + 6 && Math.abs(s.x - bxx) < bhw + 2) captureShip(b);
          if (b.beam.t <= 0 || !b.crowns[b.beam.k].alive) b.beam = null;
        }
        break;
      case 'ship':
        b.x = W / 2 + Math.sin(b.t * 0.35 * m) * Math.max(0, W / 2 - w / 2 - 2); b.y = b.ty + Math.sin(b.t * 1.1) * 2;
        if (every(b, 'broadside', 2.4 / m, dt)) b.volley = { n: 0, t: 0 };
        if (b.volley) { b.volley.t -= dt; if (b.volley.t <= 0) { var fx = d.ports[0] + (d.ports[1] - d.ports[0]) * b.volley.n / 5; pt = bossPt(b, fx, d.ports[2]); var v3 = aimAt(pt[0], pt[1], 64 * m); eshot(pt[0], pt[1], v3[0] * 0.4, v3[1], 'cannon'); b.volley.n++; b.volley.t = 0.12; if (b.volley.n >= 6) b.volley = null; } }
        if (every(b, 'crew', 5 / m, dt)) [-1, 1].forEach(function (sd) { var kinds = ['pirateA', 'pirateB', 'pirateC'], ax = b.x + sd * w * 0.32, ay = b.y + h * 0.5; G.enemies.push({ id: G.nextId++, kind: kinds[Math.floor(Math.random() * 3)], free: true, swing: true, ax: ax, ay: ay, len: 6, ang: sd * 1.2, av: -sd * 1.6, mode: 'free', hp: 1, flash: 0, t: 0, x: ax, y: ay + 6 }); });
        break;
    }
  }
  function beamX(b) { return eyeX(b, b.beam.k); }
  function eyeX(b, k) { var e = b.def.eyes[k]; return bossPt(b, (e[0] + e[2]) / 2, 0)[0]; }
  function holdY(b) { return b.y + b.h * b.def.beam[1]; }
  function captureShip(b) {
    var s = G.ship;
    if (G.pw.beadsT > 0 || settings.practice === 'on') { hitShip(); return; }   // the beads (or practice) protect you from the beam too
    G.capture = { x: s.x, y: s.y, x0: s.x, y0: s.y, k: b.beam.k, t: 0 };
    s.alive = false; s.respawn = 2.4;
    G.lives--;
    G.pw = freshPw(); G.caps = [];
    b.beam.t = Math.max(b.beam.t, 1.3);
    G.announce = { txt: 'SHIP CAPTURED', sub: 'SHOOT THAT PALM TO GET IT BACK', c: '#ff5a7a', t: 2.6 };
    SFX.die(); buzz([40, 50, 70]);
  }
  // the palm holding your ship goes dark: the ship drops back down and flies beside you as a twin
  function freeCaptive(b, k) {
    var from = G.capture && G.capture.k === k ? { x: G.capture.x, y: G.capture.y } : { x: eyeX(b, k), y: holdY(b) + 6 };
    G.capture = null; b.captive = null;
    G.rescue = { x: from.x, y: from.y, t: 0 };
    pop(from.x, from.y - 8, 'SHIP FREED!', '#7fd06a');
  }
  function updateCaptives(dt) {
    var b = G.boss, s = G.ship;
    if (G.capture) {
      var cp = G.capture;
      if (!b || b.key !== 'palms') G.capture = null;
      else {
        cp.t += dt; var k = Math.min(1, cp.t / 1.2), tx = eyeX(b, cp.k), ty = holdY(b) + 6;
        cp.x = cp.x0 + (tx - cp.x0) * k; cp.y = cp.y0 + (ty - cp.y0) * k;
        if (k >= 1) { b.captive = { k: cp.k }; G.capture = null; }
      }
    }
    if (G.rescue) {
      var r = G.rescue; r.t += dt;
      var gx = s.alive ? s.x + TWIN_DX : W / 2, gy = s.alive ? s.y : Math.round(H * 0.5);
      var dx = gx - r.x, dy = gy - r.y, dist = Math.hypot(dx, dy), step = 90 * dt;
      if (dist <= step + 1) { r.x = gx; r.y = gy; } else { r.x += dx / dist * step; r.y += dy / dist * step; }
      if (s.alive && dist <= step + 1) {
        G.pw.twinT = 999; s.x = clampShip(s.x);
        G.rescue = null;
        G.announce = { txt: 'SHIP RESCUED', sub: 'TWIN MACHINES', c: '#ffa04a', t: 2 };
        ring(s.x + TWIN_DX, s.y, 16, '#ffa04a', 0.35); SFX.power(); buzz([20, 30, 45]);
      }
    }
  }
  function drawCaptives() {
    var img = SPRITES.machine, b = G.boss, on = Math.floor(G.t * 8) % 2;
    if (b && b.key === 'palms' && b.captive && (G.phase === 'boss' || G.phase === 'bossDeath')) { blit(ctx, on ? img.flash[0] : img.clean[0], eyeX(b, b.captive.k), holdY(b) + 6); if (on) drawText(ctx, 'HELP!', Math.round(eyeX(b, b.captive.k)), Math.round(holdY(b) + 16), '#ff5a7a', 1, 'center'); }
    if (G.capture) blit(ctx, on ? img.flash[0] : img.clean[0], G.capture.x, G.capture.y);
    if (G.rescue) blit(ctx, img.clean[0], G.rescue.x, G.rescue.y);
  }

  /* ================= the treasure after the Ghost Ship ================= */
  // Beating Jean Lafitte's Ghost Ship (level 8) ends the game at Von Striga: the wreck hangs in the
  // sky spilling coins, gems and chests for 15 seconds while fireworks go off and the Ferris wheel
  // lights up. Fly into the treasure to grab it; nothing can hurt you now. Then the total, and the
  // YOU MADE IT! popup with the initials and the share.
  var TREASURE_TIME = 15, WRECK_K = 0.6;   // the wreck shrinks back into the sky so the shop shows below it
  var LOOT = { coin: 100, gem: 250, chest: 1000 }, GEMS = ['#ff5a7a', '#5fdcc4', '#b08aff', '#7fd06a'];
  function startTreasure() {
    var b = G.boss;
    G.phase = 'treasure'; G.phaseT = TREASURE_TIME; G.loot = []; G.treasure = 0; G.lootT = 0.5; G.lootDone = false;
    G.enemies = []; G.eshots = []; G.caps = []; G.bombs = []; G.seekers = []; G.gull = null; G.capture = null; G.rescue = null;
    if (b) { b.wy = 6; b.y = b.wy; b.wt = 0; b.flash = 0; }
    G.wheelParty = 999;
    G.storm.target = 0;   // the hurricane clears as you reach the shop
    G.banner = { t: 4.5, a: 'YOU MADE IT', b: 'TO VON STRIGA', c: 'THE ONLY PLACE TO GO!' };
    G.announce = null;
    SFX.clear(); buzz([30, 40, 30, 40, 60]);
  }
  function updateTreasure(dt) {
    var b = G.boss, s = G.ship, i;
    G.phaseT -= dt;
    if (b) { b.wt += dt; b.x = W / 2 + Math.sin(b.wt * 0.5) * W * 0.18; b.y = b.wy + Math.sin(b.wt * 1.3) * 3; }
    if (G.phase === 'treasure') {
      G.lootT -= dt;
      while (G.lootT <= 0) {
        G.lootT += 0.12 + Math.random() * 0.1;
        var r = Math.random(), k = r < 0.04 ? 'chest' : r < 0.28 ? 'gem' : 'coin';
        var x0 = b ? b.x + (Math.random() - 0.5) * b.w * WRECK_K * 0.7 : 20 + Math.random() * (W - 40), y0 = b ? b.y + b.h * WRECK_K * 0.75 : 10;
        G.loot.push({ kind: k, x: x0, y: y0, vx: (Math.random() - 0.5) * 40, vy: -10 - Math.random() * 25, t: Math.random() * 3, c: GEMS[Math.floor(Math.random() * GEMS.length)] });
      }
      if (Math.random() < dt * 4) { var fwx = 20 + Math.random() * (W - 40), fwy = 30 + Math.random() * (HORIZON - 50); explode(fwx, fwy, [['#ffd166', '#ffffff'], ['#ff5a7a', '#ffffff'], ['#7fd06a', '#ffffff']][Math.floor(Math.random() * 3)], 22, 1.2); }
      if (b && Math.random() < dt * 6) G.parts.push({ x: b.x + (Math.random() - 0.5) * b.w * WRECK_K * 0.5, y: b.y + b.h * WRECK_K * 0.3, vx: (Math.random() - 0.5) * 8, vy: -14 - Math.random() * 10, life: 0.9 + Math.random() * 0.6, c: ['#4a4458', '#5a5468', '#2fff9a'][Math.floor(Math.random() * 3)] });
      if (G.phaseT <= 0) { G.phase = 'treasureEnd'; G.phaseT = 3.4; }
    }
    for (i = G.loot.length - 1; i >= 0; i--) {
      var l = G.loot[i];
      l.t += dt; l.vy = Math.min(62, l.vy + 55 * dt); l.vx *= 1 - dt * 0.8;
      l.x = clamp(l.x + l.vx * dt, 6, W - 6); l.y += l.vy * dt;
      if (s.alive && Math.abs(l.y - s.y) < 14 && (Math.abs(l.x - s.x) < 15 || (G.pw.twinT > 0 && Math.abs(l.x - (s.x + TWIN_DX)) < 15))) {
        var v = LOOT[l.kind];
        G.treasure += v; addScore(v);
        pop(l.x, l.y - 8, '+' + v, l.kind === 'coin' ? '#ffd166' : l.kind === 'gem' ? l.c : '#ff8a3d');
        sparkle(l.x, l.y, ['#ffd166', '#ffffff'], l.kind === 'chest' ? 14 : 5);
        SFX.coin(l.kind); buzz(6);
        G.loot.splice(i, 1); continue;
      }
      if (l.y > SAND + 4) G.loot.splice(i, 1);
    }
    if (G.phase === 'treasureEnd') {
      if (!G.lootDone) { G.lootDone = true; G.banner = { t: 3.4, a: 'TREASURE', b: commas(G.treasure) + ' POINTS', c: 'WELCOME TO VON STRIGA' }; SFX.clear(); }
      if (G.phaseT <= 0 && !G.loot.length) { G.boss = null; G.wheelParty = 0; G.banner = null; gameOver(true); }
    }
  }
  function drawWreck(b) {
    var img = b.def.vars ? b.def.vars[0] : b.def.img;
    ctx.globalAlpha = 0.78 + 0.14 * Math.sin(G.t * 6);
    var w = b.w * WRECK_K, h = b.h * WRECK_K;
    ctx.drawImage(img, snapA(b.x - w / 2), snapA(b.y), w, h);
    ctx.globalAlpha = 1;
  }
  function drawLoot() {
    for (var i = 0; i < G.loot.length; i++) {
      var l = G.loot[i], x = Math.round(l.x), y = Math.round(l.y);
      if (l.kind === 'coin') {
        var w = [5, 3, 1, 3][Math.floor(l.t * 10) % 4];   // a spinning gold coin
        ctx.fillStyle = '#b07a1a'; ctx.fillRect(x - (w >> 1), y - 2, w, 5);
        ctx.fillStyle = '#ffd166'; ctx.fillRect(x - (w >> 1), y - 2, Math.max(1, w - 1), 4);
        if (w > 2) { ctx.fillStyle = '#fff3b0'; ctx.fillRect(x - (w >> 1), y - 2, 1, 1); }
      } else if (l.kind === 'gem') {
        ctx.fillStyle = l.c; ctx.fillRect(x, y - 2, 1, 1); ctx.fillRect(x - 1, y - 1, 3, 1); ctx.fillRect(x - 2, y, 5, 1); ctx.fillRect(x - 1, y + 1, 3, 1); ctx.fillRect(x, y + 2, 1, 1);
        ctx.fillStyle = '#ffffff'; ctx.fillRect(x - 1, y - 1, 1, 1);
      } else {
        ctx.fillStyle = '#5a3418'; ctx.fillRect(x - 4, y - 2, 9, 6);
        ctx.fillStyle = '#7a4a22'; ctx.fillRect(x - 4, y - 3, 9, 3);
        ctx.fillStyle = '#ffd166'; ctx.fillRect(x - 4, y, 9, 1); ctx.fillRect(x, y - 1, 1, 3);
        if (Math.floor(l.t * 6) % 3 === 0) { ctx.fillStyle = '#ffffff'; ctx.fillRect(x + 3, y - 4, 1, 1); }
      }
    }
  }

  /* ================= bonus round after each boss (named for its zone) ================= */
  var PIER_PATHS = [
    function (t) { return { x: -12 + t * (W + 24), y: 34 + Math.sin(t * 6.28) * 22 }; },
    function (t) { return { x: W + 12 - t * (W + 24), y: 56 + Math.sin(t * 9.4) * 18 }; },
    function (t) { var a = t * Math.PI * 2; return { x: W / 2 + Math.sin(a) * W * 0.36, y: -12 + t * HORIZON * 0.9 + Math.sin(a * 2) * 10 }; },
    function (t) { return { x: W / 2 + Math.cos(t * Math.PI * 3) * W * (0.42 - t * 0.2), y: 18 + t * 80 }; },
    function (t) { var z = (t * 4) % 2, zx = z < 1 ? z : 2 - z; return { x: 14 + zx * (W - 28), y: -10 + t * (HORIZON * 0.85) }; }
  ];
  function startPier() {
    G.phase = 'pier'; G.enemies = []; G.eshots = [];
    G.pier = { t: 0, group: 0, hits: 0, total: 40, spawned: 0 };
    G.wheelParty = 999;
    G.banner = { t: 2.6, a: 'BONUS ROUND', b: zoneFor(G.level), c: 'HIT ALL 40' };
  }
  function updatePier(dt) {
    var p = G.pier; p.t += dt;
    var gStart = 2 + p.group * 4.2;
    if (p.group < 5 && p.t >= gStart) {
      var pool = kindsFor(G.level);
      var kind = pool[p.group % pool.length];
      for (var i = 0; i < 8; i++) G.enemies.push({ id: G.nextId++, kind: kind, free: true, pier: p.group, delay: i * 0.2, mode: 'pierfly', hp: 1, max: 1, flash: 0, t: 0, x: -40, y: -40 });
      p.group++;
    }
    var alive = 0;
    G.enemies.forEach(function (e) {
      if (e.mode !== 'pierfly') return;
      e.t += dt; var tt = (e.t - e.delay) / 3.4;
      if (tt < 0) { alive++; return; }
      if (tt > 1) { e.mode = 'dead'; e.escaped = true; return; }
      var pt = PIER_PATHS[e.pier % PIER_PATHS.length](tt); e.x = pt.x; e.y = pt.y; alive++;
    });
    if (p.group >= 5 && alive === 0) {
      G.phase = 'pierEnd'; G.phaseT = 3;
      var bonus = p.hits * 100 + (p.hits >= p.total ? 10000 : 0);
      addScore(bonus);
      G.banner = { t: 3, a: p.hits >= p.total ? 'PERFECT!' : 'HITS ' + p.hits + ' OF ' + p.total, b: 'BONUS ' + bonus };
      if (p.hits >= p.total) SFX.clear();
    }
  }

  /* ================= update ================= */
  function rainCount() { return Math.min(140, Math.floor(Math.max(0, G.storm.cur - 0.8) * 60)); }
  function liveWaveEnemies() { var n = 0; for (var i = 0; i < G.enemies.length; i++) { var e = G.enemies[i]; if (e.mode !== 'dead') n++; } return n; }
  function updateStorm(dt) {
    var st = G.storm, target = (st.target || 0) * st.mul;
    st.cur += clamp(target - st.cur, -dt * 0.8, dt * 0.8);
    var s = st.cur;
    if (st.bolt) { st.bolt.t -= dt; if (st.bolt.t <= 0) st.bolt = null; }
    if (G.skyFlash > 0) G.skyFlash -= dt;
    st.wind = s >= 2.4 ? Math.sin(G.t * 0.35) * (s - 2.2) * 0.8 : 0;
    st.gustT -= dt;
    if (s >= 2.4 && st.gustT <= 0) { st.gust = { t: 1.2, dir: Math.random() < 0.5 ? -1 : 1 }; st.gustT = 5 + Math.random() * 5; }
    if (st.gust) { st.gust.t -= dt; if (st.gust.t <= 0) st.gust = null; }
    if (s >= 1.2) {
      st.nextBolt -= dt;
      if (st.nextBolt <= 0) {
        st.nextBolt = (s >= 2.4 ? 3 : 6) + Math.random() * 4;
        var strike = s >= 2.4 && G.state === 'play' && !G.ambientOnly;
        var tx = Math.random() * W;
        if (strike) {
          var live = G.enemies.filter(function (e) { return e.mode !== 'dead' && e.y > 0; });
          if (live.length) tx = live[Math.floor(Math.random() * live.length)].x;
          else if (G.boss && G.phase === 'boss') tx = G.boss.x;
        }
        var pts = [], y = 0, x = tx;
        while (y < (strike ? SAND : HORIZON)) { pts.push(x, y); y += 6 + Math.random() * 8; x += (Math.random() * 2 - 1) * 6; }
        pts.push(tx, strike ? SAND : HORIZON);
        st.bolt = { pts: pts, t: 0.2, strike: strike };
        G.skyFlash = strike ? 0.3 : 0.18;
        SFX.thunder(strike ? 0 : 0.4);
        if (strike) {
          G.shake = Math.max(G.shake, 0.25); buzz(20);
          G.enemies.forEach(function (e) { if (e.mode !== 'dead' && Math.abs(e.x - tx) < 9) { damage(e, 3, true); pop(e.x, e.y - 10, 'ZAP!', '#ffffff'); } });
          if (G.boss && G.phase === 'boss' && Math.abs(G.boss.x - tx) < bossW(G.boss) / 2) bossDamage(6, 0, true);
        }
      }
    }
    if (s >= 2.4) { st.splashT -= dt; if (st.splashT <= 0) { st.splashT = 1.2 + Math.random() * 2; var sx = Math.random() * W; for (var i = 0; i < 16; i++) G.parts.push({ x: sx + (Math.random() - 0.5) * 14, y: SAND - 2, vx: (Math.random() - 0.5) * 40, vy: -40 - Math.random() * 50, life: 0.6 + Math.random() * 0.4, c: i % 3 ? '#e1f4ff' : '#ffffff' }); } }
  }
  function update(dt) {
    var nowPlaying = canPlay();
    if (nowPlaying !== playingCls) { playingCls = nowPlaying; document.documentElement.classList.toggle('is-playing', nowPlaying); if (nowPlaying) playScrollY = window.scrollY; }
    G.t += dt;
    updateStorm(dt);
    if (G.gull) { var gu = G.gull; gu.x += gu.vx * dt; gu.y = wireY(gu.x) - GULL_FEET; if (gu.x < -24 || gu.x > W + 24) G.gull = null; }
    if (pageDrops.length) updatePageDrops(dt);
    if (G.wheelParty > 0 && G.wheelParty < 900) G.wheelParty -= dt;
    if (G.state !== 'play' || G.paused || G.ambientOnly) {
      G.formT += dt * 0.6;
      if (G.state === 'boot' || G.state === 'story' || G.state === 'title' || G.state === 'over' || G.state === 'idle' || G.ambientOnly) ambientGull(dt);
      updateParts(dt);
      return;
    }
    if (G.phase === 'wave') ambientGull(dt);
    G.formT += dt;
    if (G.banner) { G.banner.t -= dt; if (G.banner.t <= 0) G.banner = null; }
    if (G.hintT > 0 && G.steered) G.hintT -= dt;

    var s = G.ship, pw = G.pw;
    if (s.alive) {
      var speed = 125;
      if (keys.left) s.x -= speed * dt;
      if (keys.right) s.x += speed * dt;
      if (keys.up) s.y -= speed * dt;
      if (keys.down) s.y += speed * dt;
      if (mouseTarget != null && !keys.left && !keys.right) { var dm = mouseTarget - s.x, mm = (VS_CABINET ? 1e6 : 190) * dt; s.x += Math.max(-mm, Math.min(mm, dm)); }
      if (mouseTargetY != null && !keys.up && !keys.down) { var dmy = mouseTargetY - s.y, mmy = (VS_CABINET ? 1e6 : 190) * dt; s.y += Math.max(-mmy, Math.min(mmy, dmy)); }
      if (G.storm.gust) s.x += G.storm.gust.dir * 16 * dt;
      s.x = clampShip(s.x);
      s.y = clampShipY(s.y);
      if (s.inv > 0) s.inv -= dt;
    } else {
      s.respawn -= dt;
      if (s.respawn <= 0) { if (G.lives <= 0) { gameOver(); return; } s.alive = true; s.inv = 2; s.x = W / 2; s.y = SHIP_Y; }
    }
    ['fanT', 'rapidT', 'laserT', 'twinT'].forEach(function (k) { if (pw[k] > 0) pw[k] = Math.max(0, pw[k] - dt); });   // the beads do not run out of time
    if (G.capture || G.rescue) { updateCaptives(dt); pw = G.pw; }
    if (pw.fanT <= 0) pw.fan = 0;
    if (G.comboT > 0) { G.comboT -= dt; if (G.comboT <= 0) G.combo = 0; }
    if (G.muzzle > 0) G.muzzle -= dt;

    // hold to fire
    G.fireCd -= dt;
    if (G.holding && s.alive && G.fireCd <= 0 && (G.phase === 'wave' || G.phase === 'boss' || G.phase === 'pier' || G.phase === 'break')) { if (fire()) G.fireCd = fireRate(); }

    for (var i = G.shots.length - 1; i >= 0; i--) { var so = G.shots[i]; so.x += so.vx * dt; so.y += so.vy * dt; if (so.y < -10 || so.x < -6 || so.x > W + 6) G.shots.splice(i, 1); }

    for (var cI = G.caps.length - 1; cI >= 0; cI--) {
      var cap = G.caps[cI];
      cap.t += dt; cap.y += 24 * dt; cap.x = clamp(cap.x + Math.sin(cap.t * 3) * 10 * dt, 15, W - 15);
      var grab = s.alive && Math.abs(cap.y - s.y) < 15 && (Math.abs(cap.x - s.x) < 17 || (pw.twinT > 0 && Math.abs(cap.x - (s.x + TWIN_DX)) < 17));
      if (grab) { G.caps.splice(cI, 1); collect(cap.kind); continue; }
      if (cap.y > SAND + 6) G.caps.splice(cI, 1);
    }

    // phases
    if (G.phase === 'break') { G.phaseT -= dt; if (G.phaseT <= 0) { G.wave++; startWave(); } }
    if (G.phase === 'eye') { G.storm.mul = Math.max(0, G.storm.mul - dt * 1.5); G.phaseT -= dt; if (G.phaseT <= 0) { G.phase = 'warning'; G.phaseT = 2.6; SFX.siren(); } }
    if (G.phase === 'warning') { G.storm.mul = Math.min(1, G.storm.mul + dt * 0.6); G.phaseT -= dt; if (G.phaseT <= 0) startBoss(); }
    if (G.phase === 'boss') updateBoss(dt);
    if (G.phase === 'bossDeath') {
      G.phaseT -= dt;
      if (Math.random() < dt * 9 && G.boss) { var bb = G.boss; explode(bb.x + (Math.random() - 0.5) * bb.def.w, bb.y + Math.random() * bb.def.h, ['#ffffff', '#ffd166', '#ff8a3d'], 12, 1.3); G.shake = 0.2; }
      if (G.phaseT <= 0) { G.flash = 1; if (G.level >= LAST_LEVEL) { startTreasure(); return; } G.boss = null; levelCleared(true); return; }
    }
    if (G.phase === 'pier') updatePier(dt);
    if (G.phase === 'pierEnd') {
      G.phaseT -= dt;
      if (G.phaseT <= 0) {
        G.pier = null;
        G.wheelParty = 0; startLevel(G.level + 1);
      }
    }
    if (G.phase === 'treasure' || G.phase === 'treasureEnd') { updateTreasure(dt); if (G.state !== 'play') return; }

    updateEnemies(dt);
    updateEnemyShots(dt);
    updateBombs(dt);

    // shots against the boss
    if (G.boss && G.phase === 'boss') {
      var boxes = bossBoxes(G.boss);
      for (var q = G.shots.length - 1; q >= 0; q--) {
        var sh = G.shots[q];
        for (var k = 0; k < boxes.length; k++) {
          var bx = boxes[k];
          if (sh.x < bx.x - 1 || sh.x > bx.x + bx.w + 1 || sh.y < bx.y || sh.y > bx.y + bx.h) continue;
          if (sh.laser && sh.hit['b' + bx.part]) break;
          if (bx.type === 'armor') { G.shots.splice(q, 1); explode(sh.x, sh.y, ['#e1e6ee', '#ffffff'], 3, 0.5); if (Math.random() < 0.3) SFX.tink(); break; }
          if (bx.type === 'mouth') { G.shots.splice(q, 1); G.boss.swallow++; break; }
          if (sh.laser) sh.hit['b' + bx.part] = 1; else G.shots.splice(q, 1);
          bossDamage(1, bx.part);
          break;
        }
        if (G.phase !== 'boss') break;
      }
      var b = G.boss;
      if (b && G.phase === 'boss' && s.alive && s.inv <= 0 && b.key !== 'shark') {
        for (var cb = 0; cb < boxes.length; cb++) { var bx2 = boxes[cb]; if (s.x > bx2.x && s.x < bx2.x + bx2.w && s.y > bx2.y && s.y - 8 < bx2.y + bx2.h) { hitShip(); break; } }
      }
      if (b && b.key === 'shark' && b.st === 'leap' && s.alive && s.inv <= 0 && Math.abs(b.x - s.x) < bossW(b) * 0.35 && b.y < s.y + 6 && b.y + bossH(b) * 0.8 > s.y - 6) hitShip();
    }

    // the gull drops things as it walks: about half are power-ups, the rest are droppings that hurt
    if (G.gull && G.gull.live && (G.phase === 'wave' || G.phase === 'break')) {
      var gl = G.gull;
      gl.dropT -= dt;
      if (gl.dropT <= 0 && gl.x > 10 && gl.x < W - 10) {
        gl.dropT = 1.6 + Math.random() * 2.2;
        if (Math.random() < 0.5 && G.caps.length < 3) spawnCap(gl.x, gl.y + 8, pickPower());
        else eshot(gl.x, gl.y + 8, 0, 62, 'poop');
        SFX.gull();
      }
    }
    // ambient gull bonus
    if (G.gull && G.gull.live) {
      for (var g2 = G.shots.length - 1; g2 >= 0; g2--) {
        if (Math.abs(G.shots[g2].x - G.gull.x) < 9 && Math.abs(G.shots[g2].y - G.gull.y) < 6) {
          if (!G.shots[g2].laser) G.shots.splice(g2, 1);
          addScore(500);
          spawnCap(G.gull.x, G.gull.y, ['twin', 'fan', 'laser'][(Math.random() * 3) | 0]);
          explode(G.gull.x, G.gull.y, ['#f4ead6', '#ff8a3d'], 12);
          pop(G.gull.x, G.gull.y - 6, 'GULL 500', '#ff8a3d');
          SFX.gull(); buzz(20);
          G.gull = null;
          break;
        }
      }
    }
    updateParts(dt);
    if (G.shake > 0) G.shake -= dt;
    if (G.phase === 'wave' && liveWaveEnemies() === 0 && G.state === 'play') {
      if (G.wave < 3) { G.phase = 'break'; G.phaseT = 1.4; addScore(250 * G.wave); pop(W / 2, H * 0.45, 'WAVE ' + G.wave + ' CLEARED', '#7fd06a'); SFX.clear(); }
      else if (isBossLevel(G.level)) startBossIntro();
      else levelCleared(false);
    }
  }
  function updateEnemies(dt) {
    var s = G.ship, cfg = G.cfg || waveConfig(G.level, G.wave), lvl = G.level;
    for (var j = 0; j < G.enemies.length; j++) {
      var e = G.enemies[j];
      if (e.mode === 'dead') continue;
      if (e.flash > 0) e.flash -= dt;
      if (e.mode === 'pierfly') { hitByShots(e); continue; }
      if (e.mode === 'free') {
        e.t += dt;
        if (e.swing) {
          e.ang += e.av * dt; e.av += -Math.sin(e.ang) * 5 * dt; e.len = Math.min(60, e.len + 30 * dt);
          e.x = e.ax + Math.sin(e.ang) * e.len; e.y = e.ay + Math.cos(e.ang) * e.len;
          if (e.len >= 60 && e.t > 2) { e.swing = false; var v = aimAt(e.x, e.y, 70); e.vx = v[0]; e.vy = v[1]; }
        } else {
          if (e.wig) e.vx = Math.sin(e.t * 3) * 30;
          e.x += e.vx * dt; e.y += e.vy * dt;
        }
        if (e.y > H + 12 || e.x < -30 || e.x > W + 30) { e.mode = 'dead'; e.escaped = true; continue; }
      } else {
        var sp = slotPos(e);
        if (e.mode === 'enter') {
          e.t += dt;
          if (e.t < 0) continue;
          var dur = e.entry === 'loop' ? 2.1 : 1.5, k = Math.min(1, e.t / dur), inv = 1 - k;
          var p0x = e.side > 0 ? W + 12 : -12, p0y = -12;
          var p1x = e.side > 0 ? W * 0.15 : W * 0.85, p1y = H * 0.5;
          var p2x = sp.x, p2y = sp.y + 50;
          e.x = inv * inv * inv * p0x + 3 * inv * inv * k * p1x + 3 * inv * k * k * p2x + k * k * k * sp.x;
          e.y = inv * inv * inv * p0y + 3 * inv * inv * k * p1y + 3 * inv * k * k * p2y + k * k * k * sp.y;
          if (e.entry === 'loop' && k > 0.35 && k < 0.75) { var la = (k - 0.35) / 0.4 * Math.PI * 2; e.x += Math.sin(la) * 18 * e.side; e.y += (1 - Math.cos(la)) * 14; }
          if (k >= 1) e.mode = 'form';
        } else if (e.mode === 'form') {
          e.x = sp.x; e.y = sp.y;
        } else if (e.mode === 'dive') {
          e.t += dt;
          e.y += cfg.diveSpeed * dt;
          if (e.style === 'loop') {
            if (e.t > 0.8 && e.t < 2.0) { if (e.lx == null) e.lx = e.x; var lt = (e.t - 0.8) / 1.2 * Math.PI * 2; e.x = e.lx + Math.sin(lt) * 20; e.y -= cfg.diveSpeed * dt * (Math.cos(lt) > 0 ? 1.6 : 0.2); }
            else e.x += (s.x - e.x) * 0.6 * dt;
          }
          else if (e.style === 'zig') { e.x += (Math.floor(e.t * 1.6) % 2 ? 1 : -1) * 55 * dt; }
          else { var drift = (s.x - e.x) * 0.9 * dt; e.x = e.sx + Math.sin(e.t * 2.4) * 22 + (e.x - e.sx - Math.sin((e.t - dt) * 2.4) * 22) + drift; }
          if (e.lead) { var L2 = e.lead; e.x = L2.x + e.offX; e.y = L2.y - 10; if (L2.mode !== 'dive') e.lead = null; }
          if (Math.random() < dt * (0.35 + effLevel(lvl) * 0.08) && e.y < SHIP_Y - 30) enemyShot(e);
          e.x = clamp(e.x, 4, W - 4);
          if (e.y > H + 12) { e.mode = 'return'; e.y = -14; e.t = 0; e.lead = null; }
        } else if (e.mode === 'return') {
          e.t += dt;
          var rk = Math.min(1, e.t / 1.1);
          e.x = e.x + (sp.x - e.x) * Math.min(1, dt * 4);
          e.y = -14 + (sp.y + 14) * rk;
          if (rk >= 1) e.mode = 'form';
        }
      }
      hitByShots(e);
      if (e.mode === 'dead') continue;
      if (e.mode !== 'pierfly' && s.alive && s.inv <= 0 && Math.abs(e.y - s.y) < 10) {
        if (Math.abs(e.x - s.x) < 10) { e.mode = 'dead'; explode(e.x, e.y, kindColors(e.kind), 10); hitShip(); }
        else if (G.pw.twinT > 0 && Math.abs(e.x - (s.x + TWIN_DX)) < 10) { e.mode = 'dead'; explode(e.x, e.y, kindColors(e.kind), 10); hitTwin(); }
      }
    }
    if (G.phase === 'wave') {
      G.diveCd -= dt;
      if (G.diveCd <= 0) { startDive(cfg); if (lvl >= 3 && Math.random() < 0.5) startDive(cfg); G.diveCd = cfg.diveEvery + Math.random() * 1.2; }
      G.eshotCd -= dt;
      if (G.eshotCd <= 0) {
        var shooters = G.enemies.filter(function (en) { return en.mode === 'form'; });
        if (shooters.length) enemyShot(shooters[(Math.random() * shooters.length) | 0]);
        G.eshotCd = cfg.shotEvery + Math.random() * 0.8;
      }
    }
    if (G.enemies.length > 80) G.enemies = G.enemies.filter(function (e) { return e.mode !== 'dead'; });
  }
  function hitByShots(e) {
    var spr = spriteOf(e.kind), hw = spr ? spr.clean[0].gw / 2 : 7, hh = spr ? spr.clean[0].gh / 2 : 7;
    for (var q = G.shots.length - 1; q >= 0; q--) {
      var sh = G.shots[q];
      if (sh.laser && sh.hit[e.id]) continue;
      if (Math.abs(sh.x - e.x) < hw + (sh.laser ? 1.5 : 0.5) && Math.abs(sh.y - e.y) < hh + (sh.laser ? 2 : 0)) {
        if (sh.laser) sh.hit[e.id] = 1; else G.shots.splice(q, 1);
        damage(e, 1, false);
        return;
      }
    }
  }
  function startDive(cfg) {
    var pool = G.enemies.filter(function (e) { return e.mode === 'form'; });
    if (!pool.length) return;
    pool.sort(function (a, b) { return b.r - a.r; });
    var pick = pool[Math.floor(Math.random() * Math.min(pool.length, 6))];
    if (cfg.escorts && Math.random() < 0.6) { var caps = pool.filter(function (e) { return e.r === 0; }); if (caps.length) pick = caps[Math.floor(Math.random() * caps.length)]; }
    pick.mode = 'dive'; pick.t = 0; pick.sx = pick.x; pick.lx = null; pick.style = cfg.diveStyles[Math.floor(Math.random() * cfg.diveStyles.length)];
    if (cfg.escorts && pick.r === 0) {
      var esc = pool.filter(function (e) { return e !== pick && e.r === 1 && Math.abs(e.c - pick.c) <= 1; }).slice(0, 2);
      esc.forEach(function (e, n) { e.mode = 'dive'; e.t = 0; e.sx = e.x; e.lx = null; e.style = pick.style; e.lead = pick; e.offX = (n ? 1 : -1) * 13; });
    }
  }
  function enemyShot(e) {
    var cfg = G.cfg || { maxShots: 3, spread: false };
    if (G.eshots.filter(function (s) { return s.k === 'ink'; }).length >= cfg.maxShots) return;
    var aim = clamp((G.ship.x - e.x) * 0.25, -22, 22), vy = 70 + effLevel(G.level) * 6;
    eshot(e.x, e.y + 6, aim, vy, 'ink');
    if (cfg.spread && Math.random() < 0.3) { eshot(e.x, e.y + 6, aim - 26, vy, 'ink'); eshot(e.x, e.y + 6, aim + 26, vy, 'ink'); }
  }
  function updateEnemyShots(dt) {
    var s = G.ship, pw = G.pw, wind = G.storm.wind;
    for (var u = G.eshots.length - 1; u >= 0; u--) {
      var es = G.eshots[u];
      if (es.g) { es.vy += es.g * dt; es.life -= dt; if (es.life <= 0 || es.y > SHIP_Y - 40) { G.eshots.splice(u, 1); for (var sh = 0; sh < 6; sh++) { var a = sh * Math.PI / 3 + 0.5; eshot(es.x, es.y, Math.cos(a) * 55, Math.sin(a) * 55 + 20, 'shard'); } explode(es.x, es.y, ['#a8743c', '#f5c542'], 8); continue; } }
      if (es.k === 'bubble') es.vx += Math.sin(G.t * 6 + u) * 30 * dt;
      es.vx += wind * 10 * dt;
      es.y += es.vy * dt; es.x += es.vx * dt;
      if (G.tide && es.y > G.tide.y) { G.eshots.splice(u, 1); continue; }
      if (es.y > SAND + 2 || es.x < -10 || es.x > W + 10 || es.y < -20) { if (es.k === 'poop' && es.y > SAND + 2) explode(es.x, SAND, ['#f4f1e8', '#ffffff'], 5); G.eshots.splice(u, 1); continue; }
      if (s.alive && s.inv <= 0 && Math.abs(es.y - s.y) < 8) {
        if (Math.abs(es.x - s.x) < 6) { G.eshots.splice(u, 1); if (es.k === 'poop') pop(s.x, s.y - 14, 'SPLAT!', '#f4f1e8'); hitShip(); break; }
        if (pw.twinT > 0 && Math.abs(es.x - (s.x + TWIN_DX)) < 6) { G.eshots.splice(u, 1); hitTwin(); break; }
      }
    }
  }
  function updateBombs(dt) {
    for (var i = G.bombs.length - 1; i >= 0; i--) {
      var b = G.bombs[i]; b.t += dt; b.y += b.vy * dt;
      var near = G.enemies.some(function (e) { return e.mode !== 'dead' && Math.hypot(e.x - b.x, e.y - b.y) < 10; });
      if (G.boss && G.phase === 'boss') bossBoxes(G.boss).forEach(function (bx) { if (b.x > bx.x && b.x < bx.x + bx.w && b.y < bx.y + bx.h) near = true; });
      if (near || b.y < H * 0.3) {
        G.bombs.splice(i, 1);
        var R = Math.min(W, H) * 0.34;
        blast(b.x, b.y, R, 3, 30, '#ffe84a');
        ring(b.x, b.y, R * 1.3, '#ff8a3d', 0.7);
        pop(b.x, b.y - 4, '409', '#ffe84a', 3);
        G.flash = 0.8; G.shake = 0.5; SFX.bomb(); buzz([60, 40, 90]);
      }
    }
    for (var k = G.seekers.length - 1; k >= 0; k--) {
      var s = G.seekers[k]; s.life -= dt;
      var tg = s.tg;
      if (tg && tg.e && tg.e.mode === 'dead') tg = s.tg = null;
      var tx = tg ? (tg.e ? tg.e.x : tg.x) : s.x, ty = tg ? (tg.e ? tg.e.y : tg.y) : -20;
      var dx = tx - s.x, dy = ty - s.y, d = Math.max(1, Math.hypot(dx, dy));
      s.vx += (dx / d * 150 - s.vx) * dt * 3; s.vy += (dy / d * 150 - s.vy) * dt * 3;
      s.x += s.vx * dt; s.y += s.vy * dt;
      if (d < 6 || s.life <= 0 || s.y < -10) { G.seekers.splice(k, 1); if (s.y > -10) { blast(s.x, s.y, 14, 3, 8, '#5fa3ef'); SFX.pop(); } }
    }
    if (G.tide) {
      var td = G.tide; td.y -= (H / 1.1) * dt;
      G.enemies.forEach(function (e) { if (e.mode !== 'dead' && e.y > td.y && !td.done[e.id]) { td.done[e.id] = 1; damage(e, 4, true); } });
      if (G.boss && G.phase === 'boss' && !td.hitBoss && td.y < G.boss.y + bossH(G.boss)) { td.hitBoss = true; bossDamage(45, 0, true); if (G.boss && G.boss.key === 'ship') { for (var mk = 0; mk < 3; mk++) bossDamage(10, mk, true); } }
      if (td.y < -10) G.tide = null;
    }
  }
  // the power line across the sky that the seagull walks on: sags in the middle, sways in the storm
  var WIRE_Y = 19, WIRE_SAG = 3, GULL_FEET = 8;
  function wireY(x) { var f = clamp(x / W, 0, 1), sway = Math.sin(G.t * 1.7) * Math.min(2, (G.storm.cur || 0) * 0.8); return WIRE_Y + (WIRE_SAG + sway) * 4 * f * (1 - f); }
  function drawWire(P) {
    ctx.fillStyle = '#ff5a7a'; ctx.globalAlpha = 0.9;   // the same pink as 1UP and HIGH SCORE
    for (var x = 0; x < W; x++) ctx.fillRect(x, Math.round(wireY(x + 0.5)), 1, 1);
    ctx.globalAlpha = 1;
  }
  function ambientGull(dt) {
    G.gullCd -= dt;
    if (!G.gull && G.gullCd <= 0) {
      var fromLeft = Math.random() < 0.5;
      G.gull = { x: fromLeft ? -18 : W + 18, y: WIRE_Y - GULL_FEET, vx: (fromLeft ? 1 : -1) * (17 + Math.random() * 6), live: G.state === 'play' && G.phase === 'wave', dropT: 1 + Math.random() * 1.5 };
      G.gullCd = 14 + Math.random() * 10;
    }
    // between games and on the shop's other pages the seagull still drops things (just for looks, it never hurts)
    var gl = G.gull;
    if (gl && !gl.live && (G.state !== 'play' || G.ambientOnly) && gl.x > 4 && gl.x < W - 4) {
      gl.dropT -= dt;
      if (gl.dropT <= 0) { gl.dropT = 2 + Math.random() * 2.5; pageDrop(gl.x, gl.y + 8); }
    }
  }

  /* ================= seagull droppings on the page =================
     A dropping leaves the seagull and falls down the screen in front of the page. If a card
     (anything with a solid background, a picture or an embedded page) is under it, it splats
     on that card and stays with it as the page scrolls, then fades. Where nothing is in front
     of the sky (the sides) it falls all the way to the bottom of the screen. Nothing falls
     while the seagull is hidden behind a card, or for visitors who ask for reduced motion. */
  var pageDrops = [], dropLayer = null, splatLayer = null;
  function dropLayers() {
    if (dropLayer) return;
    dropLayer = document.createElement('div'); dropLayer.className = 'poop-layer'; dropLayer.setAttribute('aria-hidden', 'true');
    dropLayer.style.cssText = 'position:fixed;left:0;top:0;width:0;height:0;z-index:30;pointer-events:none;';
    splatLayer = document.createElement('div'); splatLayer.className = 'splat-layer'; splatLayer.setAttribute('aria-hidden', 'true');
    splatLayer.style.cssText = 'position:absolute;left:0;top:0;width:0;height:0;z-index:30;pointer-events:none;';
    document.body.appendChild(dropLayer); document.body.appendChild(splatLayer);
  }
  function solidAt(x, y) {
    var el = document.elementFromPoint(x, y);
    while (el && el !== document.body && el !== document.documentElement) {
      if (el === canvas || (el.classList && el.classList.contains('world'))) return null;
      if (el.tagName === 'IMG' || el.tagName === 'IFRAME' || el.tagName === 'VIDEO') return el;
      var m = /rgba?\(([^)]+)\)/.exec(getComputedStyle(el).backgroundColor || ''), parts = m ? m[1].split(',') : null;
      if (parts && (parts.length < 4 || parseFloat(parts[3]) >= 0.5)) return el;
      el = el.parentElement;
    }
    return null;
  }
  function pageDrop(gx, gy) {
    if (reduceMotion || document.hidden) return;
    var r = canvas.getBoundingClientRect();
    if (!r.width) return;
    var k = r.width / W, sx = r.left + gx * k, sy = r.top + gy * k, px = Math.max(2, Math.round(k));
    if (sx < 0 || sx > innerWidth || sy < 0 || sy > innerHeight || solidAt(sx, sy)) return;
    dropLayers();
    var el = document.createElement('div');
    el.style.cssText = 'position:absolute;left:0;top:0;will-change:transform;';
    el.innerHTML = '<svg width="' + 5 * px + '" height="' + 5 * px + '" viewBox="0 0 5 5" shape-rendering="crispEdges" style="display:block"><path fill="#f4f1e8" d="M1 0h3v1h1v3h-1v1H1v-1H0V1h1z"/><path fill="#ffffff" d="M1 0h1v1H1z"/><path fill="#5b4a30" d="M2 2h1v1H2z"/></svg>';
    dropLayer.appendChild(el);
    var d = { x: sx, y: sy, vy: 40, px: px, el: el };
    pageDrops.push(d);
    placeDrop(d);
  }
  function placeDrop(d) { d.el.style.transform = 'translate(' + Math.round(d.x - d.px * 2.5) + 'px,' + Math.round(d.y - d.px * 2.5) + 'px)'; }
  function updatePageDrops(dt) {
    for (var i = pageDrops.length - 1; i >= 0; i--) {
      var d = pageDrops[i], bottom = d.px * 2.5;
      d.vy = Math.min(900, d.vy + 1400 * dt);
      var ny = d.y + d.vy * dt, hit = null, steps = Math.max(1, Math.ceil((ny - d.y) / 6));
      for (var s = 1; s <= steps && !hit; s++) {
        var yy = d.y + (ny - d.y) * s / steps + bottom;
        if (yy >= 0 && yy < innerHeight) { hit = solidAt(d.x, yy); if (hit) ny = yy - bottom; }
      }
      d.y = ny;
      if (hit) { splatOn(hit, d); d.el.remove(); pageDrops.splice(i, 1); continue; }
      if (d.y - bottom > innerHeight) { d.el.remove(); pageDrops.splice(i, 1); continue; }
      placeDrop(d);
    }
  }
  function splatOn(card, d) {
    var px = d.px, w = 9 * px, h = 4 * px, el = document.createElement('div');
    el.className = 'poop-splat';
    el.innerHTML = '<svg width="' + w + '" height="' + h + '" viewBox="0 0 9 4" shape-rendering="crispEdges" style="display:block"><path fill="#f4f1e8" d="M3 0h3v1h2v1h1v1H0V2h1V1h2z"/><path fill="#f4f1e8" d="M1 3h2v1H1zM6 3h2v1H6z"/><path fill="#5b4a30" d="M4 1h1v1H4z"/></svg>';
    var inCard = getComputedStyle(card).position !== 'static' && card.tagName !== 'IMG' && card.tagName !== 'IFRAME' && card.tagName !== 'VIDEO';
    var host = inCard ? card : splatLayer, r = card.getBoundingClientRect();
    var left = inCard ? d.x - r.left - card.clientLeft + card.scrollLeft : d.x + window.pageXOffset;
    var top = inCard ? d.y + d.px * 2.5 - r.top - card.clientTop + card.scrollTop : d.y + d.px * 2.5 + window.pageYOffset;
    el.style.cssText = 'position:absolute;left:' + Math.round(left - w / 2) + 'px;top:' + Math.round(top - h + px) + 'px;z-index:30;pointer-events:none;transition:opacity 1.2s steps(6);';
    host.appendChild(el);
    setTimeout(function () { el.style.opacity = '0'; }, 6000);
    setTimeout(function () { if (el.parentNode) el.parentNode.removeChild(el); }, 7400);
  }
  function updateParts(dt) {
    for (var rI = G.rings.length - 1; rI >= 0; rI--) { G.rings[rI].t += dt; if (G.rings[rI].t >= G.rings[rI].life) G.rings.splice(rI, 1); }
    if (G.flash > 0) G.flash = Math.max(0, G.flash - dt * 2.5);
    if (G.announce) { G.announce.t -= dt; if (G.announce.t <= 0) G.announce = null; }
    for (var c = G.covers.length - 1; c >= 0; c--) { var co = G.covers[c]; co.t += dt; co.y -= 20 * dt; if (co.t >= co.life) G.covers.splice(c, 1); }
    for (var i = G.parts.length - 1; i >= 0; i--) { var p = G.parts[i]; p.life -= dt; p.x += p.vx * dt; p.y += p.vy * dt; p.vy += 40 * dt; if (p.life <= 0) G.parts.splice(i, 1); }
    for (var j = G.pops.length - 1; j >= 0; j--) { var o = G.pops[j]; o.life -= dt; o.y -= 12 * dt; if (o.life <= 0) G.pops.splice(j, 1); }
    var st = G.storm, n = rainCount(), slant = st.wind * 30 + (st.gust ? st.gust.dir * 40 : 0);
    for (var r = 0; r < n && r < st.rain.length; r++) { var d = st.rain[r]; d.y += d.sp * dt; d.x += slant * dt; if (d.y > SAND) { d.y = -d.len - Math.random() * 20; d.x = Math.random() * W; } if (d.x < -4) d.x += W + 8; if (d.x > W + 4) d.x -= W + 8; }
    st.clouds.forEach(function (cl) { cl.x += (cl.sp + st.wind * 20) * dt; var sw = STORM_SPRITES[cl.spr] ? STORM_SPRITES[cl.spr].width : 60; if (cl.x > W + 10) cl.x = -sw - 10; if (cl.x < -sw - 10) cl.x = W + 10; });
  }

  /* ================= state changes ================= */
  var ovCleared = $('ovCleared'), ovOver = $('ovOver');
  if (ovOver.parentNode && ovOver.parentNode !== document.body) document.body.appendChild(ovOver);
  var clearedTimer = null, clearedBoss = false;
  function levelCleared(boss) {
    G.state = 'cleared';
    clearedBoss = boss;
    var bonus = 500 * G.level;
    addScore(bonus);
    G.wheelParty = 4;
    $('clearedTitle').textContent = 'LEVEL ' + G.level + ' CLEARED';
    $('clearedBonus').textContent = 'The Seawall holds. ' + (boss ? 'Boss bonus ' + (G.bossBonus || 0) + ', level bonus ' + bonus + ' points.' : 'Bonus ' + bonus + ' points.');
    $('nextBtn').textContent = boss ? 'Bonus Round' : 'Next level';
    ovCleared.hidden = false;
    document.body.classList.add('ov-open');
    SFX.clear(); buzz([15, 40, 15]);
    clearTimeout(clearedTimer);
    clearedTimer = setTimeout(nextLevel, 4200);
  }
  function nextLevel() {
    clearTimeout(clearedTimer);
    if (G.state !== 'cleared') return;
    ovCleared.hidden = true;
    document.body.classList.remove('ov-open');
    G.shots = []; G.eshots = [];
    G.ship.inv = 1;
    G.state = 'play';
    if (clearedBoss) startPier(); else startLevel(G.level + 1);
  }
  function gameOver(win) {
    G.state = 'over';
    G.holding = false;
    G.won = !!win;
    var ot = $('overTitle'), ol = $('overLine');
    if (ot) ot.textContent = win ? 'YOU MADE IT!' : 'GAME OVER';
    if (ol) ol.textContent = win ? 'You beat all 8 levels and made it to Von Striga.' : 'Bad ink got through. Fix it for real.';
    $('overScore').textContent = pad(G.score, 6);
    var board = sampleBoard();
    var lowest = board.length < 10 ? 0 : board[board.length - 1].s;
    var qualifies = G.score > lowest && G.score > 0;
    $('enterBlock').hidden = !qualifies;
    $('boardBlock').hidden = qualifies;
    $('missLine').hidden = qualifies;
    if (qualifies) { initials = ['A', 'A', 'A']; activeSlot = 0; renderInitials(); }
    else { $('missLine').textContent = 'Score ' + pad(lowest + 10, 6) + ' to get on the board.'; renderBoard($('overBoard')); }
    updateShare();
    ovOver.hidden = false;
    ovOver.scrollTop = 0;
    document.body.classList.add('ov-open');
  }

  /* ================= initials entry ================= */
  var CHARS_IN = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
  var initials = ['A', 'A', 'A'], activeSlot = 0;
  var UP = '<svg viewBox="0 0 7 4" aria-hidden="true"><path fill="currentColor" d="M3 0h1v1h1v1h1v1h1v1H0V3h1V2h1V1h1z"/></svg>';
  var DOWN = '<svg viewBox="0 0 7 4" aria-hidden="true"><path fill="currentColor" d="M0 0h7v1H6v1H5v1H4v1H3V3H2V2H1V1H0z"/></svg>';
  function renderInitials() {
    var box = $('initials');
    box.innerHTML = '';
    initials.forEach(function (ch, i) {
      var slot = document.createElement('div');
      slot.className = 'slot' + (i === activeSlot ? ' active' : '');
      slot.innerHTML = '<button class="icon-btn" data-d="1" aria-label="Next letter for initial ' + (i + 1) + '">' + UP + '</button>' +
        '<div class="letter" aria-live="polite">' + ch + '</div>' +
        '<button class="icon-btn" data-d="-1" aria-label="Previous letter for initial ' + (i + 1) + '">' + DOWN + '</button>';
      slot.querySelectorAll('button').forEach(function (b) {
        b.addEventListener('click', function () {
          activeSlot = i;
          var n = CHARS_IN.indexOf(initials[i]);
          initials[i] = CHARS_IN[(n + Number(b.getAttribute('data-d')) + CHARS_IN.length) % CHARS_IN.length];
          SFX.tick(); buzz(8, true);
          renderInitials();
          var again = $('initials').children[i].querySelector('[data-d="' + b.getAttribute('data-d') + '"]');
          if (again) again.focus();
        });
      });
      slot.querySelector('.letter').addEventListener('click', function () { activeSlot = i; renderInitials(); });
      box.appendChild(slot);
    });
  }
  function typeChar(ch) { ch = ch.toUpperCase(); if (CHARS_IN.indexOf(ch) === -1) return; initials[activeSlot] = ch; activeSlot = Math.min(2, activeSlot + 1); renderInitials(); }
  $('typeBtn').addEventListener('click', function () { var inp = $('initialsInput'); inp.value = ''; activeSlot = 0; renderInitials(); inp.focus(); });
  $('initialsInput').addEventListener('input', function (e) {
    var v = e.target.value.toUpperCase().replace(/[^A-Z0-9]/g, '').slice(0, 3);
    for (var i = 0; i < 3; i++) initials[i] = v[i] || initials[i];
    activeSlot = Math.min(2, v.length);
    renderInitials();
    if (v.length === 3) e.target.blur();
  });
  $('saveBtn').addEventListener('click', saveScore);
  function saveScore() {
    if (G.saved) return;
    G.saved = true;
    var entry = { i: initials.join(''), s: G.score };
    var mine = load('board'); if (!Array.isArray(mine)) mine = [];
    mine.push(entry); mine.sort(function (a, b) { return b.s - a.s; }); mine = mine.slice(0, 10);
    store('board', mine);
    if (boardShared) { BOARD = cleanBoard(BOARD.concat([entry])); postScore(entry, G.level); }
    $('enterBlock').hidden = true;
    $('boardBlock').hidden = false;
    $('missLine').hidden = true;
    updateShare();
    renderBoard($('overBoard'), entry);
    renderBoard($('pageBoard'), entry);
    ovOver.scrollTop = 0;
    var top = sampleBoard()[0] || entry;
    if (top.i === entry.i && top.s === entry.s) { $('missLine').hidden = false; $('missLine').textContent = 'You are the new ISLAND LEGEND!'; }
    G.hi = Math.max(G.hi, top.s);
  }
  // share your score on Facebook for a chance to win
  function updateShare() {
    $('shareLine').textContent = 'Share your score on Facebook and tag @Von Striga for a chance to win cool stuff!';
    if (VS_CABINET) cabinetQr();
  }
  // Share on Facebook is a plain link to Facebook's post screen (the Facebook app opens it when the
  // phone hands Facebook links to the app) with vonstriga.com and #VonStriga. Facebook does not let a
  // website fill in the words of a post or tag a page, so the score message is copied, ready to paste.
  function commas(n) { return String(Math.max(0, Math.floor(n))).replace(/\B(?=(\d{3})+(?!\d))/g, ','); }
  function shareText() { return 'I scored ' + commas(G.score) + ' on Ink Invaders! Beat it at vonstriga.com'; }
  function shareScore() {
    var text = shareText(), label = $('shareBtn').querySelector('span');
    try {
      if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(text).then(function () {
        if (!label) return;
        label.textContent = 'Score Copied!';
        setTimeout(function () { label.textContent = 'Share on Facebook'; }, 3000);
      }).catch(function () {});
    } catch (e) {}
  }
  $('shareBtn').addEventListener('click', shareScore);
  $('againBtn').addEventListener('click', function () { ovOver.hidden = true; document.body.classList.remove('ov-open'); musicRestart(); newGame(); });
  // the X: close the game over popup without saving; GAME OVER stays in the game until a tap starts a new one
  function closeOver() {
    if (G.state !== 'over' || ovOver.hidden) return;
    ovOver.hidden = true;
    document.body.classList.remove('ov-open');
    G.enemies = []; G.eshots = []; G.shots = []; G.caps = []; G.boss = null;   // clear the board so GAME OVER reads cleanly
    try { hero.focus({ preventScroll: true }); } catch (e) {}
  }
  $('overClose').addEventListener('click', closeOver);
  $('initialsInput').addEventListener('keydown', function (e) { if (e.key === 'Escape') { e.target.blur(); closeOver(); } });
  $('nextBtn').addEventListener('click', nextLevel);

  /* ================= drawing ================= */
  function draw() {
    var P = PAL[settings.palette];
    ctx.setTransform(RES, 0, 0, RES, 0, 0);
    ctx.imageSmoothingEnabled = false;
    ctx.save();
    if (G.shake > 0 && FX[settings.fx].shake && !reduceMotion) { var m = FX[settings.fx].shake; ctx.translate(Math.round((Math.random() * 2 - 1) * m), Math.round((Math.random() * 2 - 1) * m)); }
    ctx.drawImage(bg, 0, 0);
    var st = G.storm.cur;
    // stars fade as the storm closes in
    ctx.fillStyle = P.star;
    var starFade = clamp(1 - st * 0.5, 0, 1);
    for (var i = 0; i < G.stars.length; i++) {
      var sr = G.stars[i], a = (0.5 + 0.5 * Math.sin(G.t * sr.sp + sr.p)) * starFade;
      if (a < 0.25) continue;
      ctx.globalAlpha = a; ctx.fillRect(sr.x, sr.y, 1, 1);
      if (sr.big && a > 0.8) { ctx.fillRect(sr.x - 1, sr.y, 3, 1); ctx.fillRect(sr.x, sr.y - 1, 1, 3); }
    }
    ctx.globalAlpha = 1;
    if (st > 0) { ctx.fillStyle = '#16241e'; ctx.globalAlpha = Math.min(0.55, st * 0.18); ctx.fillRect(0, 0, W, HORIZON); ctx.globalAlpha = Math.min(0.3, st * 0.08); ctx.fillRect(0, HORIZON, W, H - HORIZON); ctx.globalAlpha = 1; }
    if (G.skyFlash > 0) { ctx.fillStyle = '#d8dcff'; ctx.globalAlpha = clamp(G.skyFlash * 1.6, 0, 0.5); ctx.fillRect(0, 0, W, HORIZON); ctx.globalAlpha = 1; }
    if (G.storm.bolt && !G.storm.bolt.strike) drawBolt(G.storm.bolt, 0.7);
    drawCloud(P);
    if (st > 0.3) { var nc = Math.min(G.storm.clouds.length, Math.ceil(st * 3)); for (var c = 0; c < nc; c++) { var cl = G.storm.clouds[c], sp = STORM_SPRITES[cl.spr]; if (sp) { ctx.globalAlpha = Math.min(1, (st - 0.3) * 0.7); ctx.drawImage(sp, Math.round(cl.x), Math.round(cl.y)); } } ctx.globalAlpha = 1; }
    ctx.drawImage(sceneC, 0, 0);
    if (SCENES[sceneN] === 'causeway') drawTraffic(ctx);
    if (st > 0) tintLayer(sceneMask, st);
    if (SCENES[sceneN] === 'pier') drawWheel(P);
    if (SCENE_WATER[sceneN]) drawSea(P, st);
    if (hasFront) { ctx.drawImage(frontC, 0, 0); if (st > 0) tintLayer(frontMask, st); }
    if (SCENES[sceneN] === 'seawall') drawRunners(); else if (SCENES[sceneN] === 'strand') drawBuggy();
    var sway = 0.6 + st * 1.4;
    if (SCENE_PALMS[sceneN]) {
      drawPalm(P.palm, 4, SAND + 1, 1, Math.sin(G.t * (0.8 + st * 0.6)) * sway + (G.storm.gust ? G.storm.gust.dir * 2 : 0));
      drawPalm(P.palm, W - 5, SAND + 1, -1, Math.sin(G.t * (0.8 + st * 0.6) + 1) * sway + (G.storm.gust ? G.storm.gust.dir * 2 : 0));
    }

    drawWire(P);
    if (G.gull && G.state !== 'boot') { var gs = SPRITES.gull.clean[0]; blit(ctx, G.gull.vx > 0 ? flipCache(gs) : gs, G.gull.x, G.gull.y + Math.round(Math.sin(G.t * 8)) * 0.5); }
    if (G.boss && (G.phase === 'boss' || G.phase === 'bossDeath')) drawBoss(G.boss);
    else if (G.boss && (G.phase === 'treasure' || G.phase === 'treasureEnd')) drawWreck(G.boss);
    if (G.loot && G.loot.length) drawLoot();
    if (G.state === 'play' && (G.capture || G.rescue || (G.boss && G.boss.captive))) drawCaptives();
    drawEnemies();
    for (var cv = 0; cv < G.covers.length; cv++) drawSaved(G.covers[cv]);
    for (var cI = 0; cI < G.caps.length; cI++) { var cp = G.caps[cI]; ctx.globalAlpha = Math.floor(cp.t * 6) % 3 === 0 ? 0.85 : 1; blit(ctx, SPRITES.capsules[cp.kind], cp.x, cp.y); ctx.globalAlpha = 1; }
    for (var k = 0; k < G.shots.length; k++) drawShot(G.shots[k]);
    for (var u = 0; u < G.eshots.length; u++) drawEShot(G.eshots[u]);
    G.bombs.forEach(function (b) { var bi = SPRITES.capsules.b409; blit(ctx, bi, b.x, b.y, 0.6); ctx.fillStyle = '#ffd166'; ctx.globalAlpha = 0.6; ctx.fillRect(Math.round(b.x) - 1, Math.round(b.y + bi.gh * 0.3), 3, 6); ctx.globalAlpha = 1; });
    G.seekers.forEach(function (s) { ctx.fillStyle = '#5fa3ef'; ctx.globalAlpha = 0.4; ctx.fillRect(Math.round(s.x) - 2, Math.round(s.y) - 2, 5, 5); ctx.globalAlpha = 1; ctx.fillStyle = '#ffffff'; ctx.fillRect(Math.round(s.x) - 1, Math.round(s.y) - 1, 3, 3); });
    if (G.tide) drawTide(G.tide);
    drawShip();
    for (var rI = 0; rI < G.rings.length; rI++) drawRing(G.rings[rI]);
    for (var pI = 0; pI < G.parts.length; pI++) { var p = G.parts[pI]; ctx.fillStyle = p.c; ctx.fillRect(Math.round(p.x), Math.round(p.y), 1, 1); }
    for (var oI = 0; oI < G.pops.length; oI++) { var o = G.pops[oI]; drawText(ctx, o.txt, o.x, Math.round(o.y), o.c, o.s || 1, 'center'); }
    // rain in front of everything, then a lightning strike
    var n = rainCount(), slant = G.storm.wind * 30 + (G.storm.gust ? G.storm.gust.dir * 40 : 0);
    if (n > 0) { ctx.fillStyle = '#b8d8f0'; ctx.globalAlpha = 0.45; for (var r = 0; r < n && r < G.storm.rain.length; r++) { var d = G.storm.rain[r]; for (var l = 0; l < d.len; l++) ctx.fillRect(Math.round(d.x - slant * l * 0.004 * 6), Math.round(d.y + l), 1, 1); } ctx.globalAlpha = 1; }
    if (G.storm.bolt && G.storm.bolt.strike) drawBolt(G.storm.bolt, 1);
    ctx.restore();
    if (G.flash > 0) { ctx.fillStyle = '#ffffff'; ctx.globalAlpha = G.flash * (reduceMotion ? 0.15 : 0.45); ctx.fillRect(0, 0, W, H); ctx.globalAlpha = 1; }
    drawHud(P);
  }
  var flipStore = new Map();
  function flipCache(img) { var f = flipStore.get(img); if (!f) { f = flipX(img); flipStore.set(img, f); } return f; }
  function drawBolt(b, alpha) {
    ctx.strokeStyle = '#ffffff'; ctx.globalAlpha = alpha; ctx.lineWidth = 1;
    ctx.fillStyle = '#ffffff';
    for (var i = 2; i < b.pts.length; i += 2) { var x0 = b.pts[i - 2], y0 = b.pts[i - 1], x1 = b.pts[i], y1 = b.pts[i + 1], steps = Math.max(1, Math.round(Math.abs(y1 - y0))); for (var s = 0; s <= steps; s++) { var t = s / steps; ctx.fillRect(Math.round(x0 + (x1 - x0) * t), Math.round(y0 + (y1 - y0) * t), b.strike ? 2 : 1, 1); } }
    ctx.globalAlpha = 1;
  }
  function drawEnemies() {
    for (var j = 0; j < G.enemies.length; j++) {
      var e = G.enemies[j];
      if (e.mode === 'dead' || (e.mode === 'enter' && e.t < 0) || (e.mode === 'pierfly' && e.t < e.delay)) continue;
      var spr = spriteOf(e.kind); if (!spr) continue;
      var stage = (e.max || 1) - e.hp;  // 0 bad, 1 brighter, 2 your clean flash
      var img = e.flash > 0 ? spr.flash[0] : stage >= 2 ? spr.clean[0] : stage === 1 ? spr.mid[0] : spr.bad[0];
      if (e.kind === 'pirateA' || e.kind === 'pirateB' || e.kind === 'pirateC' || e.kind === 'babyShark') img = e.flash > 0 ? spr.flash[0] : spr.clean[0];
      if (e.kind === 'babyShark' && e.vx > 0) img = flipCache(img);
      if (e.swing) { ctx.fillStyle = '#a8743c'; var steps = Math.round(e.len); for (var r = 0; r < steps; r += 2) ctx.fillRect(Math.round(e.ax + (e.x - e.ax) * r / steps), Math.round(e.ay + (e.y - e.ay) * r / steps), 1, 1); }
      // invaders in formation bob half a pixel, out of step with their neighbors
      var bob = e.mode === 'form' ? (Math.floor(G.t * 2 + (e.c || 0) * 0.5) % 2) * 0.5 : 0;
      blit(ctx, img, e.x, e.y + bob);
    }
  }
  function snapA(v) { return Math.round(v * ART_A) / ART_A; }
  // a pixel arrow pointing along (dx, dy): one of right/left/down
  function chevron(x, y, dx, dy, color, alpha) {
    ctx.fillStyle = color; ctx.globalAlpha = alpha;
    for (var k = 0; k < 4; k++) {
      if (dy) { ctx.fillRect(x - 3 + k, y + k, 1, 2); ctx.fillRect(x + 3 - k, y + k, 1, 2); }
      else { ctx.fillRect(x + dx * k, y - 3 + k, 2, 1); ctx.fillRect(x + dx * k, y + 3 - k, 2, 1); }
    }
    ctx.globalAlpha = 1;
  }
  // an oval outline in single pixels
  function pxRing(cx, cy, rx, ry, color, alpha) {
    ctx.fillStyle = color; ctx.globalAlpha = alpha;
    var n = Math.max(16, Math.round((rx + ry) * 3));
    for (var i = 0; i < n; i++) { var a = i / n * Math.PI * 2; ctx.fillRect(Math.round(cx + Math.cos(a) * rx), Math.round(cy + Math.sin(a) * ry), 1, 1); }
    ctx.globalAlpha = 1;
  }
  // the alien palms' tractor beam: a cone of glowing edges, rings sliding down and sparkles rising
  function drawBeam(bx, top, bottom) {
    var len = Math.max(1, bottom - top), y, hw;
    ctx.fillStyle = '#8fff8a';
    for (y = top; y < bottom; y += 2) {
      hw = Math.round(3 + (y - top) / len * 7);
      ctx.globalAlpha = 0.3; ctx.fillRect(bx - hw, y, 1, 1); ctx.fillRect(bx + hw, y, 1, 1);
    }
    for (var r = 0; r < len; r += 10) {
      y = top + (r + G.t * 28) % len;
      hw = 3 + (y - top) / len * 7;
      pxRing(bx, Math.round(y), Math.round(hw), Math.max(1, Math.round(hw * 0.3)), '#8fff8a', 0.35 + 0.45 * (y - top) / len);
    }
    ctx.fillStyle = '#e8ffe0';
    for (var k = 0; k < 9; k++) {
      y = Math.round(bottom - (k * 23 + G.t * 34) % len);
      hw = 3 + (y - top) / len * 7;
      ctx.globalAlpha = 0.85; ctx.fillRect(Math.round(bx + Math.sin(k * 2.1 + G.t * 3) * hw * 0.7), y, 1, 1);
    }
    ctx.globalAlpha = 1;
  }
  // the gator's tail sweeping in from the screen edge: thick at the edge, a point at the tip, with ridges on top
  function drawGatorTail(edge, tip, cy) {
    var len = Math.abs(tip - edge), dir = tip >= edge ? 1 : -1;
    for (var i = 0; i <= len; i++) {
      var x = Math.round(edge + dir * i), f = 1 - i / Math.max(1, len), th = Math.max(2, Math.round(2 + f * 10));
      ctx.fillStyle = '#506a26'; ctx.fillRect(x, cy - Math.round(th / 2), 1, th);
      ctx.fillStyle = '#7d9a3c'; ctx.fillRect(x, cy + Math.round(th / 2) - 2, 1, 1);
      if (i % 6 < 2 && th > 4) { ctx.fillStyle = '#34461a'; ctx.fillRect(x, cy - Math.round(th / 2) - 2, 1, 2); }
    }
  }
  function drawBoss(b) {
    var def = b.def, w = b.w, h = b.h, x0 = bossX0(b), y0 = b.y;
    var fl = b.flash > 0 || (G.phase === 'bossDeath' && Math.floor(G.t * 20) % 2);
    if (b.key === 'shark' && b.st === 'fin') {
      // only the dorsal fin shows, cutting through the water
      var f = def.fin, src = b.dir < 0 ? def.imgL : def.img, a0 = b.dir < 0 ? 1 - f[2] : f[0];
      var gw = (f[2] - f[0]) * w, gh = (f[3] - f[1]) * h;
      ctx.drawImage(src, a0 * src.width, f[1] * src.height, (f[2] - f[0]) * src.width, (f[3] - f[1]) * src.height, snapA(b.x - gw / 2), snapA(HORIZON + 3 - gh), gw, gh);
      ctx.fillStyle = '#e1f4ff'; ctx.globalAlpha = 0.8; ctx.fillRect(Math.round(b.x - gw / 2 - 3), HORIZON + 2, Math.round(gw + 6), 1); ctx.globalAlpha = 1;
      return;
    }
    var img;
    if (def.vars) {
      var mask = 0;
      if (b.key === 'palms') b.crowns.forEach(function (c, k) { if (c.alive) mask |= 1 << k; });
      else b.sailHp.forEach(function (v, k) { if (v > 0) mask |= 1 << k; });
      img = (fl ? def.varsFlash : def.vars)[mask];
    } else img = facingLeft(b) ? (fl ? def.flashL : def.imgL) : (fl ? def.flash : def.img);
    if (b.spin) { ctx.save(); ctx.translate(b.x, y0 + h / 2); ctx.rotate(b.spin); ctx.drawImage(img, -w / 2, -h / 2, w, h); ctx.restore(); }
    else ctx.drawImage(img, snapA(x0), snapA(y0), w, h);
    if (b.key === 'gator' && b.st === 'open') {
      var mp = bossPt(b, def.mouth[0], def.mouth[1]); ctx.fillStyle = '#c8ff6a'; ctx.globalAlpha = 0.25 + 0.2 * Math.abs(Math.sin(G.t * 8));
      ctx.beginPath(); ctx.ellipse(mp[0], mp[1], w * 0.11, h * 0.12, 0, 0, Math.PI * 2); ctx.fill(); ctx.globalAlpha = 1;
      drawText(ctx, 'GULP', mp[0], Math.round(mp[1] - h * 0.3), '#c8ff6a', 1, 'center');
    }
    if (b.key === 'crab' && b.st === 'tele') {
      // where the claws will slam: arrows falling to a blinking target on the water under each claw
      var on = Math.floor(G.t * 12) % 2, top = Math.round(y0 + h) + 2;
      [x0 + w * 0.185, x0 + w * 0.815].forEach(function (lx) {
        lx = Math.round(lx);
        for (var ay = top + Math.floor(G.t * 40) % 12; ay < SHIP_Y - 2; ay += 12) chevron(lx, ay, 0, 1, '#ff5a7a', 0.75);
        pxRing(lx, SHIP_Y + 6, Math.round(w * 0.17), 3, '#ff5a7a', on ? 0.95 : 0.45);
      });
      if (on) drawText(ctx, '!', Math.round(x0 + w / 2), SHIP_Y - 4, '#ff5a7a', 2, 'center');
    }
    if (b.key === 'palms' && b.beam) {
      var bx = Math.round(beamX(b)), by = Math.round(y0 + h * def.beam[1]);
      if (b.beam.t > 1.8) {
        // charging: a blinking target where the beam will land
        pxRing(bx, SHIP_Y + 6, 9, 3, '#ff5a7a', Math.floor(G.t * 12) % 2 ? 0.95 : 0.4);
        chevron(bx, by + 4 + Math.floor(G.t * 40) % 10, 0, 1, '#ff5a7a', 0.8);
      } else drawBeam(bx, by, SAND);
    }
    if (b.key === 'gator' && (b.st === 'tele' || b.st === 'tail')) {
      var hx = b.side ? Math.round(W / 2) : 0;
      if (b.st === 'tele') {
        // the tail sweeps in from the screen edge: arrows racing along the ship line show which half
        var dirx = b.side ? -1 : 1, edge = b.side ? W : 0, sh = Math.floor(G.t * 60) % 14;
        for (var ax = 6 + sh; ax < W / 2 - 4; ax += 14) chevron(Math.round(edge + dirx * ax), SHIP_Y - 3, dirx, 0, '#ff5a7a', Math.floor(G.t * 12) % 2 ? 0.9 : 0.5);
        drawText(ctx, 'TAIL!', hx + W / 4, SHIP_Y - 24, '#ff5a7a', 1, 'center');
      }
      else { var prog = 1 - b.stT / 0.6, tx = b.side ? W - prog * W / 2 : prog * W / 2; drawGatorTail(b.side ? W : 0, tx, SHIP_Y - 2); }
    }
  }
  function drawShot(sh) {
    var sx = Math.round(sh.x), sy = Math.round(sh.y);
    var col = sh.laser ? '#00e5ff' : (G.pw.fanT > 0 ? '#ffd166' : '#9dff6a');
    var sp = Math.max(1, Math.hypot(sh.vx, sh.vy)), nx = -sh.vx / sp, ny = -sh.vy / sp;
    ctx.fillStyle = col;
    for (var k = 1; k <= 4; k++) { ctx.globalAlpha = 0.5 - k * 0.1; ctx.fillRect(Math.round(sx + nx * k * 3) - (k < 3 ? 1 : 0), Math.round(sy + ny * k * 3), k < 3 ? 2 : 1, 3); }
    ctx.globalAlpha = 0.3; ctx.fillRect(sx - 2, sy - 2, 5, sh.laser ? 13 : 9);
    ctx.globalAlpha = 1; ctx.fillRect(sx - 1, sy - 1, 3, sh.laser ? 11 : 6);
    ctx.fillStyle = '#ffffff'; ctx.fillRect(sx, sy, 1, sh.laser ? 9 : 4);
  }
  function drawSaved(co) {
    var k = co.t / co.life;
    ctx.globalAlpha = k < 0.45 ? 1 : Math.max(0, 1 - (k - 0.45) / 0.55);
    blit(ctx, co.t < 0.07 ? co.fl : co.img, co.x, co.y);
    // four twinkles turning around it
    var r = (co.img.gw || 10) * 0.62;
    for (var i = 0; i < 4; i++) {
      var a = co.t * 5 + i * Math.PI / 2, px = Math.round(co.x + Math.cos(a) * r), py = Math.round(co.y + Math.sin(a) * r * 0.8);
      ctx.fillStyle = i % 2 ? '#ffd166' : '#ffffff';
      ctx.fillRect(px, py - 1, 1, 3); ctx.fillRect(px - 1, py, 3, 1);
    }
    ctx.globalAlpha = 1;
  }
  function drawEShot(es) {
    var x = Math.round(es.x), y = Math.round(es.y), img = null;
    if (es.k === 'feather') img = SPRITES.feather.clean[0];
    else if (es.k === 'bubble') img = SPRITES.bubble.clean[0];
    else if (es.k === 'coconut') img = SPRITES.coconut.clean[0];
    else if (es.k === 'cannon') img = SPRITES.cannonball.clean[0];
    if (img) { blit(ctx, img, es.x, es.y); return; }
    if (es.k === 'poop') {   // a seagull dropping: white with a dark middle
      ctx.fillStyle = '#f4f1e8'; ctx.fillRect(x - 1, y - 2, 3, 5); ctx.fillRect(x - 2, y - 1, 5, 3);
      ctx.fillStyle = '#5b4a30'; ctx.fillRect(x, y, 1, 1);
      ctx.fillStyle = '#ffffff'; ctx.fillRect(x - 1, y - 2, 1, 1);
      return;
    }
    var col = es.k === 'tooth' ? '#ffffff' : es.k === 'shard' ? '#d8a870' : '#ff4f9a';
    ctx.fillStyle = col; ctx.globalAlpha = 0.35; ctx.fillRect(x - 2, y - 2, 6, 7);
    ctx.globalAlpha = 1; ctx.fillRect(x - 1, y - 1, 4, 5);
    ctx.fillStyle = '#ffffff'; ctx.fillRect(x, y, 2, 2);
  }
  function drawTide(t) {
    var y = Math.round(t.y);
    ctx.fillStyle = '#1fa892'; ctx.globalAlpha = 0.55; ctx.fillRect(0, y, W, H - y); ctx.globalAlpha = 1;
    ctx.fillStyle = '#ffffff';
    for (var x = 0; x < W; x += 2) ctx.fillRect(x, y + Math.round(Math.sin(x * 0.25 + G.t * 8) * 2), 2, 2);
    drawText(ctx, 'BORN ON THE ISLAND', W / 2, Math.min(H - 20, y + 10), '#ffffff', 1, 'center');
  }
  function drawShip() {
    var s = G.ship;
    if (!s.alive || G.state === 'boot' || G.state === 'story' || G.state === 'title' || G.state === 'idle' || (s.inv > 0 && Math.floor(G.t * 12) % 2)) return;
    var img = SPRITES.machine.clean[0];
    guns().forEach(function (gx) {
      blit(ctx, img, gx, s.y + 1.5);
      var tx = Math.round(gx + TIP_DX);
      if (G.muzzle > 0) { ctx.fillStyle = G.pw.laserT > 0 ? '#bff6ff' : '#fff3b0'; ctx.fillRect(tx - 2, s.y - 14, 5, 1); ctx.fillRect(tx, s.y - 16, 1, 5); }
    });
    if (G.pw.beadsT > 0 && !(G.pw.beadsHits === 1 && Math.floor(G.t * 8) % 2)) {
      var span = G.pw.twinT > 0 ? TWIN_DX : 0, mid = s.x + span / 2, rx = 13 + span / 2, ry = 13, cols = ['#b08aff', '#f5c542', '#3fa34d'];
      for (var i = 0; i < 18; i++) { var a = i / 18 * Math.PI * 2 + G.t * 2; ctx.fillStyle = cols[i % 3]; ctx.fillRect(Math.round(mid + Math.cos(a) * rx) - 1, Math.round(s.y + Math.sin(a) * ry) - 1, 2, 2); }
    }
  }
  function drawRing(r) {
    var k = r.t / r.life, rad = r.max * (0.2 + 0.8 * k);
    ctx.fillStyle = r.c; ctx.globalAlpha = Math.max(0, 1 - k);
    var step = Math.max(0.02, 1.2 / Math.max(4, rad));
    for (var a = 0; a < 6.283; a += step) ctx.fillRect(Math.round(r.x + Math.cos(a) * rad), Math.round(r.y + Math.sin(a) * rad), 1, 1);
    ctx.globalAlpha = 1;
  }
  function drawWheel(P) {
    var g = wheelGeom(), ang = G.t * 0.25, party = G.wheelParty > 0;
    ctx.fillStyle = P.sil;
    for (var a = 0; a < 6.283; a += 0.12) ctx.fillRect(Math.round(g.cx + Math.cos(a) * g.R), Math.round(g.cy + Math.sin(a) * g.R), 1, 1);
    for (var s = 0; s < 8; s++) {
      var aa = ang + s * 0.785;
      for (var r = 0; r < g.R; r += 2) ctx.fillRect(Math.round(g.cx + Math.cos(aa) * r), Math.round(g.cy + Math.sin(aa) * r), 1, 1);
      ctx.fillRect(Math.round(g.cx + Math.cos(aa) * g.R) - 1, Math.round(g.cy + Math.sin(aa) * g.R), 3, 2);
    }
    var cols = party ? ['#ff5a7a', '#ffd166', '#7fd06a', '#5fa3ef', '#b08aff'] : [P.glint];
    for (var l = 0; l < 16; l++) {
      if (!party && ((Math.floor(G.t * 4) + l) % 3 || l % 2)) continue;
      ctx.fillStyle = cols[(l + Math.floor(G.t * 8)) % cols.length];
      var la = ang + l * 0.3927; ctx.fillRect(Math.round(g.cx + Math.cos(la) * g.R), Math.round(g.cy + Math.sin(la) * g.R), party ? 2 : 1, party ? 2 : 1);
    }
  }
  function drawSea(P, storm) {
    var SAND = seaBottom(sceneN);   // in the Pleasure Pier level the water stops at the beach
    var seaH = SAND - HORIZON;
    if (P.grid) {
      ctx.fillStyle = P.grid;
      var vx = W / 2;
      for (var c = -9; c <= 9; c++) {
        var bx = vx + c * (W / 5), prev = null;
        for (var y = HORIZON + 4; y < SAND; y += 1) { var k = (y - HORIZON) / seaH, px = Math.round(vx + (bx - vx) * k); if (px < -2 || px > W + 2) continue; var from = prev == null ? px : prev; ctx.fillRect(Math.min(from, px), y, Math.abs(px - from) + 1, 1); prev = px; }
      }
      var off = (G.t * (0.35 + storm * 0.2)) % 1;
      for (var i = 0; i < 10; i++) { var kk = Math.pow((i + off) / 10, 2.2); var yy = Math.round(HORIZON + 1 + kk * (seaH - 1) + Math.sin(G.t * 2 + i) * storm); ctx.fillRect(0, yy, W, 1); }
      ctx.fillStyle = P.crest; ctx.globalAlpha = 0.8; ctx.fillRect(0, HORIZON, W, 1); ctx.globalAlpha = 1;
      return;
    }
    var S = sunGeom(), rows = Math.max(6, Math.floor(seaH / 5));
    for (var r = 0; r < rows; r++) {
      var k2 = r / rows, y2 = Math.round(HORIZON + 2 + Math.pow(k2, 1.5) * (seaH - 5));
      var step = Math.round(7 + k2 * 14), len = Math.round(2 + k2 * 6 + storm * 2), speed = 4 + k2 * 10 + storm * 8;
      var off2 = Math.round((G.t * speed + r * 13) % step), glintHalf = S.r * (0.9 - k2 * 0.5) * (1 - storm * 0.3);
      for (var x = -step + off2; x < W; x += step) {
        var mid = x + len / 2, inGlint = Math.abs(mid - S.cx) < glintHalf;
        ctx.fillStyle = inGlint ? P.glint : P.crest;
        ctx.globalAlpha = inGlint ? 0.9 : (0.25 + k2 * 0.6);
        ctx.fillRect(x, y2 + Math.round(Math.sin(x * 0.2 + G.t * 2.4) * storm * 0.9), len, 1);
      }
    }
    ctx.globalAlpha = 1;
    if (!SCENE_SURF[sceneN]) return;   // surf only where the water meets a beach
    var foam = Math.sin(G.t * 1.3) * (1.5 + storm * 1.2);
    ctx.fillStyle = '#f4ead6'; ctx.globalAlpha = 0.7;
    for (var fx = 0; fx < W; fx += 3) ctx.fillRect(fx, Math.round(SAND - 1 + foam + Math.sin(fx * 0.3 + G.t * 2) * (0.8 + storm * 0.6)), 2, 1);
    ctx.globalAlpha = 1;
  }
  function drawLifeIcon(x, y) { blit(ctx, SPRITES.machine.clean[0], x + 3, y + 4.5, 0.3); }
  function drawHud(P) {
    if (G.state === 'boot' || G.state === 'story' || G.state === 'title' || G.state === 'idle' || G.ambientOnly) return;
    drawText(ctx, '1UP', 6, 3, '#ff5a7a', 1);
    if (settings.practice === 'on') drawText(ctx, 'PRACTICE', 22, 3, '#7fd06a', 1);
    drawText(ctx, pad(G.score, 6), 6, 10, '#f4ead6', 1);
    var cx = Math.round(W / 2);
    drawText(ctx, 'HIGH SCORE', cx, 3, '#ff5a7a', 1, 'center');
    drawText(ctx, pad(G.hi, 6), cx, 10, '#f4ead6', 1, 'center');
    var lives = Math.max(0, G.lives - (G.ship.alive ? 1 : 0));
    for (var i = 0; i < lives; i++) drawLifeIcon(3 + i * 7, H - 9);
    var cat = catFor(G.storm.target || 0), lv = 'LV ' + G.level;
    drawText(ctx, lv, W - 4, H - 8, P.onSand, 1, 'right');
    if (cat) drawText(ctx, 'CAT ' + cat, W - 10 - textWidth(lv, 1), H - 8, P.catOnSand, 1, 'right');
    var top = 18;
    if (G.boss && (G.phase === 'boss' || G.phase === 'bossDeath')) {
      var b = G.boss;
      drawText(ctx, b.def.name, 6, 18, '#ffd166', 1);
      ctx.fillStyle = 'rgba(0,0,0,0.6)'; ctx.fillRect(6, 25, W - 12, 4);
      ctx.fillStyle = '#ff5a7a'; ctx.fillRect(6, 25, Math.max(0, Math.round((W - 12) * b.hp / b.maxHp)), 4);
      ctx.fillStyle = '#ffd166'; ctx.fillRect(6, 25, Math.max(0, Math.round((W - 12) * b.hp / b.maxHp)), 1);
      top = 32;
    }
    if (G.phase === 'pier' && G.pier) drawText(ctx, 'HITS ' + G.pier.hits + '/' + G.pier.total, cx, 18, '#7fd06a', 1, 'center');
    if (G.phase === 'treasure' || G.phase === 'treasureEnd') drawText(ctx, 'TREASURE ' + commas(G.treasure || 0), cx, 18, '#ffd166', 1, 'center');
    if (G.phase === 'eye') { drawText(ctx, 'THE EYE OF THE STORM', cx, Math.round(H * 0.42), '#b4dcff', 1, 'center'); drawText(ctx, 'IT IS QUIET... TOO QUIET', cx, Math.round(H * 0.42) + 9, '#f4ead6', 1, 'center'); }
    if (G.phase === 'warning') {
      var on = Math.floor(G.t * 4) % 2;
      ctx.fillStyle = '#ff2a4a'; ctx.globalAlpha = on ? 0.5 : 0.2;
      for (var sx = -10; sx < W; sx += 10) { ctx.fillRect(sx + (G.t * 30 % 10), 30, 5, 4); ctx.fillRect(sx - (G.t * 30 % 10), Math.round(H * 0.6), 5, 4); }
      ctx.globalAlpha = 1;
      if (on) drawText(ctx, 'WARNING', cx, Math.round(H * 0.42), '#ff2a4a', 3, 'center');
      drawText(ctx, BOSSES[bossIndexFor(G.level)].name, cx, Math.round(H * 0.42) + 20, '#ffd166', 1, 'center');
      drawText(ctx, 'APPROACHING', cx, Math.round(H * 0.42) + 28, '#f4ead6', 1, 'center');
    }
    if (G.state === 'play' && G.banner && G.phase !== 'warning' && !G.userPaused) {
      drawText(ctx, G.banner.a, cx, Math.round(H * 0.4), '#ff5a7a', textWidth(G.banner.a, 2) <= W - 6 ? 2 : 1, 'center');
      drawText(ctx, G.banner.b, cx, Math.round(H * 0.4) + 14, '#ffd166', 1, 'center');
      if (G.banner.c) drawText(ctx, G.banner.c, cx, Math.round(H * 0.4) + 23, '#f4ead6', 1, 'center');
    }
    if (G.state === 'play' && G.hintT > 0 && !G.ambientOnly && G.phase === 'wave' && !G.userPaused) {
      var msg = VS_CABINET ? 'HOLD FIRE TO SHOOT' : touchSeen ? 'HOLD TO SHOOT  DRAG TO MOVE' : 'HOLD MOUSE OR SPACE TO SHOOT';
      if (Math.floor(G.t * 2) % 2 || G.steered) drawText(ctx, msg, cx, Math.max(22, G.ship.y - 26), '#f4ead6', 1, 'center');
    }
    if (G.paused && !G.userPaused && G.state === 'play') drawText(ctx, 'PAUSED', cx, Math.round(H * 0.45), '#ffd166', 2, 'center');
    if (G.state === 'over' && ovOver.hidden) {
      drawText(ctx, G.won ? 'YOU MADE IT!' : 'GAME OVER', cx, Math.round(H * 0.4), '#ff5a7a', 2, 'center');
      if (Math.floor(G.t * 2) % 2) drawText(ctx, VS_CABINET ? 'PRESS START TO PLAY AGAIN' : touchSeen ? 'TAP TO PLAY AGAIN' : 'CLICK TO PLAY AGAIN', cx, Math.round(H * 0.4) + 16, '#f4ead6', 1, 'center');
    }
    var row = 0, pw = G.pw;
    ['fan', 'rapid', 'laser', 'twin', 'beads'].forEach(function (k) {
      var left = pw[k + 'T'];
      if (!(left > 0)) return;
      var def = POWER[k], y = top + row * 7, lbl = def.short + (k === 'fan' && pw.fan >= 2 ? ' MAX' : '');
      var beads = k === 'beads', low = beads ? pw.beadsHits === 1 : left < 3;
      drawText(ctx, lbl, 6, y, low && Math.floor(G.t * 6) % 2 ? '#ffffff' : def.color, 1);
      var bw = 18, fill = Math.max(1, Math.min(bw, Math.round(bw * (beads ? (pw.beadsHits || 1) / BEADS_HITS : left / def.time)))), bxx = 6 + textWidth(lbl, 1) + 3;
      ctx.fillStyle = 'rgba(0,0,0,0.5)'; ctx.fillRect(bxx, y + 1, bw, 3);
      ctx.fillStyle = def.color; ctx.fillRect(bxx, y + 1, fill, 3);
      row++;
    });
    if (G.combo >= 3 && G.comboT > 0) drawText(ctx, 'COMBO X' + G.combo, W - 6, top + 8, Math.floor(G.t * 8) % 2 ? '#ff5a7a' : '#ffd166', 1, 'right');
    if (G.announce && G.state === 'play') {
      var ac = Math.floor(G.t * 10) % 2 ? '#ffffff' : G.announce.c;
      drawText(ctx, G.announce.txt, cx, Math.round(H * 0.5), ac, 2, 'center');
      if (G.announce.sub) drawText(ctx, G.announce.sub, cx, Math.round(H * 0.5) + 14, G.announce.c, 1, 'center');
    }
  }

  /* ================= main loop ================= */
  var last = 0, acc = 0, STEP = 1 / 60, running = true;
  function frame(ts) {
    if (!running) return;
    requestAnimationFrame(frame);
    if (!artReady || testFrozen) return;
    var dt = last ? Math.min(0.1, (ts - last) / 1000) : STEP;
    last = ts; acc += dt;
    while (acc >= STEP) { update(STEP); acc -= STEP; }
    draw();
  }
  var testFrozen = false;   // test hook only: lets a recorder step the game frame by frame
  function setRunning(on) { if (on === running) return; running = on; if (on) { last = 0; acc = 0; requestAnimationFrame(frame); } }

  /* ================= input: hold to shoot, slide to steer ================= */
  var touchSeen = !!(window.matchMedia && window.matchMedia('(pointer: coarse)').matches);
  function isUi(el) { return !!(el && el.closest && el.closest('a, button, input, select, .overlay, .hud-tools, .opt-sheet, .menu, .help-drawer, .help-tab')); }
  var tch = null;
  hero.addEventListener('touchstart', function (e) {
    touchSeen = true;
    if (tch || isUi(e.target)) return;
    var t = e.changedTouches[0];
    tch = { id: t.identifier, x0: t.clientX, y0: t.clientY, lastX: t.clientX, lastY: t.clientY, axis: null };
    mouseTarget = null;
    audio();
    if (canPlay()) { if (e.cancelable) e.preventDefault(); pressFire(); buzz(8, true); }
  }, { passive: false });
  hero.addEventListener('touchmove', function (e) {
    if (!tch) return;
    var t = null;
    for (var i = 0; i < e.changedTouches.length; i++) if (e.changedTouches[i].identifier === tch.id) t = e.changedTouches[i];
    if (!t) return;
    var dx = t.clientX - tch.lastX, dy = t.clientY - tch.lastY; tch.lastX = t.clientX; tch.lastY = t.clientY;
    if (canPlay()) {
      if (e.cancelable) e.preventDefault();
      G.ship.x = clampShip(G.ship.x + dx / SCALE * 1.3);
      G.ship.y = clampShipY(G.ship.y + dy / SCALE * 1.3);
      G.steered = true;
      return;
    }
    var tx = t.clientX - tch.x0, ty = t.clientY - tch.y0;
    if (!tch.axis && Math.max(Math.abs(tx), Math.abs(ty)) > 7) tch.axis = Math.abs(tx) >= Math.abs(ty) * 0.75 ? 'x' : 'y';
    if (tch.axis === 'y') { G.holding = false; return; }
    if (tch.axis === 'x') {
      if (e.cancelable) e.preventDefault();
      if (canPlay()) { G.ship.x = clampShip(G.ship.x + dx / SCALE * 1.3); G.steered = true; }
    }
  }, { passive: false });
  function endTouch(e) {
    if (!tch) return;
    for (var i = 0; i < e.changedTouches.length; i++) if (e.changedTouches[i].identifier === tch.id) { tch = null; G.holding = false; return; }
  }
  hero.addEventListener('touchend', endTouch, { passive: true });
  hero.addEventListener('touchcancel', endTouch, { passive: true });
  hero.addEventListener('mousemove', function (e) {
    if (touchSeen) return;
    var r = world.getBoundingClientRect();
    mouseTarget = (e.clientX - r.left) / SCALE;
    mouseTargetY = (e.clientY - r.top) / SCALE;
    if (G.state === 'play') G.steered = true;
  });
  hero.addEventListener('mouseleave', function () { mouseTarget = null; mouseTargetY = null; });
  hero.addEventListener('mousedown', function (e) {
    audio();
    if (touchSeen || e.button !== 0 || isUi(e.target)) return;
    if (canPlay()) { pressFire(); e.preventDefault(); }
  });
  window.addEventListener('mouseup', function () { if (!touchSeen) G.holding = false; });
  window.addEventListener('blur', function () { G.holding = false; keys.left = keys.right = keys.up = keys.down = false; });
  function heroInView() { var r = hero.getBoundingClientRect(); return r.bottom > r.height * 0.5 && r.top < window.innerHeight * 0.5; }
  document.addEventListener('keydown', function (e) {
    if (e.target && /INPUT|TEXTAREA|SELECT/.test(e.target.tagName)) return;
    if (!$('boot').hidden) { endBoot(); return; }
    var onCtl = e.target && e.target.closest && e.target.closest('a, button, input, select');
    if ((e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') && !onCtl && heroInView()) {
      if (G.state === 'title') { e.preventDefault(); startPlay(); return; }
      if (pausedByUser()) { e.preventDefault(); resumePlay(); return; }
    }
    if (G.state === 'story' && heroInView() && !helpOpen) {
      var onControl = e.target && e.target.closest && e.target.closest('a, button');
      if ((e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') && onControl) return;
      if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar' || e.key === 'ArrowRight') { e.preventDefault(); storyNext(); return; }
      if (e.key === 'Escape' && menu.hidden && sheet.hidden && !helpOpen) { startFromStory(); return; }
    }
    if (G.state === 'over' && !$('enterBlock').hidden) {
      if (e.key === 'Enter') { saveScore(); e.preventDefault(); return; }
      if (e.key === 'Backspace') { activeSlot = Math.max(0, activeSlot - 1); renderInitials(); e.preventDefault(); return; }
      if (e.key.length === 1 && /[a-z0-9]/i.test(e.key)) { typeChar(e.key); e.preventDefault(); return; }
    }
    if (G.state === 'over' && ovOver.hidden && heroInView() && (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') && !(e.target && e.target.closest && e.target.closest('a, button'))) { e.preventDefault(); musicRestart(); newGame(); return; }
    if (e.key === 'Escape') { if (volOpen) volShow(false); closeMenu(); closeOpts(); closeHelp(); closeOver(); return; }
    if (!(G.state === 'play' && heroInView())) return;
    if (e.key === 'ArrowLeft' || e.key === 'a' || e.key === 'A') { keys.left = true; mouseTarget = null; G.steered = true; e.preventDefault(); }
    else if (e.key === 'ArrowRight' || e.key === 'd' || e.key === 'D') { keys.right = true; mouseTarget = null; G.steered = true; e.preventDefault(); }
    else if (e.key === 'ArrowUp' || e.key === 'w' || e.key === 'W') { keys.up = true; mouseTargetY = null; G.steered = true; e.preventDefault(); }
    else if (e.key === 'ArrowDown' || e.key === 's' || e.key === 'S') { keys.down = true; mouseTargetY = null; G.steered = true; e.preventDefault(); }
    else if (e.key === ' ' || e.key === 'Spacebar') { e.preventDefault(); audio(); if (!G.holding) pressFire(); }
    else if (e.key === 'p' || e.key === 'P') togglePause();
    else if (e.key === 'b' || e.key === 'B') useBomb(0);
    else if (e.key === '1' || e.key === '2' || e.key === '3') useBomb(Number(e.key) - 1);
  });
  document.addEventListener('keyup', function (e) {
    if (e.key === 'ArrowLeft' || e.key === 'a' || e.key === 'A') keys.left = false;
    if (e.key === 'ArrowRight' || e.key === 'd' || e.key === 'D') keys.right = false;
    if (e.key === 'ArrowUp' || e.key === 'w' || e.key === 'W') keys.up = false;
    if (e.key === 'ArrowDown' || e.key === 's' || e.key === 'S') keys.down = false;
    if (e.key === ' ' || e.key === 'Spacebar') G.holding = false;
  });
  document.addEventListener('click', function (e) { var el = e.target.closest && e.target.closest('[data-buzz], .seg button'); if (el) { buzz(10, true); SFX.tick(); } });
  soundBtn.addEventListener('click', function () { settings.sound = !settings.sound; settings.mute = !settings.sound; applySettings(); if (settings.sound) { audio(); SFX.tick(); if (G.state !== 'boot') musicStart(); } });
  buzzBtn.addEventListener('click', function () { settings.buzz = !settings.buzz; applySettings(); buzz(15, true); });
  /* ================= volume panel: music and effects ================= */
  // The sliders button next to the speaker opens two sliders. The game waits while it is open.
  var volBtn = $('volBtn'), volPanel = $('volPanel'), volOpen = false;
  function volFill() {
    ['musicVol', 'sfxVol'].forEach(function (k) {
      var pct = Math.round(settings[k] * 100), el = $(k), out = $(k + 'Out');
      if ('value' in el) el.value = String(pct);
      out.textContent = pct + '%';
    });
  }
  function volShow(on) {
    volOpen = !!on;
    volPanel.hidden = !volOpen;
    volBtn.setAttribute('aria-expanded', String(volOpen));
    if (volOpen) { volFill(); G.holding = false; }
    syncPause();
  }
  volBtn.addEventListener('click', function () { volShow(!volOpen); });
  $('volClose').addEventListener('click', function () { volShow(false); try { volBtn.focus({ preventScroll: true }); } catch (e) {} });
  ['musicVol', 'sfxVol'].forEach(function (k) {
    $(k).addEventListener('input', function (e) {
      settings[k] = clamp(Number(e.target.value) / 100, 0, 1);
      if (settings[k] > 0 && !settings.sound) { settings.sound = true; settings.mute = false; }
      applySettings(); audio(); volFill();
      if (k === 'musicVol' && G.state !== 'boot') musicStart();
    });
    $(k).addEventListener('change', function () { if (k === 'sfxVol') SFX.shot(); });
  });
  function togglePause() {
    G.userPaused = !G.userPaused;
    pauseBtn.setAttribute('aria-pressed', String(G.userPaused));
    pauseBtn.setAttribute('aria-label', G.userPaused ? 'Resume game' : 'Pause game');
    if (G.userPaused && G.state === 'play') showTap('PAUSED', false); else hideTap();
    syncPause();
  }
  pauseBtn.addEventListener('click', togglePause);

  /* ================= pausing when not visible ================= */
  var heroRatio = 1;
  function syncPause() {
    var hidden = document.hidden;
    G.paused = G.userPaused || hidden || helpOpen || consentWait || volOpen;
    if (settings.layout === 'top') { G.ambientOnly = false; setRunning(!hidden && heroRatio > 0); if (heroRatio < 0.35) G.paused = true; }
    else { G.ambientOnly = VS_AMBIENT || heroRatio < 0.4; setRunning(!hidden); }
    if (G.paused || G.ambientOnly) { keys.left = keys.right = keys.up = keys.down = false; G.holding = false; }
    storySync();
    musicSync();
  }
  document.addEventListener('visibilitychange', syncPause);
  /* ================= the cookie banner =================
     While the store's cookie banner is up (first visit), the story and the game wait, paused,
     so nothing plays behind it. They carry on the moment the visitor makes a choice. */
  var consentWait = false;
  function cookieBannerUp() {
    var el = document.getElementById('shopify-pc__banner');
    if (!el) return false;
    var r = el.getBoundingClientRect(), cs = getComputedStyle(el);
    return r.width > 0 && r.height > 0 && cs.display !== 'none' && cs.visibility !== 'hidden' && parseFloat(cs.opacity || '1') > 0.05;
  }
  function checkConsent() {
    if (VS_CABINET) return;   // no cookie banner on the arcade machine
    var up = cookieBannerUp();
    if (up !== consentWait) { consentWait = up; syncPause(); }
  }
  setInterval(checkConsent, 400);
  document.addEventListener('visitorConsentCollected', function () { setTimeout(checkConsent, 60); });
  if ('IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) { entries.forEach(function (en) { heroRatio = en.intersectionRatio; }); syncPause(); }, { threshold: [0, 0.2, 0.35, 0.4, 0.6, 0.8, 1] }).observe(hero);
  }

  /* ================= menu, options and level select ================= */
  var menu = document.createElement('div'), menuBtn = document.createElement('div');
  menu.hidden = true;
  function closeMenu() {}
  var sheet = $('optSheet'), optBtn = $('optBtn');
  sheet.hidden = true;
  function openOpts() { sheet.hidden = false; optBtn.setAttribute('aria-expanded', 'true'); $('optClose').focus(); }
  function closeOpts() { if (sheet.hidden) return; sheet.hidden = true; optBtn.setAttribute('aria-expanded', 'false'); optBtn.focus(); }
  optBtn.addEventListener('click', function () { sheet.hidden ? openOpts() : closeOpts(); });
  $('optClose').addEventListener('click', closeOpts);
  document.querySelectorAll('.seg[data-opt]').forEach(function (seg) {
    seg.addEventListener('click', function (e) {
      var b = e.target.closest('button'); if (!b) return;
      var k = seg.getAttribute('data-opt');
      settings[k] = b.getAttribute('data-v');
      applySettings();
      if (k === 'layout') window.scrollTo(0, 0);
      if (k === 'palette' || k === 'layout' || k === 'fx') requestAnimationFrame(function () { measure(); syncPause(); });
      if (k === 'fonts' && document.fonts) document.fonts.ready.then(function () { measure(); });
    });
  });
  $('replayBoot').addEventListener('click', function () { closeOpts(); window.scrollTo(0, 0); startBoot(true); });
  var jumpLevel = $('jumpLevel'), jumpPart = $('jumpPart');
  (function fillLevels() {
    for (var L = 1; L <= LAST_LEVEL; L++) {
      var o = document.createElement('option'); o.value = L;
      var cat = catFor(stormFor(L));
      o.textContent = 'Level ' + L + ': ' + zoneFor(L).toLowerCase().replace(/(^|\s)\w/g, function (c) { return c.toUpperCase(); }) + (isBossLevel(L) ? ' (boss: ' + BOSSES[bossIndexFor(L)].name.toLowerCase().replace(/(^|\s)\w/g, function (c) { return c.toUpperCase(); }) + ')' : '') + (cat ? ' CAT ' + cat : '');
      jumpLevel.appendChild(o);
    }
  })();
  function fillParts() {
    var L = Number(jumpLevel.value), opts = [['w1', 'Wave 1'], ['w2', 'Wave 2'], ['w3', 'Wave 3']];
    opts.push(['boss', 'Boss fight']); opts.push(L < LAST_LEVEL ? ['pier', 'Bonus round'] : ['treasure', 'Treasure ending']);
    jumpPart.innerHTML = '';
    opts.forEach(function (p) { var o = document.createElement('option'); o.value = p[0]; o.textContent = p[1]; jumpPart.appendChild(o); });
  }
  jumpLevel.addEventListener('change', fillParts);
  fillParts();
  function jump(L, part) {
    clearTimeout(clearedTimer);
    ovCleared.hidden = true; ovOver.hidden = true; document.body.classList.remove('ov-open');
    $('boot').hidden = true;
    hideStory();
    newGame();
    G.level = L; G.storm.target = stormFor(L); G.storm.cur = G.storm.target; G.storm.mul = 1;
    setScene(L - 1);
    G.enemies = []; G.boss = null;
    if (part === 'boss') startBossIntro();
    else if (part === 'pier') startPier();
    else if (part === 'treasure') { startBoss(); startTreasure(); }
    else { G.wave = Number(part.slice(1)) || 1; startWave(); }
  }
  $('jumpGo').addEventListener('click', function () { var L = Number(jumpLevel.value), part = jumpPart.value; closeOpts(); window.scrollTo(0, 0); jump(L, part); });

  /* ================= artist roster (placeholders) ================= */
  (function roster() {
    var box = $('roster');
    var face = '<svg viewBox="0 0 12 12" aria-hidden="true"><path fill="#3b2c63" d="M4 1h4v1h1v1h1v4H9v1H8v1H4V8H3V7H2V3h1V2h1z"/><path fill="#3b2c63" d="M1 12v-1h1v-1h2V9h4v1h2v1h1v1z"/><path fill="#8a7fb0" d="M5 4h1v1H5zM7 4h1v1H7zM5 6h3v1H5z"/></svg>';
    for (var i = 0; i < 5; i++) {
      var a = document.createElement('a');
      a.className = 'fighter'; a.href = 'https://vonstriga.com/pages/artists'; a.target = '_blank'; a.rel = 'noopener'; a.setAttribute('data-buzz', '');
      a.innerHTML = '<span class="p1" aria-hidden="true">P1</span><div class="portrait">' + face + '</div><div class="name">ARTIST NAME</div><div class="spec">Specialties</div>';
      box.appendChild(a);
    }
  })();
  renderBoard($('pageBoard'));

  /* ================= boot sequence ================= */
  var bootTimer = null, bootForce = false;
  function startBoot(force) {
    bootForce = !!force;
    hideStory();
    $('boot').hidden = false;
    G.state = 'boot';
    ovOver.hidden = true; ovCleared.hidden = true;
    document.body.classList.remove('ov-open');
    clearTimeout(bootTimer);
    bootTimer = setTimeout(endBoot, reduceMotion ? 700 : 2600);
  }
  function endBoot() {
    clearTimeout(bootTimer);
    var boot = $('boot');
    if (boot.hidden) return;
    boot.hidden = true;
    showTitle(bootForce);
  }
  $('boot').addEventListener('click', endBoot);
  $('boot').addEventListener('touchstart', endBoot, { passive: true });

  /* ================= TAP TO PLAY ================= */
  // The game never starts by itself. TAP TO PLAY (CLICK TO PLAY on a computer) starts the story,
  // once per visit, and then level 1. While a game is running the rest of the page is locked:
  // nothing outside the game can be selected or press-and-held (no iPhone zoom bubble), and the
  // first tap outside the game only pauses it. A tap or a scroll outside the game pauses it and
  // gives the page back; a tap on the game picks up where it left off.
  var tapPlay = $('tapPlay'), tapBtn = $('tapBtn'), tapTitle = $('tapTitle'), tapWarn = $('tapWarn'), titleForce = false;
  function showTap(title, full) {
    if (!tapPlay || !tapBtn) return;
    if (tapTitle) tapTitle.textContent = title;
    if (tapWarn) tapWarn.hidden = !full;
    tapBtn.textContent = VS_CABINET ? 'PRESS START' : touchSeen ? 'TAP TO PLAY' : 'CLICK TO PLAY';
    tapPlay.hidden = false;
  }
  function hideTap() { if (tapPlay) tapPlay.hidden = true; }
  function showTitle(force) {
    titleForce = !!force;
    hideStory();
    G.state = 'title'; G.enemies = []; G.eshots = []; G.boss = null; G.banner = null; G.loot = [];
    G.storm.target = 0;
    setScene(0);
    showTap('INK INVADERS', true);
    if (VS_CABINET) cabAttractReset();
  }
  function startPlay() { if (G.state !== 'title') return; if (VS_CABINET) { cabinetStartGame(); return; } soundForPlay(); musicRestart(); hideTap(); startStory(titleForce); }
  // TAP TO PLAY turns the sound on (music and effects), unless this visitor muted it before
  function soundForPlay() { if (!settings.sound && !settings.mute) { settings.sound = true; applySettings(); } audio(); }
  function pausedByUser() { return G.state === 'play' && G.userPaused; }
  var scrollGuardUntil = 0, swallowUntil = 0, playScrollY = 0;
  function resumePlay() {
    if (!pausedByUser()) return;
    if (heroRatio < 0.9 && window.scrollY > 0) { scrollGuardUntil = Date.now() + 1200; window.scrollTo(0, 0); }
    togglePause();
  }
  function inGame(el) { return !!(el && el.closest && el.closest('#hero, #ovOver, #boot, #optBtn, #optSheet')); }   // the prototype's options count as part of the game
  function leaveForPage() { if (!canPlay()) return false; G.holding = false; if (!G.userPaused) togglePause(); return true; }
  function outsidePress(e) { if (inGame(e.target)) return; if (leaveForPage()) swallowUntil = Date.now() + 900; }
  document.addEventListener('touchstart', outsidePress, { capture: true, passive: true });
  document.addEventListener('mousedown', function (e) { if (!touchSeen) outsidePress(e); }, true);
  document.addEventListener('click', function (e) { if (Date.now() < swallowUntil && !inGame(e.target)) { swallowUntil = 0; e.preventDefault(); e.stopPropagation(); } }, true);
  window.addEventListener('wheel', function (e) { if (!inGame(e.target)) leaveForPage(); }, { passive: true });
  window.addEventListener('scroll', function () {
    if (Date.now() < scrollGuardUntil) { playScrollY = window.scrollY; return; }
    if (canPlay() && Math.abs(window.scrollY - playScrollY) > 30) leaveForPage();
  }, { passive: true });

  /* ================= the story crawl ================= */
  // Once per visit, after the start-up screen: the story rises out of the water and rolls
  // off into the distance over the Galveston sky, then the game starts. It is drawn line by
  // line on its own canvas (no browser 3D), centered. A tap, click or Enter starts the game,
  // SKIP too. Reduced motion gets the same words standing still. The words live in the page
  // (#crawlText) so screen readers have them.
  var ovStory = $('ovStory'), crawlWrap = $('crawlWrap'), crawlText = $('crawlText'), crawlIntro = $('crawlIntro'),
    crawlHint = crawlWrap.querySelector('.crawl-hint'), storySkip = $('storySkip'), crawlCanvas = $('crawlCanvas'), cctx = crawlCanvas.getContext('2d');
  var storyTimers = [], crawl = null;
  var STORY_STORM = 1.4;      // clouds and light rain roll in while the story plays
  var CRAWL_SPEED = 1.7;      // lines per second
  var CRAWL_END_S = 0.36;     // the story is over once its last line has shrunk to this size
  function storyLater(fn, ms) { storyTimers.push(setTimeout(fn, ms)); }
  function storyStop() {
    storyTimers.forEach(clearTimeout); storyTimers = [];
    crawl = null;
    cctx.setTransform(1, 0, 0, 1, 0, 0); cctx.clearRect(0, 0, crawlCanvas.width, crawlCanvas.height);
    crawlIntro.classList.remove('show');
    ovStory.classList.remove('flash');
  }
  function hideStory() { storyStop(); ovStory.hidden = true; document.body.classList.remove('story-open'); }
  function storySeen() { try { return sessionStorage.getItem('inkinv.story') === '1'; } catch (e) { return false; } }
  function markStorySeen() { try { sessionStorage.setItem('inkinv.story', '1'); } catch (e) {} }
  function storyBolt() {
    var x = W * (0.3 + Math.random() * 0.4), y = 0, pts = [];
    while (y < HORIZON) { pts.push(x, y); y += 6 + Math.random() * 8; x += (Math.random() * 2 - 1) * 6; }
    pts.push(x, HORIZON);
    G.storm.bolt = { pts: pts, t: 0.25, strike: false };
    G.skyFlash = 0.3;
    SFX.thunder(0.4);
    ovStory.classList.remove('flash'); void ovStory.offsetWidth; ovStory.classList.add('flash');
  }
  function startStory(force) {
    if (!force && storySeen()) { newGame(); return; }
    markStorySeen();
    storyStop();
    G.state = 'story';
    if (!reduceMotion) G.storm.target = STORY_STORM;   // no story lightning when the device asks for less motion
    ovStory.hidden = false; storySkip.hidden = false; crawlIntro.hidden = false;
    crawlWrap.scrollTop = 0;
    document.body.classList.add('ov-open', 'story-open');
    crawlHint.textContent = VS_CABINET ? 'PRESS START' : touchSeen ? 'TAP TO START' : 'CLICK OR PRESS ENTER TO START';
    if (reduceMotion) { crawlWrap.classList.add('flat'); return; }
    crawlWrap.classList.remove('flat');
    crawlIntro.classList.add('show');
    storyLater(runCrawl, 3000);
  }
  // where the story comes out of the water: a little above the shoreline, measured on the game canvas
  function crawlGeom() {
    var cw = crawlWrap.clientWidth, ch = crawlWrap.clientHeight;
    var wr = crawlWrap.getBoundingClientRect(), gr = canvas.getBoundingClientRect();
    var horizonY = gr.top - wr.top + HORIZON * SCALE, shoreY = gr.top - wr.top + SAND * SCALE;
    var base = clamp(shoreY - (shoreY - horizonY) * 0.22, ch * 0.5, ch - 6);
    var vanish = -ch * 0.15;   // the vanishing point sits just above the top, so lines stay readable most of the way up
    return { cw: cw, ch: ch, base: base, vanish: vanish, depth: (base - vanish), horizonY: horizonY, shoreY: shoreY };
  }
  function crawlLayout(cw) {
    var F = clamp(Math.round(cw * 0.088), 28, 46), L = Math.round(F * 1.45), gap = Math.round(F * 0.95);   // big, well spaced lines that are easy to read
    var fam = getComputedStyle(crawlText).fontFamily;
    var gold = getComputedStyle(document.documentElement).getPropertyValue('--accent').trim() || '#ffd166';
    var maxW = Math.min(cw - 36, F * 15);
    cctx.setTransform(1, 0, 0, 1, 0, 0);
    cctx.font = F + 'px ' + fam;
    var lines = [], pos = 0;
    [].forEach.call(crawlText.querySelectorAll('p'), function (p, i) {
      if (i) pos += gap;
      var col = p.classList.contains('crawl-last') ? '#ffffff' : gold, line = '';
      p.textContent.trim().split(/\s+/).forEach(function (w) {
        var t = line ? line + ' ' + w : w;
        if (line && cctx.measureText(t).width > maxW) { lines.push({ txt: line, pos: pos, c: col }); pos += L; line = w; }
        else line = t;
      });
      if (line) { lines.push({ txt: line, pos: pos, c: col }); pos += L; }
    });
    return { F: F, L: L, fam: fam, lines: lines, total: pos, cw: cw };
  }
  function runCrawl() {
    if (G.state !== 'story') return;
    var g = crawlGeom(), lay = crawlLayout(g.cw);
    var speed = lay.L * CRAWL_SPEED;
    var endU = g.depth * (1 / CRAWL_END_S - 1);                 // how far the last line travels before the story is over
    var dur = (lay.F + lay.lines[lay.lines.length - 1].pos + endU) / speed;
    crawl = { t: 0, dur: dur, speed: speed, lay: lay, paused: false, fade: 0, playState: 'running', last: 0 };
    crawlIntro.hidden = true;   // its fade is done; take it off the screen
    storyBolt();
    storySync();
    requestAnimationFrame(crawlTick);
  }
  function crawlTick(now) {
    var c = crawl;
    if (!c) return;
    var dt = c.last ? Math.min(0.1, (now - c.last) / 1000) : 0;
    c.last = now;
    if (!c.paused) {
      c.t += dt;
      if (c.t >= c.dur) c.fade += dt / 0.8;
    }
    drawCrawl();
    if (c.fade >= 1) { startFromStory(); return; }
    requestAnimationFrame(crawlTick);
  }
  function drawCrawl() {
    var c = crawl;
    if (!c) return;
    var g = crawlGeom(), dpr = clamp(Math.round(window.devicePixelRatio || 1), 1, 3);
    if (g.cw !== c.lay.cw) { var keepT = c.t; c.lay = crawlLayout(g.cw); c.speed = c.lay.L * CRAWL_SPEED; c.t = keepT; }
    var pw = Math.round(g.cw * dpr), ph = Math.round(g.ch * dpr);
    if (crawlCanvas.width !== pw || crawlCanvas.height !== ph) { crawlCanvas.width = pw; crawlCanvas.height = ph; }
    cctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    cctx.clearRect(0, 0, g.cw, g.ch);
    cctx.save();
    cctx.beginPath(); cctx.rect(0, 0, g.cw, g.base); cctx.clip();   // nothing shows below the waterline
    cctx.textAlign = 'center'; cctx.textBaseline = 'alphabetic';
    var F = c.lay.F, u0 = c.t * c.speed - F, outFade = 1 - clamp(c.fade, 0, 1);
    for (var i = 0; i < c.lay.lines.length; i++) {
      var ln = c.lay.lines[i], u = u0 - ln.pos, s, y;
      if (u < -F) continue;                           // still under the water
      if (u <= 0) { s = 1; y = g.base - u; }           // rising out of the water
      else { s = g.depth / (g.depth + u); y = g.vanish + (g.base - g.vanish) * s; }   // rolling off into the distance
      var a = clamp((s - 0.1) / 0.18, 0, 1) * outFade;
      if (u < F * 0.6) a *= clamp(0.45 + 0.55 * (u + F) / (F * 1.6), 0, 1);   // a touch darker while it surfaces
      if (a <= 0.01) continue;
      cctx.globalAlpha = a;
      cctx.fillStyle = ln.c;
      cctx.font = (F * s).toFixed(2) + 'px ' + c.lay.fam;
      cctx.fillText(ln.txt, g.cw / 2, y);
    }
    cctx.restore();
  }
  function startFromStory() {
    if (G.state !== 'story') return;
    if (VS_CABINET && attractStory) { attractStory = false; hideStory(); document.body.classList.remove('ov-open'); showTitle(false); return; }
    hideStory();
    document.body.classList.remove('ov-open');
    var cur = G.storm.cur;
    newGame();
    G.storm.cur = Math.max(G.storm.cur, cur);   // the story clouds clear away as level 1 starts
  }
  function storyNext() { startFromStory(); }
  function storySync() {
    if (!crawl) return;
    var away = document.hidden || G.ambientOnly || heroRatio === 0 || helpOpen || consentWait;
    crawl.paused = !!away;
    crawl.playState = away ? 'paused' : 'running';
    if (!away) crawl.last = 0;
  }
  crawlWrap.addEventListener('click', function () { if (G.state === 'story') startFromStory(); });
  storySkip.addEventListener('click', startFromStory);

  /* ================= HOW TO PLAY: the slider on the right ================= */
  // A tab on the right edge of the game opens the instructions; the game waits while it is open.
  var helpTab = $('helpTab'), helpDrawer = $('helpDrawer'), helpClose = $('helpClose'), helpOpen = false;
  function fillHowTo() {
    var t = touchSeen;
    var rows = [
      ['SHOOT', t ? 'Hold your finger on the game.' : 'Hold the mouse button or the Space bar.'],
      ['MOVE', t ? 'Drag your finger to fly anywhere: up, down and side to side.' : 'Move the mouse, or use the arrow keys, to fly anywhere.'],
      ['FIX THE INK', 'Each bad tattoo takes 3 hits. It gets brighter, then clean, then it is saved.', true],
      ['WATCH OUT', 'Flying into an invader or a boss costs a life.'],
      ['POWER UPS', 'Fly into the capsules that fall.'],
      ['BOMBS', 'Bombs wait in your bag on the left. ' + (t ? 'Tap one to set it off.' : 'Click one, or press B.')],
      ['THE ISLAND', '8 levels across Galveston, 3 waves and a boss in each. The hurricane gets worse as you go. Make it to Von Striga!'],
      ['PAUSE', (t ? 'Tap' : 'Click') + ' or scroll outside the game to pause it and use the page. ' + (t ? 'Tap' : 'Click') + ' the game to keep playing.']
    ];
    var ul = $('howTo');
    ul.textContent = '';
    rows.forEach(function (r) {
      var li = document.createElement('li'), b = document.createElement('b'), sp = document.createElement('span');
      b.textContent = r[0]; sp.textContent = r[1];
      var rose = SPRITES.rose;
      if (r[2] && artReady && rose && rose.mid) {
        var row = document.createElement('span');
        row.className = 'stages'; row.setAttribute('aria-hidden', 'true');
        [rose.bad[0], rose.mid[0], rose.clean[0]].forEach(function (src, i) {
          if (i) { var a = document.createElement('i'); a.textContent = '>'; row.appendChild(a); }
          var c = document.createElement('canvas'); c.width = src.width; c.height = src.height;
          c.getContext('2d').drawImage(src, 0, 0);
          row.appendChild(c);
        });
        sp.appendChild(row);
      }
      li.appendChild(b); li.appendChild(sp); ul.appendChild(li);
    });
  }
  function openHelp() {
    fillHowTo();
    helpDrawer.hidden = false; helpOpen = true;
    document.body.classList.add('help-open');
    helpTab.setAttribute('aria-expanded', 'true');
    G.holding = false;
    syncPause();
    try { helpClose.focus({ preventScroll: true }); } catch (e) {}
  }
  function closeHelp() {
    if (!helpOpen) return;
    helpDrawer.hidden = true; helpOpen = false;
    document.body.classList.remove('help-open');
    helpTab.setAttribute('aria-expanded', 'false');
    syncPause();
    try { helpTab.focus({ preventScroll: true }); } catch (e) {}
  }
  helpTab.addEventListener('click', function () { if (helpOpen) closeHelp(); else openHelp(); });
  helpClose.addEventListener('click', closeHelp);
  hero.addEventListener('click', function (e) {
    if (volOpen) { if (!(e.target.closest && e.target.closest('.vol-panel, #volBtn'))) volShow(false); return; }
    if (helpOpen) { if (!(e.target.closest && e.target.closest('.help-drawer, .help-tab'))) closeHelp(); return; }
    var onTap = !isUi(e.target) || !!(e.target.closest && e.target.closest('#tapBtn'));
    if (G.state === 'title' && onTap) { startPlay(); return; }
    if (pausedByUser() && onTap) { resumePlay(); return; }
    if (G.state === 'over' && ovOver.hidden && !isUi(e.target)) { musicRestart(); newGame(); }   // after the X: a tap on the game plays again
  });

  /* ================= the arcade machine in the shop =================
     /pages/arcade on the arcade machine (VS_GAME.mode 'cabinet'): a USB joystick and buttons,
     a tall screen, Chrome in kiosk mode. It opens on the logo, then the start screen with the
     theme on a loop, switching between the title, the shared top 10 and the story.
     START (or FIRE) plays and the theme starts over. The joystick picks the initials. After a
     game it goes back to the start screen by itself. The controls are learned once on a setup
     screen (it opens by itself the first time; or hold SPECIAL for 5 seconds on the start
     screen), where the music and effects volumes are set too. */
  var attractStory = false;
  var CAB = { phase: 'title', phaseT: 0, overT: 0, idleT: 0, pausedT: 0, map: null, setup: null, prev: {}, hold: 0, rep: {}, savedSeen: false, started: Date.now() };
  var DIRS8 = [[0, -1], [1, -1], [1, 0], [1, 1], [0, 1], [-1, 1], [-1, 0], [-1, -1]];
  function padMap() {
    if (CAB.map) return CAB.map;
    var m = load('padmap');
    if (m && typeof m === 'object' && typeof m.fire === 'number' && typeof m.special === 'number' && typeof m.start === 'number' && m.dir && typeof m.dir.kind === 'string') CAB.map = m;
    return CAB.map;
  }
  function firstPad() {
    var pads = null;
    try { pads = navigator.getGamepads ? navigator.getGamepads() : null; } catch (e) {}
    if (!pads) return null;
    for (var i = 0; i < pads.length; i++) if (pads[i] && pads[i].connected !== false) return pads[i];
    return null;
  }
  function padBtn(gp, i) { var b = gp && gp.buttons && gp.buttons[i]; return !!(b && (b.pressed || b.value > 0.5)); }
  // a hat switch reports one axis: -1 is up, then each eighth of a turn clockwise; centered is outside -1 to 1
  function hatDir(v, off) {
    if (typeof v !== 'number' || v < -1.05 || v > 1.05) return null;
    var i = Math.round((v + 1) / (2 / 7));
    return DIRS8[((i - (off || 0)) % 8 + 8) % 8];
  }
  function axisLive(v) { var a = Math.abs(v || 0); return a > 0.5 && a <= 1.05; }
  function readPad() {
    var gp = firstPad();
    if (!gp) return null;
    var m = padMap(), ax = gp.axes || [], dx = 0, dy = 0, d;
    if (m && m.dir.kind === 'axes') { dx = (ax[m.dir.x] || 0) * m.dir.xs; dy = (ax[m.dir.y] || 0) * m.dir.ys; }
    else if (m && m.dir.kind === 'hat') { d = hatDir(ax[m.dir.axis], m.dir.off); if (d) { dx = d[0]; dy = d[1]; } }
    else if (m && m.dir.kind === 'dpad') { dx = (padBtn(gp, 15) ? 1 : 0) - (padBtn(gp, 14) ? 1 : 0); dy = (padBtn(gp, 13) ? 1 : 0) - (padBtn(gp, 12) ? 1 : 0); }
    else {
      // not set up yet: the usual ways a USB arcade board reports its stick
      if (axisLive(ax[0])) dx = ax[0];
      if (axisLive(ax[1])) dy = ax[1];
      if (gp.buttons && gp.buttons.length > 15) { if (padBtn(gp, 14)) dx = -1; if (padBtn(gp, 15)) dx = 1; if (padBtn(gp, 12)) dy = -1; if (padBtn(gp, 13)) dy = 1; }
      d = hatDir(ax[9], 0); if (d && !dx && !dy) { dx = d[0]; dy = d[1]; }
    }
    return { gp: gp, left: dx < -0.5, right: dx > 0.5, up: dy < -0.5, down: dy > 0.5,
      fire: padBtn(gp, m ? m.fire : 0), special: padBtn(gp, m ? m.special : 1), start: padBtn(gp, m ? m.start : 9) };
  }
  function padAny(gp) {
    if (!gp) return false;
    for (var i = 0; i < (gp.buttons || []).length; i++) if (padBtn(gp, i)) return true;
    var ax = gp.axes || [];
    for (var j = 0; j < ax.length; j++) if (axisLive(ax[j])) return true;
    return false;
  }
  // held joystick: one step at once, then repeats
  function repeatPress(k, on, dt) {
    var r = CAB.rep[k] || (CAB.rep[k] = { t: 0, held: false });
    if (!on) { r.held = false; r.t = 0; return false; }
    if (!r.held) { r.held = true; r.t = 0.35; return true; }
    r.t -= dt;
    if (r.t <= 0) { r.t = 0.11; return true; }
    return false;
  }

  /* the setup screen: the buttons, the joystick, then the two volumes */
  var SETUP_STEPS = ['fire', 'special', 'start', 'up', 'left', 'music', 'sfx', 'done'];
  var SETUP_TEXT = {
    fire: ['PRESS THE FIRE BUTTON', 'The button that shoots.'],
    special: ['PRESS THE SPECIAL BUTTON', 'The button that sets off bombs.'],
    start: ['PRESS THE START BUTTON', 'The 1 PLAYER button.'],
    up: ['PUSH THE JOYSTICK UP', 'Then let it go.'],
    left: ['PUSH THE JOYSTICK LEFT', 'Then let it go.'],
    music: ['MUSIC VOLUME', 'Joystick left and right. FIRE when it sounds right.'],
    sfx: ['EFFECTS VOLUME', 'Joystick left and right. FIRE when it sounds right.'],
    done: ['ALL SET!', 'To do this again, hold SPECIAL for 5 seconds on the start screen.']
  };
  function setupShow() {
    var s = CAB.setup, k = SETUP_STEPS[s.step], tx = SETUP_TEXT[k];
    $('padStep').textContent = tx[0];
    $('padHint').textContent = tx[1];
    $('padCount').textContent = s.step < SETUP_STEPS.length - 1 ? 'STEP ' + (s.step + 1) + ' OF ' + (SETUP_STEPS.length - 1) : '';
    var vol = k === 'music' || k === 'sfx';
    $('padVol').hidden = !vol;
    if (vol) {
      var pct = Math.round(settings[k === 'music' ? 'musicVol' : 'sfxVol'] * 100);
      $('padVolFill').style.width = pct + '%';
      $('padVolPct').textContent = pct + '%';
    }
  }
  function openSetup() {
    if (CAB.setup) return;
    CAB.setup = { step: 0, map: { dir: null }, base: [], wait: true, t: 0, firePrev: true };
    attractStory = false; hideStory(); hideTap();
    $('attractBoard').hidden = true;
    $('padSetup').hidden = false;
    document.body.classList.add('ov-open');
    setupShow();
  }
  function setupNext() {
    var s = CAB.setup;
    s.step++; s.wait = true; s.t = 0; s.firePrev = true;
    CAB.rep = {};
    if (SETUP_STEPS[s.step] === 'music') { CAB.map = s.map; store('padmap', s.map); musicStart(); }
    SFX.tick();
    setupShow();
  }
  function closeSetup() {
    CAB.setup = null;
    $('padSetup').hidden = true;
    document.body.classList.remove('ov-open');
    var p = readPad();
    CAB.prev = p ? { fire: p.fire, special: p.special, start: p.start, up: p.up, down: p.down, left: p.left, right: p.right } : {};
    showTitle(false);
  }
  function setupTick(p, dt) {
    var s = CAB.setup, k = SETUP_STEPS[s.step], gp = p ? p.gp : null;
    if (k === 'done') { s.t += dt; if (s.t > 2.5) closeSetup(); return; }
    if (!gp) return;
    if (s.wait) { if (!padAny(gp)) { s.wait = false; s.base = (gp.axes || []).slice(); } return; }
    var i;
    if (k === 'fire' || k === 'special' || k === 'start') {
      for (i = 0; i < (gp.buttons || []).length; i++) {
        if (gp.mapping === 'standard' && i >= 12 && i <= 15) continue;   // a standard pad's d-pad is the joystick
        if (padBtn(gp, i) && [s.map.fire, s.map.special, s.map.start].indexOf(i) === -1) { s.map[k] = i; setupNext(); return; }
      }
      return;
    }
    var ax = gp.axes || [], best = -1, bestD = 0, dlt;
    if (k === 'up') {
      if ((gp.buttons || []).length > 15 && padBtn(gp, 12)) { s.map.dir = { kind: 'dpad' }; setupNext(); return; }
      for (i = 0; i < ax.length; i++) { dlt = Math.abs((ax[i] || 0) - (s.base[i] || 0)); if (dlt > 0.6 && dlt > bestD) { best = i; bestD = dlt; } }
      if (best < 0) return;
      var b0 = s.base[best] || 0, v = ax[best];
      if (Math.abs(b0) > 1.05 && Math.abs(v) <= 1.05) s.map.dir = { kind: 'hat', axis: best, off: ((Math.round((v + 1) / (2 / 7)) % 8) + 8) % 8 };
      else s.map.dir = { kind: 'axes', y: best, ys: v - b0 < 0 ? 1 : -1, x: best === 0 ? 1 : 0, xs: 1 };
      setupNext(); return;
    }
    if (k === 'left') {
      if (s.map.dir.kind !== 'axes') { if (padAny(gp)) setupNext(); return; }
      for (i = 0; i < ax.length; i++) { if (i === s.map.dir.y) continue; dlt = Math.abs((ax[i] || 0) - (s.base[i] || 0)); if (dlt > 0.6 && dlt > bestD) { best = i; bestD = dlt; } }
      if (best < 0) return;
      s.map.dir.x = best; s.map.dir.xs = (ax[best] - (s.base[best] || 0)) < 0 ? 1 : -1;
      setupNext(); return;
    }
    if (k === 'music' || k === 'sfx') {
      var key = k === 'music' ? 'musicVol' : 'sfxVol', ch = 0;
      if (repeatPress('vl', p.left, dt)) ch = -0.05;
      if (repeatPress('vr', p.right, dt)) ch = 0.05;
      if (ch) {
        settings[key] = clamp(Math.round((settings[key] + ch) * 20) / 20, 0, 1);
        applySettings();
        if (k === 'sfx') SFX.shot();
        setupShow();
      }
      if (p.fire && !s.firePrev) { store('settings', settings); setupNext(); return; }
      s.firePrev = p.fire;
    }
  }

  /* playing with the joystick and buttons */
  function stepLetter(d) {
    var n = CHARS_IN.indexOf(initials[activeSlot]);
    initials[activeSlot] = CHARS_IN[(n + d + CHARS_IN.length) % CHARS_IN.length];
    SFX.tick(); renderInitials();
  }
  function moveSlot(d) { activeSlot = clamp(activeSlot + d, 0, 2); SFX.tick(); renderInitials(); }
  function cabinetStartGame() {
    attractStory = false;
    $('attractBoard').hidden = true;
    if (G.state === 'story') hideStory();
    hideTap();
    ovOver.hidden = true; ovCleared.hidden = true;
    document.body.classList.remove('ov-open', 'story-open');
    CAB.idleT = 0; CAB.overT = 0; CAB.savedSeen = false;
    audio();
    musicRestart();
    newGame();
  }
  function backToAttract() {
    ovOver.hidden = true; ovCleared.hidden = true;
    document.body.classList.remove('ov-open');
    clearTimeout(clearedTimer);
    if (G.userPaused) togglePause();
    keys.left = keys.right = keys.up = keys.down = false; G.holding = false;
    showTitle(false);
  }
  function padTick(dt) {
    var p = readPad();
    if (CAB.setup) { setupTick(p, dt); return; }
    if (!p) { CAB.prev = {}; return; }
    var now = { fire: p.fire, special: p.special, start: p.start, up: p.up, down: p.down, left: p.left, right: p.right }, prev = CAB.prev;
    CAB.prev = now;
    var hit = function (k) { return now[k] && !prev[k]; };
    if (now.fire || now.special || now.start || now.up || now.down || now.left || now.right) CAB.idleT = 0;
    if (!padMap()) { if (G.state === 'title') openSetup(); return; }
    if (!$('boot').hidden) { if (hit('start') || hit('fire')) endBoot(); return; }
    if (G.state === 'title') {
      if (hit('start') || hit('fire')) { cabinetStartGame(); return; }
      if (now.special) { CAB.hold += dt; if (CAB.hold >= 5) { CAB.hold = 0; openSetup(); } } else CAB.hold = 0;
      return;
    }
    if (G.state === 'story') { if (hit('start') || hit('fire')) cabinetStartGame(); return; }
    if (G.state === 'cleared') { if (hit('start') || hit('fire')) nextLevel(); return; }
    if (G.state === 'over') {
      var entering = !ovOver.hidden && !$('enterBlock').hidden && !G.saved;
      if (entering) {
        if (repeatPress('lu', now.up, dt)) stepLetter(1);
        if (repeatPress('ld', now.down, dt)) stepLetter(-1);
        if (hit('left')) moveSlot(-1);
        if (hit('right')) moveSlot(1);
        if (hit('fire')) { if (activeSlot < 2) moveSlot(1); else saveScore(); }
        if (hit('start')) saveScore();
        return;
      }
      if (CAB.overT > 1.5 && (hit('start') || hit('fire'))) cabinetStartGame();
      return;
    }
    if (G.state !== 'play') return;
    if (hit('start')) { togglePause(); return; }
    if (G.userPaused) return;
    keys.left = now.left; keys.right = now.right; keys.up = now.up; keys.down = now.down;
    if (now.left || now.right) { mouseTarget = null; G.steered = true; }
    if (now.up || now.down) { mouseTargetY = null; G.steered = true; }
    if (now.fire) { if (!G.holding) pressFire(); }
    else if (prev.fire) G.holding = false;
    if (hit('special')) useBomb(0);
  }

  /* the start screen: title, then the top 10, then the story, round and round */
  function cabAttractReset() {
    CAB.phase = 'title'; CAB.phaseT = 0; CAB.hold = 0;
    $('attractBoard').hidden = true;
    if (!musicOn) musicStart();
  }
  function attractTick(dt) {
    CAB.phaseT += dt;
    if (CAB.phase === 'title' && CAB.phaseT > 15) {
      CAB.phase = 'scores'; CAB.phaseT = 0;
      fetchBoard();
      renderBoard($('attractScores'));
      hideTap();
      $('attractBoard').hidden = false;
    } else if (CAB.phase === 'scores' && CAB.phaseT > 12) {
      $('attractBoard').hidden = true;
      CAB.phase = 'story'; CAB.phaseT = 0;
      attractStory = true;
      startStory(true);
    }
  }
  function cabTick(dt) {
    CAB.idleT += dt;
    if (G.state === 'over') {
      CAB.overT += dt;
      if (G.saved && !CAB.savedSeen) { CAB.savedSeen = true; CAB.overT = 0; }
      var entering = !ovOver.hidden && !$('enterBlock').hidden && !G.saved;
      if (entering) {
        // walked away while entering initials: save them if they were picked, then the board
        if (CAB.idleT > 60) {
          if (initials.join('') !== 'AAA') saveScore();
          else { $('enterBlock').hidden = true; $('boardBlock').hidden = false; renderBoard($('overBoard')); CAB.savedSeen = true; CAB.overT = 0; }
        }
      } else if (CAB.overT > 25) backToAttract();
    } else { CAB.overT = 0; CAB.savedSeen = false; }
    if (G.state === 'play' && G.userPaused) { CAB.pausedT += dt; if (CAB.pausedT > 60) backToAttract(); } else CAB.pausedT = 0;
    if (G.state === 'title' && !CAB.setup) attractTick(dt);
  }

  /* the QR code after a game: scan it to share the score on Facebook */
  function cabinetQr() {
    var cv = $('qrCanvas'), box = $('qrBlock');
    if (!cv.getContext || typeof window.qrcode !== 'function') { box.hidden = true; return; }
    var url = 'https://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent(G.shareUrl || 'https://vonstriga.com/') + '&hashtag=%23VonStriga';
    try {
      var q = window.qrcode(0, 'M');
      q.addData(url);
      q.make();
      var n = q.getModuleCount(), quiet = 4, px = Math.max(3, Math.floor(260 / (n + quiet * 2))), size = px * (n + quiet * 2);
      cv.width = size; cv.height = size;
      var c = cv.getContext('2d');
      c.fillStyle = '#ffffff'; c.fillRect(0, 0, size, size);
      c.fillStyle = '#000000';
      for (var r = 0; r < n; r++) for (var k = 0; k < n; k++) if (q.isDark(r, k)) c.fillRect((k + quiet) * px, (r + quiet) * px, px, px);
      cv.setAttribute('data-url', url);
      box.hidden = false;
    } catch (e) { box.hidden = true; }
  }

  function cabWake() { try { if (navigator.wakeLock && !document.hidden) navigator.wakeLock.request('screen').catch(function () {}); } catch (e) {} }
  function cabinetInit() {
    document.documentElement.classList.add('cabinet');
    settings.sound = true; settings.mute = false; settings.buzz = false;
    applySettings();
    audio();
    startBoot(true);
    var lastTs = 0;
    function cabLoop(ts) {
      requestAnimationFrame(cabLoop);
      var dt = lastTs ? Math.min(0.1, (ts - lastTs) / 1000) : 0;
      lastTs = ts;
      padTick(dt);
      cabTick(dt);
    }
    requestAnimationFrame(cabLoop);
    document.addEventListener('contextmenu', function (e) { e.preventDefault(); });
    cabWake();
    document.addEventListener('visibilitychange', cabWake);
    // a fresh start every night at 4 AM, only while nobody is playing
    setInterval(function () { if (new Date().getHours() === 4 && G.state === 'title' && Date.now() - CAB.started > 3600000) location.reload(); }, 60000);
    // the shared board stays current while the machine waits
    setInterval(function () { if (G.state === 'title' || G.state === 'over') fetchBoard(); }, 120000);
  }

  /* ================= start ================= */
  window.addEventListener('resize', function () { clearTimeout(window.__rz); window.__rz = setTimeout(measure, 120); });
  applySettings();
  measure();
  loadLogo();
  G.ship.x = W / 2;
  G.ship.y = SHIP_Y;
  function bootSeen() { try { return sessionStorage.getItem('inkinv.boot') === '1'; } catch (e) { return false; } }
  function markBootSeen() { try { sessionStorage.setItem('inkinv.boot', '1'); } catch (e) {} }
  if (VS_AMBIENT) { $('boot').hidden = true; G.state = 'idle'; G.ambientOnly = true; setScene(6); }
  else if (VS_CABINET) cabinetInit();
  else if (bootSeen()) { $('boot').hidden = true; showTitle(false); }
  else { markBootSeen(); startBoot(); }
  // CK's art is inside this file, so it loads in a moment; the loop waits for it
  var artReady = false;
  loadArt(function (err) { if (err) return; findTip(); artReady = true; });
  requestAnimationFrame(frame);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(measure);

  // test hook for automated checks: only on a test address (?inktest)
  if (/[?&]inktest\b/.test(location.search)) window.InkInvaders = { G: G, settings: settings, fire: fire, newGame: newGame, endBoot: endBoot, killShip: killShip, collect: collect, spawnCap: spawnCap, jump: jump, startBossIntro: startBossIntro, bossBoxes: bossBoxes, bossDamage: bossDamage,
    waveConfig: waveConfig, stormFor: stormFor, catFor: catFor, useBomb: useBomb, sprites: SPRITES,
    skipStory: function () { if (G.state === 'title') startPlay(); startFromStory(); },
    showTitle: showTitle, startPlay: startPlay, resumePlay: resumePlay, leaveForPage: leaveForPage, setScene: setScene, scene: function () { return SCENES[sceneN]; },
    startTreasure: startTreasure, startBoss: startBoss, effLevel: effLevel, bossIndexFor: bossIndexFor, zoneFor: zoneFor,
    layers: function () { return { scene: SCENES[sceneN], water: SCENE_WATER[sceneN], surf: SCENE_SURF[sceneN], palms: SCENE_PALMS[sceneN], front: hasFront, horizon: HORIZON }; }, storyAdvance: function () { if (crawl) { crawl.t = crawl.dur; crawl.fade = 1; } else storyNext(); },
    freeze: function (on) { testFrozen = !!on; }, crawl: function () { return crawl; }, wireY: function (x) { return wireY(x); }, crawlGeom: crawlGeom, crawlSeek: function (f) { if (!crawl) return; crawl.t = crawl.dur * f; crawl.paused = true; crawl.playState = 'paused'; drawCrawl(); }, crawlPlay: function () { if (crawl) { crawl.paused = false; crawl.playState = 'running'; crawl.last = 0; } }, openHelp: openHelp, closeHelp: closeHelp,
    ready: function () { return artReady; },
    advance: function (sec) { var n = Math.round(sec * 60); for (var i = 0; i < n; i++) update(STEP); draw(); },
    music: function () { return { el: !!musicEl, on: musicOn, paused: musicEl ? musicEl.paused : true, t: musicEl ? musicEl.currentTime : 0, gain: musicGain ? musicGain.gain.value : (musicEl ? musicEl.volume : null), src: MUSIC_SRC }; },
    sfx: SFX, cab: CAB, initials: function () { return { letters: initials.join(''), slot: activeSlot }; }, padMap: padMap, cabinetQr: cabinetQr, volShow: volShow,
    life: function () { return LIFE; },
    cloudMode: function () { return cloudMode; }, size: function () { return { W: W, H: H, SCALE: SCALE, SHIP_Y: SHIP_Y, SHIP_TOP: SHIP_TOP, HORIZON: HORIZON, SAND: SAND }; } };

})();
